export default {
  'exportTime':'ExportTime',
  'uploadtime':'Uploadtime',
  'createtime':'Createtime',
  'filename': 'Filename',
  'MOS温度': 'MOS temperature',
  '充电MOS': 'Charging MOS',
  '放电MOS': 'Discharge MOS',
  '叉车':'forklift truck',
  '无从机系统':'No machine system',
  "总体高压1": "Overall high pressure 1",
  "总体高压2": "Overall high pressure 2",
  "总体高压3": "Overall high pressure 3",
  "总体低压1": "Overall low pressure 1",
  "总体低压2": "Overall low pressure 2",
  "总体低压3": "Overall low pressure 3",
  "充电过流2~3": "Charging overcurrent 2-3",
  "放电过流2~3": "Discharge overcurrent 2-3",
  "快充口高温1": "Fast charging port high temperature 1",
  "快充口高温2": "Fast charging port high temperature 2",
  "快充口高温3": "Fast charging port high temperature 3",
  "慢充电口高温1": "Slow charging port high temperature 1",
  "慢充电口高温2": "Slow charging port high temperature 2",
  "慢充电口高温3": "Slow charging port high temperature 3",
  "放电口高温1": "Discharge port high temperature 1",
  "放电口高温2": "Discharge port high temperature 2",
  "放电口高温3": "Discharge port high temperature 3",
  "正极端子高温1": "Positive terminal high temperature 1",
  "正极端子高温2": "Positive terminal high temperature 2",
  "正极端子高温3": "Positive terminal high temperature 3",
  "负极端子高温1": "Negative terminal high temperature 1",
  "负极端子高温2": "Negative terminal high temperature 2",
  "负极端子高温3": "Negative terminal high temperature 3",
  "Ntc采样异常1": "Ntc sampling anomaly 1",
  "Ntc采样异常2": "Ntc sampling anomaly 2",
  "Ntc采样异常3": "Ntc sampling anomaly 3",
  "电芯采样异常1": "Abnormal cell sampling 1",
  "电芯采样异常2": "Abnormal cell sampling 2",
  "电芯采样异常3": "Abnormal cell sampling 3",
  "PACK电压": "PACK voltage",
  "PACK温度": "PACK temperature",
  "电芯温度个数": "Number of battery cell temperatures",
  "PACK端子温度数量": "PACK terminal temperature quantity",
  "PACK端子温度": "PACK terminal temperature",
  "单体高压1": "Single cell high voltage 1",
  "单体高压2": "Single cell high voltage 2",
  "单体高压3": "Single cell high voltage 3",
  "单体低压1": "Single cell low voltage 1",
  "单体低压2": "Single cell low voltage 2",
    "单体低压3": "Single cell low voltage 3",
    "电池簇总体高压1": "Battery cluster overall high voltage 1",
    "电池簇总体高压2": "Battery cluster overall high voltage 2",
    "电池簇总体高压3": "Battery cluster overall high voltage 3",
    "电池簇总体低压1": "Battery cluster overall low voltage 1",
    "电池簇总体低压2": "Battery cluster overall low voltage 2",
    "充电过流3": "Charging overcurrent 3",
    "放电过流3": "Discharging overcurrent 3",
    "电池簇总体低压3": "Battery cluster overall low voltage 3",
      "充电高温1": "Charging high temperature 1",
      "充电高温2": "Charging high temperature 2",
      "充电高温3": "Charging high temperature 3",
      "充电低温1": "Charging low temperature 1",
      "充电低温2": "Charging low temperature 2",
      "充电低温3": "Charging low temperature 3",
      "放电高温1": "Discharging high temperature 1",
      "放电高温2": "Discharging high temperature 2",
      "放电高温3": "Discharging high temperature 3",
      "放电低温1": "Discharging low temperature 1",
      "放电低温2": "Discharging low temperature 2",
      "放电低温3": "Discharging low temperature 3",
      "充电温差1": "Charging temperature difference 1",
      "充电温差2": "Charging temperature difference 2",
      "充电温差3": "Charging temperature difference 3",
      "放电温差1": "Discharging temperature difference 1",
      "放电温差2": "Discharging temperature difference 2",
      "放电温差3": "Discharging temperature difference 3",
      "电芯温升1": "Cell temperature rise 1",
      "电芯温升2": "Cell temperature rise 2",
      "电芯温升3": "Cell temperature rise 3",
      "SOC高1": "SOC high 1",
      "SOC高2": "SOC high 2",
      "SOC高3": "SOC high 3",
      "SOC低1": "SOC low 1",
      "SOC低2": "SOC low 2",
      "SOC低3": "SOC low 3",
      "正极绝缘漏电1": "Positive insulation leakage 1",
      "正极绝缘漏电2": "Positive insulation leakage 2",
      "正极绝缘漏电3": "Positive insulation leakage 3",
      "负极绝缘漏电1": "Negative insulation leakage 1",
      "负极绝缘漏电2": "Negative insulation leakage 2",
      "负极绝缘漏电3": "Negative insulation leakage 3",
      "环境高温1": "Ambient high temperature 1",
      "环境高温2": "Ambient high temperature 2",
      "环境高温3": "Ambient high temperature 3",
      "环境低温1": "Ambient low temperature 1",
      "环境低温2": "Ambient low temperature 2",
      "环境低温3": "Ambient low temperature 3",
      "充电压差1": "Charging voltage difference 1",
      "充电压差2": "Charging voltage difference 2",
      "充电压差3": "Charging voltage difference 3",
      "放电压差1": "Discharging voltage difference 1",
      "放电压差2": "Discharging voltage difference 2",
      "放电压差3": "Discharging voltage difference 3",
      "端子高温1": "Terminal high temperature 1",
      "端子高温2": "Terminal high temperature 2",
      "端子高温3": "Terminal high temperature 3",
  '待机模式':'standby mode',
  '禁充禁放':'No charging or discharging allowed',
  'CAN逆变器':'CAN inverter',
  'MOS环境温度':'MOS environmental temperature',
  'pack总压':'Pack total pressure',
  'PACK地址':'PACK address',
  'BMU地址':'BMU address',
  '前7天':'First 7 days',
  '设备SN':'Device SN',
  '设备ID':'Device ID',
  '角色ID':'Role ID',
  '输入设备ID': 'enter the device ID',
  '导入设备ID': 'Import device ID',
  'MD5地址': 'MD5 address',
  'URL地址': 'URL address',
  '协议列表名称(英文)': 'Protocol list name (English)',
  '地址、无线连接信息、操作系统类型和版本、浏览器类型和版本、推送通知标识符以及移动网络信息。': 'Address, wireless connection information, operating system type and version, browser type and version, push notification identifier, and mobile network information.',
  '使用数据：在您与我们的网站和服务交互期间，我们会自动收集与访问、点击、下载、发送': 'Usage Data: During your interaction with our website and services, we automatically collect usage data related to access, clicks, downloads, sending, ',
  '接收消息和其他使用我们的网站和服务相关的使用数据。': 'receiving messages, and other usage of our website and services.',
  '位置信息：当您通过设备与我们的网站和服务交互时，我们可能会收集有关您的实时精确或非精确地理定位信息。': 'Location Information: When you interact with our website and services through a device, we may collect real-time precise or imprecise geolocation information about you.',
  '智能设备数据：“智能设备”是指硬件制造商生产或制造的，具有人机界面并且可以通过无线网络传输数据的非标准计算设备，包括智能家用电器、智能可穿戴设备、智能空气净化设备等。当您使用连接到我们服务的智能设备时，根据您的智能设备的功能，我们可能会收集某些类型的数据，以提供您请求或购买的服务，如视频、图像、健康相关数据等。有关详细信息，请参见我们的移动隐私政策。': 'Smart Device Data: "Smart Device" refers to non-standard computing devices produced or manufactured by hardware manufacturers, featuring a human-machine interface and capable of transmitting data via wireless networks, including smart home appliances, smart wearable devices, smart air purifiers, etc. When you use smart devices connected to our services, depending on the functionality of your smart device, we may collect certain types of data to provide the services you request or purchase, such as videos, images, health-related data, etc. For details, please refer to our Mobile Privacy Policy.',
  '和类似跟踪技术': 'and similar tracking technologies',
  '当您访问网站和服务时，我们和代表我们的服务提供商可能会向您的设备发送一个或多个小型数据文件“': 'When you visit the website and services, we and service providers acting on our behalf may send one or more small data files called "',
  '帮助我们测量如下数据：例如，网站的总访问人数、每个网页的访问人数、我们的用户如何使用和与服务交互，以及访问者的互联网服务提供商的域名。您可以重置网络浏览器以拒绝所有': 'They help us measure data such as: the total number of visitors to the website, the number of visitors to each webpage, how our users use and interact with the service, and the domain name of visitors\' internet service providers. You can reset your web browser to reject all ',
  '或指定何时发送某个': 'or specify when a particular ',
  '如果您不想在设备上安装': 'is sent. If you do not wish to have ',
  '大多数浏览器都可以通过简单的设置，允许您拒绝接受': 'installed on your device, most browsers allow you to refuse to accept them through simple settings.',
  '请注意，如果您的设备禁用了': 'Please note that if you disable ',
  '网站和服务的某些功能将无法正常运行。': 'on your device, certain functions of the website and services may not work properly.',
  '我们也可能会使用网络信标跟踪服务用户的使用模式。此外，我们可能会使用发送给用户的': 'We may also use web beacons to track usage patterns of service users. Additionally, we may use emails sent to users in ',
  '格式的电子邮件，跟踪收件人打开了哪些电子邮件。这些信息用于确保报告更加准确，并为您提供更好的服务。': 'format to track which emails recipients open. This information is used to ensure reports are more accurate and to provide you with better service.',
  '我们尊重系统检测和识别到的“请勿跟踪”信号或类似技术。当在您的设备上此类“请勿跟踪（': 'We respect system-detected and recognized "Do Not Track" signals or similar technologies. When such a "Do Not Track" (',
  '浏览器机制就位时，我们不会跟踪信息、植入': '") browser mechanism is in place on your device, we will not track information, plant ',
  '或使用广告。': 'or use advertising.',
  '处理个人数据的目的和法律依据': 'Purposes and Legal Basis for Processing Personal Data',
  '我们处理您信息的目的如下：': 'We process your information for the following purposes:',
  '为您提供服务：我们处理您的帐户和个人资料数据、设备信息、使用数据、位置信息和智能设备数据，以提供您请求或购买的服务。此类处理的法律依据是根据我们的使用条款履行我们与您的合同。': 'To Provide Services to You: We process your account and profile data, device information, usage data, location information, and smart device data to provide the services you request or purchase. The legal basis for such processing is the performance of our contract with you pursuant to our Terms of Use.',
  '改善我们的服务：我们处理您的设备信息、使用数据、位置信息和智能设备数据，以分析趋势，在必要时跟踪您对我们网站和服务的使用情况，从而开发和改进我们的网站，并为我们的用户提供更相关和更有用的内容。此类处理的法律依据是根据我们的使用条款履行我们与您的合同。': 'To Improve Our Services: We process your device information, usage data, location information, and smart device data to analyze trends, track your use of our website and services where necessary, thereby developing and improving our website, and providing more relevant and useful content to our users. The legal basis for such processing is the performance of our contract with you pursuant to our Terms of Use.',
  '帐户管理：当您注册我们的帐户时，我们会处理您的个人数据以创建和管理帐户。此类处理的法律依据是根据我们的使用条款履行我们与您的合同。': 'Account Management: When you register for our account, we process your personal data to create and manage the account. The legal basis for such processing is the performance of our contract with you pursuant to our Terms of Use.',
  '处理联系和支持请求：我们会处理您的个人数据以便联系您，根据有关智能设备的诊断信息提供帮助，满足您的请求，回复您的询问并提供支持。此类处理的法律依据是根据我们的使用条款履行我们与您的合同。': 'Handling Contact and Support Requests: We process your personal data to contact you, provide assistance based on diagnostic information about smart devices, fulfill your requests, respond to your inquiries, and provide support. The legal basis for such processing is the performance of our contract with you pursuant to our Terms of Use.',
  '营销通信：我们处理您的个人数据，告知您我们认为您可能感兴趣的服务。在上述情况中，我们向您发送的每封邮件均含有允许您选择不再接收此类邮件的指示信息。此类处理的法律依据是基于您的同意。': 'Marketing Communications: We process your personal data to inform you about services we believe you may be interested in. In the above cases, each email we send you contains instructions allowing you to opt out of receiving such emails. The legal basis for such processing is your consent.',
  '非营销通信：我们处理您的个人数据，旨在向您发送与服务、条款': 'Non-Marketing Communications: We process your personal data to send you communications related to service, terms, ',
  '条件和政策变更和': 'conditions, and policy changes, and',
  '如果处理您的个人数据的目的发生任何变化，我们将通过电子邮件和': 'If there are any changes to the purpose for processing your personal data, we will notify you of such changes via email and ',
  '或我们网站上的显著通知将此类变化通知到您，并告知您关于个人数据的选择。': 'or a prominent notice on our website, and inform you about choices regarding personal data.',
  '我们与谁共享您的个人数据？': 'With Whom Do We Share Your Personal Data?',
  '仅以您知晓的方式共享您的个人数据。我们不会将您的个人数据出售给第三方，且仅限于向以下人士披露您的个人数据：': 'We share your personal data only in ways that you are aware of. We do not sell your personal data to third parties and limit disclosure of your personal data to the following parties:',
  '向为我们提供某些业务相关服务的第三方服务提供商披露您的个人数据，例如网站托管、数据分析、支付和信用卡处理、基础设施供应、': 'Disclose your personal data to third-party service providers who provide certain business-related services to us, such as website hosting, data analysis, payment and credit card processing, infrastructure provision, ',
  '服务、客户支持服务、电子邮件发送服务以及其他类似服务，从而确保他们能够为我们提供服务。': 'services, customer support services, email delivery services, and other similar services, to ensure they can provide services to us.',
  '向直接或间接为您提供智能设备和': 'Disclose your personal data to customers and other business partners who directly or indirectly provide you with smart devices and ',
  '或您用来访问和使用我们网站和服务的网络和系统的客户以及其他业务合作伙伴披露您的个人数据。': 'or the networks and systems you use to access and use our website and services.',
  '当发生重组、合并、出售、合资、让渡、转让或其他处置我们所有或部分业务、资产或股票（包括但不限于与任何破产或类似程序相关的上述情况）的情况时，向附属公司或其他第三方披露您的个人数据。在这种情况下，您将通过电子邮件和': 'Disclose your personal data to affiliates or other third parties in the event of a reorganization, merger, sale, joint venture, assignment, transfer, or other disposition of all or any portion of our business, assets, or stock (including, without limitation, in connection with any bankruptcy or similar proceedings). In such cases, you will be notified via email and ',
  '或我们的网站收到关于所有权变更、个人数据新的使用方式不兼容以及有关个人数据选择的明确通知。': 'or our website with clear notice of the change in ownership, any incompatible new uses of personal data, and choices regarding personal data.',
  '在我们认为必要或适当的情况下：（': 'Disclose your personal data when we believe it is necessary or appropriate to: (',
  '）响应公共机构和政府当局的要求，包括您居住的国家': 'a) respond to requests from public agencies and government authorities, including those outside the country ',
  '地区以外的公共机构和政府当局；（': 'or region where you reside; (',
  '向公司旗下的子公司或附属公司披露您的个人数据，以定期开展业务活动。': 'b) disclose your personal data to subsidiaries or affiliates under the company for regular business activities.',
  '除上述第三方以外，我们仅在您同意的情况下向其他第三方披露您的个人数据。': 'Other than the third parties mentioned above, we disclose your personal data to other third parties only with your consent.',
  '所收集信息的国际转移': 'International Transfer of Collected Information',
  '为了方便我们的操作，我们可能会在您居住的地方以外的司法管辖区转移、存储和处理您的个人数据。这些国家可能设有不同的数据保护法。在此类情况下，我们会通过以下方式确保您的信息得到充分的保护：': 'To facilitate our operations, we may transfer, store, and process your personal data in jurisdictions outside where you reside. These countries may have different data protection laws. In such cases, we ensure your information is adequately protected by:',
  '第': 'Agreements reached using the "EU Standard Contractual Clauses" approved under Article ',
  '条批准的“欧盟标准合同条款”达成的协议。点击此处访问信息。': 'Click here to access information.',
  '如果您想进一步了解我们的安全保障措施，您可以通过本政策直接联系我们。': 'If you wish to learn more about our security safeguards, you can contact us directly through this policy.',
  '安全保障措施': 'Security Safeguards',
  '我们采取商业上合理的物理、管理和技术保障措施，以维护您的个人数据的完整性和安全性。提供多种安全保障策略，以有效确保用户和设备的数据安全。在设备访问方面，我们采用专有算法保障数据隔离、访问认证和授权申请。在数据通信方面，支持使用安全算法和传输加密协议以及基于动态密钥的商业级信息加密传输进行通信。在数据处理方面，采用严格的数据过滤和验证以及完整的数据审核流程。在数据存储方面，用户的所有机密信息将进行安全的加密处理以便存储。如果您出于任何原因认为您与我们的交互不再安全（例如，您认为您的帐户的安全性已经受损），请您按照下述方式发送电子邮件至': 'We implement commercially reasonable physical, administrative, and technical safeguards to maintain the integrity and security of your personal data. Multiple security strategies are provided to effectively ensure the security of user and device data. For device access, we use proprietary algorithms to ensure data isolation, access authentication, and authorization requests. For data communication, we support the use of secure algorithms, transmission encryption protocols, and commercial-grade encrypted transmission based on dynamic keys. For data processing, we employ strict data filtering and validation, along with complete data audit processes. For data storage, all confidential user information is securely encrypted. If, for any reason, you believe your interaction with us is no longer secure (e.g., you believe the security of your account has been compromised), please immediately notify us by sending an email to ',
  '立即告知我们。': 'as described below.',
  '数据主体权利': 'Data Subject Rights',
  '我们尊重您的权利，同时也会掌握您的个人数据。您可以通过以下方式行使下列任何一项权利：': 'We respect your rights regarding your personal data. You can exercise any of the following rights in the following ways:',
  '在“支持中心”创建票证；': 'Create a ticket in the "Support Center";',
  '通过': 'Send us an email via ',
  '给我们发邮件。': '.',
  '您无需支付任何费用，我们将在': 'You will not be charged any fee, and we will respond within ',
  '天之内作出答复。在您的请求中，请说明您希望更改哪些信息，您是否希望将您的个人数据从我们的数据库中删除，或者您希望我们在使用您的个人数据时受到哪些限制。请注意，出于安全考虑，我们可能会在进一步处理您的请求之前要求您核实身份。': 'days. In your request, please specify what information you wish to change, whether you want your personal data deleted from our database, or what restrictions you want us to observe when using your personal data. Please note that for security reasons, we may require you to verify your identity before further processing your request.',
  '您可以：': 'You can:',
  '要求访问我们处理的与您相关的个人数据；': 'Request access to the personal data we process related to you;',
  '要求我们纠正与您相关的不准确或不完整的个人数据；': 'Request that we correct inaccurate or incomplete personal data related to you;',
  '要求删除您的个人数据；': 'Request deletion of your personal data;',
  '要求暂时或永久限制我们处理您的部分或全部个人数据；': 'Request temporary or permanent restriction of our processing of some or all of your personal data;',
  '要求我们基于您的同意或与您签订的合同处理您的数据，以及我们自动处理您的数据时，向您本人或第三方传输个人数据；': 'Request that we transmit personal data to you or a third party when we process your data based on your consent or a contract with you, and when we process your data automatically;',
  '当我们基于您的同意或我们的正当利益使用您的个人数据时，选择反对或拒绝我们使用您的个人数据。': 'Object to or refuse our use of your personal data when we use it based on your consent or our legitimate interests.',
  '您可以通过向': 'You can opt out of receiving our marketing-related emails or other communications by sending an email to ',
  '发送电子邮件，选择不接收我们的营销相关邮件或其他通信。我们将在合理可行的情况下尽快满足您的拒收请求。请注意，如果您确实选择不接收我们的营销相关消息，我们可能仍然会向您发送重要的管理消息，并且您不能选择不接收管理消息。': '. We will honor your opt-out request as soon as reasonably practicable. Please note that if you do opt out of marketing messages, we may still send you important administrative messages, and you cannot opt out of administrative messages.',
  '加州隐私权利': 'California Privacy Rights',
  '《加州民法典》第': 'The California Civil Code Section ',
  '节允许使用软件的加州居民用户，出于直接营销目的，请求获取我们向第三方披露的个人数据当中的某些信息。若要提出以上要求，请按照下述方式与我们联系（': 'allows California resident users of software to request certain information regarding our disclosure of personal data to third parties for direct marketing purposes. To make such a request, please contact us as follows (',
  '）。未经您的同意，我们不会出于直接营销目的向第三方披露个人数据。请访问加州隐私权利声明查看更多信息。': '). We do not disclose personal data to third parties for direct marketing purposes without your consent. Please visit the California Privacy Rights Statement for more information.',
  '数据保留期限': 'Data Retention Period',
  '我们将在达成本政策所述目的的最短期限内处理您的个人数据，除非根据特定法律要求需要保留较长时间。我们将根据个人数据的数量、性质和敏感性决定适当的保留期限，在保留期限结束后，我们将销毁您的个人数据。如果我们出于技术原因无法销毁数据，我们将采取适当措施防止您的个人数据被进一步使用。': 'We will process your personal data for the minimum period necessary to achieve the purposes stated in this policy, unless a longer retention period is required by specific laws. We will determine an appropriate retention period based on the amount, nature, and sensitivity of the personal data. After the retention period expires, we will destroy your personal data. If we are unable to destroy the data for technical reasons, we will take appropriate measures to prevent further use of your personal data.',
  '儿童隐私': 'Children\'s Privacy',
  '保护儿童的隐私对我们来说非常重要。本服务不面向': 'Protecting children\'s privacy is very important to us. This service is not directed to individuals under ',
  '岁以下的个人，而且我们要求这些个人不要向我们提供任何个人数据。除非得到父母或法定监护人的同意，否则我们不会有意收集': 'years of age, and we require these individuals not to provide any personal data to us. Unless parental or guardian consent is obtained, we do not knowingly collect personal data from children under ',
  '岁以下儿童的个人数据。我们若在未经儿童父母或法定监护人同意的情况下收集了': 'years of age. If we collect personal data from a child under ',
  '岁以下儿童的个人数据，且已得知此情况时，我们会删除这些信息。': 'years of age without parental or guardian consent and become aware of it, we will delete that information.',
  '本隐私政策的变更': 'Changes to This Privacy Policy',
  '我们可能会根据信息实践的变化对本政策进行至少每年一次的更新。如果我们作出任何重大变更，我们将通过电子邮件（发送至您帐户中指定的电子邮件地址）通知您，或于变更生效前在本网站上发布通知。我们建议您定期浏览本页面，以获取有关隐私做法的最新信息。': 'We may update this policy at least annually based on changes in our information practices. If we make any material changes, we will notify you by email (sent to the email address specified in your account) or by posting a notice on this website before the change becomes effective. We recommend that you periodically visit this page to get the latest information on privacy practices.',
  '联系我们': 'Contact Us',
  '如果您对我们的做法或本政策存在任何疑问，请通过以下方式联系我们：': 'If you have any questions about our practices or this policy, please contact us at:',
  '四川三棵物联科技有限公司': 'Sichuan Sanko IoT Technology Co., Ltd.',
  '通讯地址：四川省成都市武侯区环球中心': 'Mailing Address: Global Center, Wuhou District, Chengdu City, Sichuan Province',
  '电子邮箱：': 'Email:',
  '智慧燃气平台': 'Smart Gas Platform',
  '平台设备列表': 'Platform Device List',
  '您的浏览器不支持': 'Your browser does not support ',
  '元素。': 'element.',
  '报警消息列表': 'Alarm Message List',
  '待处理报警数量': 'Number of Pending Alarms',
  '前往处理': 'Go to Handle',
  '告警排行分析': 'Alarm Ranking Analysis',
  '模拟数据列表': 'Simulated Data List',
  '多选': 'Multiple Selection',
  '请选择导出设备': 'Please Select Devices to Export',
  '数据为空': 'Data is Empty',
  '我的查询条件': 'My Query Criteria',
  '商户列表': 'Merchant List',
  '确认删除': 'Confirm Deletion',
  '显示标记的数据': 'Show Marked Data',
  '所属商户': 'Belonging Merchant',
  '请选择商户': 'Please Select Merchant',
  '请输入报警级别': 'Please Enter Alarm Level',
  '，获取级联的': ', Get Cascading ',
  '按需获取信息': 'Get Information On Demand',
  '这里是获取节点名称': 'Here to Get Node Name',
  '提交弹窗时': 'When Submitting Popup',
  '取消和关闭弹窗时': 'When Canceling and Closing Popup',
  '开关弹窗时': 'When Toggling Popup',
  '图片格式有误': 'Image Format is Incorrect',
  '或者': 'or ',
  '格式的照片': 'format photo',
  '文件过大，超出': 'File is too large, exceeding ',
  '仅上传一张照片': 'Upload Only One Photo',
  '您确定要删除序号为': 'Are you sure you want to delete the data with serial number ',
  '的数据吗？': '?',
  '出货区域不能为空': 'Shipment Region Cannot Be Empty',
  '获取区域列表': 'Get Region List',
  '等待提交的临时数据': 'Temporary Data Waiting for Submission',
  '单个删除': 'Single Delete',
  '同时删除临时对象中的数据': 'Also Delete Data in Temporary Object',
  '获取节点所在数组的位置': 'Get the Position of the Node in the Array',
  '这里按照你的需求来存放最后返回的内容吧': 'Store the final returned content here according to your needs',
  '这里的': 'Here the ',
  '是表示我是根据': ' indicates that I am based on ',
  '去查询父级的，你可以修改成你的需求，其他不变': ' to query the parent level. You can modify it to your requirements, other things remain unchanged',
  '返回数据': 'Return Data',
  '请选择': 'Please Select',
  '经销商': 'Distributor',
  '请输入经销商': 'Please Enter Distributor',
  '出货区域': 'Shipment Region',
  '请输入出货区域': 'Please Enter Shipment Region',
  '报警数量': 'Number of Alarms',
  '请输入报警数量': 'Please Enter Number of Alarms',
  '楼层数': 'Number of Floors',
  '请输入楼层数': 'Please Enter Number of Floors',
  '平面图': 'Floor Plan',
  '上传平面图': 'Upload Floor Plan',
  '分配数量不能为': 'Allocation Quantity Cannot Be ',
  '产测时间不能为空': 'Production Test Time Cannot Be Empty',
  '产品型号不能为空': 'Product Model Cannot Be Empty',
  '所属防制区域：': 'Belonging Pest Control Area:',
  '请选择所属防制区域': 'Please Select Belonging Pest Control Area',
  '防制区域名称：': 'Pest Control Area Name:',
  '所属建筑物：': 'Belonging Building:',
  '地图标记：': 'Map Marker:',
  '经纬度：': 'Coordinates:',
  '平面图：': 'Floor Plan:',
  '项目编码': 'Project Code',
  '平面图名称': 'Floor Plan Name',
  '详细地址': 'Detailed Address',
  '所属防制区域名称不能为空': 'Pest Control Area Name Cannot Be Empty',
  '平面图名称不能为空': 'Floor Plan Name Cannot Be Empty',
  '地图标注不能为空': 'Map Annotation Cannot Be Empty',
  '经纬度不能为空': 'Coordinates Cannot Be Empty',
  '详细地址不能为空': 'Detailed Address Cannot Be Empty',
  '平面图不能为空': 'Floor Plan Cannot Be Empty',
  '文件大小超出限制': 'File Size Exceeds Limit',
  '请上传小于': 'Please Upload Images Smaller Than ',
  '的图片': '',
  '维保开始日期': 'Maintenance Start Date',
  '合同开始日期': 'Contract Start Date',
  '根据点位获取地理位置': 'Get Geographic Location Based on Point',
  '其他': 'Other',
  '去分配': 'To Allocate',
  '导出历史数据记录': 'Export Historical Data Record',
  '分配经销商': 'Allocate Distributor',
  '的数据吗': ' data?',
  '采样频率设置': 'Sampling Frequency Setting',
  '这里显示堆信息': 'Heap Information Displayed Here',
  '运行监视': 'Operation Monitoring',
  '容量统计': 'Capacity Statistics',
  '容量分析': 'Capacity Analysis',
  '地址': 'Address',
  '电压': 'Voltage',
  '温度': 'Temperature',
  '℃': '℃',
  '电芯温度数量': 'Number of Cell Temperatures:',
  '电芯数量': 'Number of Cells:',
  '电芯电压': 'Cell Voltage',
  '电芯温度': 'Cell Temperature',
  '更多': 'More',
  '二级数据': 'Secondary Data',
  '更新时间': 'Update Time',
  '串口逆变器': 'Serial Port Inverter',
  '网络逆变器': 'Network Inverter',
  '当前已是最新版本': 'Currently the Latest Version',
  '检测新版本': 'Check for New Version',
  '开始更新固件': 'Start Firmware Update',
  '升级成功':'Upgrade Successful',
  '：当前已是最新版本': ': Currently the Latest Version',
  '检测到新固件': ': New Firmware Detected ',
  '立即升级': 'Upgrade Now',
  '升级进度': 'Upgrade Progress',
  '定位到指定': 'Locate to Specified',
  '是否显示二维码': 'Whether to Show QR Code',
  '二维码地址': 'QR Code Address',
  '电池': 'Battery',
  '设备位置': 'Device Location',
  '参数名': 'Parameter Name',
  '当前值': 'Current Value',
  '值': 'Value',
  '设置值': 'Set Value',
  '风扇控制': 'Fan Control',
  '满充参数': 'Full Charge Parameters',
  '均衡参数': 'Balancing Parameters',
  '容量': 'Capacity',
  '短路保护': 'Short Circuit Protection',
  '掉电开关': 'Power Loss Switch',
  '继电器控制': 'Relay Control',
  '基础控制': 'Basic Control',
  '保护功能': 'Protection Function',
  '趋势数据': 'Trend Data',
  '电芯电压（': 'Cell Voltage (',
  '去掉辅助线首尾圆点和箭头': 'Remove Dots and Arrows from Start/End of Auxiliary Line',
  '实线': 'Solid Line',
  '纵坐标的值，决定横向辅助线在': 'The value of the ordinate determines the position of the horizontal auxiliary line on the ',
  '轴的位置': 'axis',
  '最高限制': 'Upper Limit',
  '最低限制': 'Lower Limit',
  '横坐标的值，决定纵向辅助线在': 'The value of the abscissa determines the position of the vertical auxiliary line on the ',
  '纵向辅助线': 'Vertical Auxiliary Line',
  '测试单体数据': 'Test Single Cell Data',
  '电芯温度（℃）': 'Cell Temperature (℃)',
  '我的名字': 'My Name',
  '中心点': 'Center Point',
  '有历史估计，按经纬度显示地图': 'Display Map by Coordinates if Historical Estimation Exists',
  '全部设备信息': 'All Device Information',
  '循环找到逆变器': 'Loop to Find Inverter',
  '设置发送刷新命令': 'Set Send Refresh Command',
  '升级固件': 'Upgrade Firmware',
  '升级': 'Upgrade',
  '您确定要升级通道': 'Are you sure you want to upgrade channel ',
  '的固件吗？': ' firmware?',
  '拉取进度': 'Pull Progress',
  '运行数据': 'Operation Data',
  '最高电压': 'Maximum Voltage',
  '最低电压': 'Minimum Voltage',
  '最高温度': 'Maximum Temperature',
  '最低温度': 'Minimum Temperature',
  '暂无可升级的固件': 'No Upgradable Firmware Available',
  '暂无可更新固件': 'No Updatable Firmware Available',
  '检测新的固件版本': 'Detect New Firmware Version',
  '获取设备信息': 'Get Device Information',
  '检测成功': 'Detection Successful',
  '毫秒': 'Milliseconds',
  '固件升级超时，升级失败': 'Firmware Upgrade Timed Out, Upgrade Failed',
  '升级通知': 'Upgrade Notification',
  '这里': 'Here',
  '设置成功': 'Set Successfully',
  '默认值': 'Default Value',
  '已复制': 'Copied',
  '鼠标悬浮时显示小手': 'Show Pointer Cursor on Mouse Hover',
  '添加过渡效果': 'Add Transition Effect',
  '堆信息': 'Heap Information',
  '汇总数据': 'Summary Data',
  '详情数据': 'Detail Data',
  '总压：': 'Total Voltage:',
  '境温度：': 'Ambient Temperature:',
  '环境温度：': 'Ambient Temperature:',
  '老数据': 'Old Data',
  '一级数据': 'Primary Data',
  '进度测试': 'Progress Test',
  '已经是最新版本': 'Already the Latest Version',
  '检测出可升级的固件': 'Detected Upgradable Firmware',
  '图标位置': 'Icon Position',
  '使用自定义图标': 'Use Custom Icon',
  '添加到地图': 'Add to Map',
  '更新图表数据': 'Update Chart Data',
  '中的': 'in ',
  '最大值': 'Maximum Value',
  '的长度生成': 'length generates ',
  '轴标签': 'axis labels',
  '轴线颜色': 'Axis Line Color',
  '轴标签颜色': 'Axis Label Color',
  '轴分割线颜色': 'Axis Grid Line Color',
  '是数组，使用深度监听': 'is an array, use deep watch',
  '重新设置图表选项': 'Reset Chart Options',
  '显示时间': 'Display Time',
  '添加颜色原点': 'Add Color Origin',
  '充电电流': 'Charging Current',
  '放电电流': 'Discharging Current',
  '压差': 'Voltage Difference',
  '监测充电数据变化': 'Monitor Charging Data Changes',
  '监测放电数据变化': 'Monitor Discharging Data Changes',
  '保护': 'Protection',
  '指示': 'Indicator',
  '请输入申诉内容': 'Please Enter Appeal Content',
  '张三': 'Zhang San',
  '采样频率不能为空': 'Sampling Frequency Cannot Be Empty',
  '采样频率': 'Sampling Frequency',
  '刷新频率设置': 'Refresh Frequency Setting',
  '实时监测': 'Real-time Monitoring',
  '铃铛': 'Bell',
  '跳转': 'Jump',
  '是否打开蜂鸣器声音': 'Whether to Turn On Buzzer Sound',
  '运作': 'Operating',
  '静止': 'Inactive',
  '实际容量': 'Actual Capacity',
  '功率': 'Power',
  '当前连接状态': 'Current Connection Status',
  '会影响电池包正常是否确认': 'Will Affect Battery Pack Normal Operation, Confirm?',
  '均衡': 'Balancing',
  '电池串数': 'Number of Battery Strings',
  '设备数据': 'Device Data',
  '选择时间': 'Select Time',
  '返回今日': 'Return to Today',
  '返回旧页面': 'Return to Previous Page',
  '数据导出': 'Data Export',
  '历史数据详情': 'Historical Data Details',
  '单体电池视图': 'Single Cell Battery View',
  '平均电压': 'Average Voltage',
  '示例数据': 'Sample Data',
  '初始图片源': 'Initial Image Source',
  '控制是否可以点击': 'Control Whether Clickable',
  '触发对话框逻辑': 'Trigger Dialog Logic',
  '我的值': 'My Value',
  '恢复原图片': 'Restore Original Image',
  '恢复点击': 'Restore Click',
  '我的信息': 'My Information',
  '左侧数据': 'Left Side Data',
  '提示': 'Prompt',
  '会影响电池包正常是否确认？': 'Will Affect Battery Pack Normal Operation, Confirm?',
  '保留当前路径': 'Keep Current Path',
  '保留其他查询参数': 'Keep Other Query Parameters',
  '地图': 'Map',
  '添加标记': 'Add Marker',
  '标记位置': 'Marker Position',
  '将标记添加到地图': 'Add Marker to Map',
  '创建信息窗口': 'Create Info Window',
  '信息窗口位置': 'Info Window Position',
  '向上偏移': 'Offset Upward',
  '点击标记显示时间': 'Click Marker to Show Time',
  '打开信息窗口': 'Open Info Window',
  '默认打开信息窗口': 'Open Info Window by Default',
  '在地图加载时打开信息窗口': 'Open Info Window When Map Loads',
  '背景': 'Background',
  '最大值背景': 'Maximum Value Background',
  '最小值背景': 'Minimum Value Background',
  '其他值背景': 'Other Values Background',
  '折线图': 'Line Chart',
  '月份从': 'Month from ',
  '开始': 'Start',
  '复制信息': 'Copy Information',
  '假设地图在第一个标签': 'Assume Map is in the First Tab',
  '不换行': 'No Wrap',
  '隐藏超出部分': 'Hide Overflow',
  '省略号': 'Ellipsis',
  '允许换行': 'Allow Wrap',
  '垂直居中对齐': 'Vertical Center Alignment',
  '元素间距': 'Element Spacing',
  '每项之间的间距': 'Spacing Between Items',
  '图片与文字之间的间距': 'Spacing Between Image and Text',
  '使背景图像覆盖整个': 'Make Background Image Cover the Entire ',
  '居中显示背景图像': 'Center Background Image',
  '每个元素固定宽度为': 'Each Element Fixed Width is ',
  '计算元素间距，最多': 'Calculate Element Spacing, Maximum ',
  '个元素': ' Elements',
  '每行最后一个元素不需要右边距': 'Last Element in Each Row Does Not Need Right Margin',
  '电芯温度个数：': 'Number of Cell Temperatures:',
  '端子温度数量：': 'Number of Terminal Temperatures:',
  '判断启用禁用': 'Determine Enable/Disable',
  '端子温度（℃）': 'Terminal Temperature (℃)',
  '不显示原点': 'Do Not Show Origin',
  '根据条件显示数据': 'Display Data Based on Condition',
  '中国区': 'China Region',
  '香港区': 'Hong Kong Region',
  '欧洲区': 'Europe Region',
  '美国区': 'US Region',
  '设为默认': 'Set as Default',
  '您确定要设置': 'Are you sure you want to set ',
  '为默认吗？': ' as default?',
  '联网方式必须': 'Network Connection Method Must',
  '实时监测预览': 'Real-time Monitoring Preview',
  '单体过压': 'Single Cell Overvoltage',
  '另一个状态': 'Another State',
  '折线图数据': 'Line Chart Data',
  '确认下载？': 'Confirm Download?',
  '导出接口': 'Export Interface',
  '长显的': 'Persistently Displayed',
  '条件': 'Condition',
  '收起的查询条件': 'Collapsed Query Conditions',
  '需要点击': 'Requires Clicking ',
  '按钮显示的': ' Button to Display',
  '是否重新进行分配': 'Whether to Reallocate',
  '错误信息': 'Error Message',
  '详细数据': 'Detailed Data',
  '用户点击确定后的逻辑': 'Logic After User Clicks OK',
  '沛城平台账号': 'Peicheng Platform Account',
  '产测时间和产测状态': 'Production Test Time and Status',
  '搜索参数名': 'Search Parameter Name',
  '选择参数名': 'Select Parameter Name',
  '批量发送': 'Batch Send',
  '取消全选': 'Deselect All',
  '输入值非法': 'Input Value Invalid',
  '拉取': 'Pull',
  '及其内容': ' and its content',
  '不存在': 'Does Not Exist',
  '存在': 'Exists',
  '休眠': 'Sleep',
  '功能参数': 'Function Parameters',
  '掉电关机': 'Power Loss Shutdown',
  '慢充电口高温': 'Slow Charging Port Overheat',
  '加热膜参数': 'Heating Film Parameters',
  '小谢': 'Xiao Xie',
  '设计容量不能小于满充容量': 'Design Capacity Cannot Be Less Than Full Charge Capacity',
  '满充容量不能小于剩余容量': 'Full Charge Capacity Cannot Be Less Than Remaining Capacity',
  '判断是否设置弹框参数': 'Determine Whether Popup Parameters Are Set',
  '多选操作': 'Multi-select Operation',
  '加热膜控制': 'Heating Film Control',
  '自动': 'Automatic',
  '常闭': 'Normally Closed',
  '常开': 'Normally Open',
  '定时开关': 'Timed Switch',
  '判断大小': 'Determine Size',
  '单个发送': 'Single Send',
  '单体抵押': 'Single Cell Mortgage',
  '设置加热膜': 'Set Heating Film',
  '加热膜控制：': 'Heating Film Control:',
  '请选择加热膜状态': 'Please Select Heating Film Status',
  '定时计划：': 'Timing Schedule:',
  '您确定要删除这条数据吗': 'Are you sure you want to delete this data?',
  '新增计划': 'Add Plan',
  '增加定时计划': 'Add Timing Plan',
  '加热膜控制状态：': 'Heating Film Control Status:',
  '重复：': 'Repeat:',
  '仅一次不选周': 'Only Once, Do Not Select Weeks',
  '周期必选周，可多选': 'Cycle Must Include Weeks, Multiple Selection Allowed',
  '周天': 'Sunday',
  '写入计划': 'Write Plan',
  '时间必须': 'Time Must',
  '仅一次': 'Only Once',
  '所属项目': 'Belonging Project',
  '请输入平面图名称': 'Please Enter Floor Plan Name',
  '申诉内容': 'Appeal Content',
  '所属建筑物': 'Belonging Building',
  '请输入所属建筑物': 'Please Enter Belonging Building',
  '地图标记': 'Map Marker',
  '经纬度': 'Coordinates',
  '请输入经纬度': 'Please Enter Coordinates',
  '请输入详细地址': 'Please Enter Detailed Address',
  '分配编码': 'Allocation Code',
  '申诉内容不能为空': 'Appeal Content Cannot Be Empty',
  '是否使用': 'Whether to Use',
  '请选择是否使用': 'Please Select Whether to Use',
  '区域名称不能为空': 'Region Name Cannot Be Empty',
  '上级编码不能为空': 'Parent Code Cannot Be Empty',
  '添加选中设备': 'Add Selected Devices',
  '添加到提交的对象中': 'Add to Submission Object',
  '清空全选或选择状态？': 'Clear All Selections or Selected State?',
  '删除选择': 'Delete Selection',
  '选中后修改': 'Modify After Selection',
  '修改状态': 'Modify Status',
  '您确认要': 'You confirm to ',
  '请选择项目名称': 'Please Select Project Name',
  '建筑物选择': 'Building Selection',
  '请选择建筑物选择': 'Please Select Building Selection',
  '所在楼层': 'Floor Location',
  '请输入所在楼层': 'Please Enter Floor Location',
  '建筑物列表': 'Building List',
  '建筑物编码': 'Building Code',
  '平面图路径': 'Floor Plan Path',
  '项目名称不能为空': 'Project Name Cannot Be Empty',
  '建筑物不能为空': 'Building Cannot Be Empty',
  '所在楼层不能为空': 'Floor Location Cannot Be Empty',
  '合同编号': 'Contract Number',
  '合同期限': 'Contract Term',
  '维保周期': 'Maintenance Cycle',
  '维保开始时间': 'Maintenance Start Time',
  '影像图': 'Image',
  '合同结束日期': 'Contract End Date',
  '合同时间': 'Contract Time',
  '维保人员的': 'Maintenance Personnel\'s ',
  '影像图的': 'Image\'s ',
  '客户负责人不能为空': 'Customer Responsible Person Cannot Be Empty',
  '联系电话格式不正确': 'Contact Phone Number Format Incorrect',
  '合同编号不能为空': 'Contract Number Cannot Be Empty',
  '合同时间不能为空': 'Contract Time Cannot Be Empty',
  '维保人员不能为空': 'Maintenance Personnel Cannot Be Empty',
  '维保开始日期不能为空': 'Maintenance Start Date Cannot Be Empty',
  '影像图不能为空': 'Image Cannot Be Empty',
  '维保周期不能为空': 'Maintenance Cycle Cannot Be Empty',
  '项目名称筛选': 'Project Name Filter',
  '建筑物名称筛选': 'Building Name Filter',
  '楼层': 'Floor',
  '建筑物名称': 'Building Name',
  '楼吗？': ' Building?',
  '防制区域名称': 'Pest Control Area Name',
  '请输入防制区域名称': 'Please Enter Pest Control Area Name',
  '所属项目不能为空': 'Belonging Project Cannot Be Empty',
  '低压': 'Low Voltage',
  '所在服务器': 'Server Location',
  '经销商筛选': 'Distributor Filter',
  '产品型号筛选': 'Product Model Filter',
  '请输入协议列表名称': 'Please Enter Protocol List Name',
  '请输入协议列表名称(中文)': 'Please enter protocol list name (Chinese)',
  '请输入协议列表名称(英文)': 'Please enter protocol list name (English)',
  '产品名称不能为空': 'Product Name Cannot Be Empty',
  '协议列表名称不能为空': 'Protocol List Name Cannot Be Empty',
  '你确定要删除': 'Are you sure you want to delete ',
  '新增协议列表': 'Add Protocol List',
  '协议列表中文名称不能为空': 'Protocol List Chinese Name Cannot Be Empty',
  '协议列表英文名称不能为空': 'Protocol List English Name Cannot Be Empty',
  '协议列表名称：': 'Protocol List Name:',
  '姓名筛选': 'Name Filter',
  '组别': 'Group',
  '联系方式': 'Contact Information',
  '请输入联系方式': 'Please Enter Contact Information',
  '请输入组别': 'Please Enter Group',
  '登录名': 'Login Name',
  '维保项目': 'Maintenance Project',
  '请选择维保项目': 'Please Select Maintenance Project',
  '授权菜单': 'Authorized Menu',
  '请选择授权菜单': 'Please Select Authorized Menu',
  '维保服务': 'Maintenance Service',
  '维保管理': 'Maintenance Management',
  '需要授权的菜单': 'Menu Requiring Authorization',
  '组别不能为空': 'Group Cannot Be Empty',
  '联系方式不能为空': 'Contact Information Cannot Be Empty',
  '联系方式格式不正确': 'Contact Information Format Incorrect',
  '登录名不能为空': 'Login Name Cannot Be Empty',
  '维保项目不能为空': 'Maintenance Project Cannot Be Empty',
  '星期一': 'Monday',
  '星期二': 'Tuesday',
  '星期三': 'Wednesday',
  '星期四': 'Thursday',
  '星期五': 'Friday',
  '星期六': 'Saturday',
  '星期日': 'Sunday',
  '功能开发中': 'Function Under Development',
  '获取选中项目': 'Get Selected Item',
  '去重操作': 'Deduplicate Operation',
  '保存经销商权限': 'Save Distributor Permissions',
  '下级代理商': 'Subordinate Agent',
  '编辑代理商': 'Edit Agent',
  '转移代理商': 'Transfer Agent',
  '操作状态': 'Operation Status',
  '（': '(',
  '账号（手机号）': 'Account (Mobile Number)',
  '打开选择接口配置': 'Open Select Interface Configuration',
  '所选中的项': 'Selected Item',
  '需要改接口状态': 'Need to Change Interface Status',
  '应用': 'Application',
  '请输入应用': 'Please Enter Application',
  '请输入区域': 'Please Enter Region',
  '请输入售后联系': 'Please Enter After-sales Contact',
  '不能为空': 'Cannot Be Empty',
  '手机号不能为空': 'Mobile Number Cannot Be Empty',
  '选中的遍历选择': 'Selected Traverse Selection',
  '设置默认角色权限': 'Set Default Role Permissions',
  '是否有密码管理权限': 'Whether Has Password Management Permission',
  '有权限': 'Has Permission',
  '无权限': 'No Permission',
  '是否有管理密码权限必须': 'Whether Has Password Management Permission Must',
  '请选择默认权限': 'Please Select Default Permission',
  '新增时': 'When Adding',
  '您在': 'You clicked the map at ',
  '的位置单击了地图！': '!',
  '根据经纬度查询地址失败': 'Failed to Query Address Based on Coordinates',
  '构造地点查询类': 'Construct Place Query Class',
  '展现结果的地图实例': 'Map Instance Displaying Results',
  '关键字查询': 'Keyword Query',
  '经纬度信息': 'Coordinate Information',
  '这里是': 'Here is ',
  '上级经销商': 'Superior Distributor',
  '请输入经销商名称': 'Please Enter Distributor Name',
  '请选择上级经销商': 'Please Select Superior Distributor',
  '上级经销商不能为空': 'Superior Distributor Cannot Be Empty',
  '所属项目筛选': 'Belonging Project Filter',
  '设备编号筛选': 'Device Number Filter',
  '全部报警类型': 'All Alarm Types',
  '全部防制分类': 'All Pest Control Classifications',
  '防制分类': 'Pest Control Classification',
  '报警类型': 'Alarm Type',
  '设备编号': 'Device Number',
  '报警时间': 'Alarm Time',
  '所属区域': 'Belonging Area',
  '处理报警': 'Handle Alarm',
  '处理告警': 'Handle Alert',
  '您确定要处理': 'Are you sure you want to handle the alert for ',
  '的告警吗': '?',
  '建筑物': 'Building',
  '现场位置': 'On-site Location',
  '处理方式': 'Handling Method',
  '请选择处理方式': 'Please Select Handling Method',
  '已存在坐标': 'Coordinate Already Exists',
  '楼层列表': 'Floor List',
  '项目记录': 'Project Record',
  '设备分类': 'Device Classification',
  '设备用途': 'Device Purpose',
  '设备编码': 'Device Code',
  '设备分类编码': 'Device Classification Code',
  '设备用途编码': 'Device Purpose Code',
  '楼层编码': 'Floor Code',
  '设备图': 'Device Image',
  '处理人不能为空': 'Handler Cannot Be Empty',
  '处理方式不能为空': 'Handling Method Cannot Be Empty',
  '获取楼层': 'Get Floor',
  '获取坐标': 'Get Coordinates',
  '项目改变': 'Project Changed',
  '改变建筑物': 'Change Building',
  '上传进度': 'Upload Progress',
  '获取设备分类和用途': 'Get Device Classification and Purpose',
  '获取当前时间和处理人': 'Get Current Time and Handler',
  '请选择硬件版本号': 'Please Select Hardware Version Number',
  '固件版本号': 'Firmware Version Number',
  '主版本号子版本号': 'Main version number Sub version number Revised version number Build version No._YYMMDD; Each version number field occupies 2 decimal digits of data;',
  '主版本号子版本号1': 'For example: 1.02.03.01_180701; Main version number: 1; Sub version number: 02, revised version number:03, Build version: 01, compilation time: 180701',
  '型号': 'Model',
  '当前版本状态': 'Current Version Status',
  '最新版本': 'Latest Version',
  '非最新版本': 'Not Latest Version',
  '新增固件版本': 'Add Firmware Version',
  '编辑固件版本': 'Edit Firmware Version',
  '请先选择产品型号,硬件版本号。': 'Please Select Product Model First,Hardware Version Number.',
  '硬件版本号。': 'Hardware Version Number. ',
  '例如': 'E.g.',
  '请填写固件版本号': 'Please Fill in Firmware Version Number',
  '例': 'E.g. ',
  '主版本号': 'Major Version Number',
  '子版本号': 'Minor Version Number',
  '修正版本号': 'Revision Version Number',
  '每个版本号字段占用': 'Each version number field occupies ',
  '位': ' bits ',
  '进制数据；': 'base data;',
  '比如': 'For example, ',
  '版本为': 'version is ',
  '编译时间': 'Compilation Time',
  '升级方式': 'Upgrade Method',
  '请选择升级方式': 'Please Select Upgrade Method',
  '上传固件版本': 'Upload Firmware Version',
  '版本说明（中文）': 'Version Description (Chinese)',
  '请输入版本说明（中文）': 'Please Enter Version Description (Chinese)',
  '版本说明（英文）': 'Version Description (English)',
  '请输入版本说明（英文）': 'Please Enter Version Description (English)',
  '请求升级': 'Request Upgrade',
  '强制升级': 'Forced Upgrade',
  '项目号不能为空': 'Project Number Cannot Be Empty',
  '固件版本号不能为空': 'Firmware Version Number Cannot Be Empty',
  '请输入正确的固件版本号': 'Please Enter a Valid Firmware Version Number',
  '升级方式不能为空': 'Upgrade Method Cannot Be Empty',
  '固件版本不能为空': 'Firmware Version Cannot Be Empty',
  '固件大小不可超过': 'Firmware Size Cannot Exceed ',
  '检测中': 'Detecting',
  '改变后需要重新上传': 'Need to Re-upload After Change',
  '对应的对象': 'Corresponding Object',
  '检查上传': 'Check Upload',
  '测试数据': 'Test Data',
  '回车输入多个设备ID': 'Enter device ID, press enter to enter multiple device IDs',
  '获取第三个项目号': 'Get the Third Project Number',
  '允许在单词内换行': 'Allow Word Break Within Words',
  '同上，现代浏览器推荐使用这个属性别名': 'Same as above, modern browsers recommend using this property alias',
  '允许自动换行': 'Allow Automatic Word Wrap',
  '原版本': 'Original Version',
  '开始版本': 'Start Version',
  '结束版本': 'End Version',
  '目标版本': 'Target Version',
  '请输入目标版本': 'Please Enter Target Version',
  '开始升级时间：': 'Start Upgrade Time:',
  '请选择开始升级时间': 'Please Select Start Upgrade Time',
  '升级范围': 'Upgrade Scope',
  '请选择升级范围': 'Please Select Upgrade Scope',
  '方式': 'Method',
  '上传设备ID': 'Upload device ID',
  '上传设备ID文件': 'Upload device ID file (xls or xlsx file)',
  '请选择方式': 'Please Select Method',
  '输入设备': 'Enter Devices',
  '，回车输入多个设备': ', press Enter to input multiple devices',
  '上传设备': 'Upload Devices',
  '文件': 'File',
  '原版本的数据源': 'Original Version Data Source',
  '大于': 'Greater Than',
  '大于等于': 'Greater Than or Equal To',
  '等于': 'Equal To',
  '小于': 'Less Than',
  '小于等于': 'Less Than or Equal To',
  '指定设备': 'Specified Devices',
  '全部设备': 'All Devices',
  '导入设备': 'Import Devices',
  '设备ID不能为空': 'Device ID cannot be empty',
  '设备ID文件不能为空': 'The device ID file cannot be empty',
  '开始升级时间必须': 'Start Upgrade Time Must',
  '升级范围不能为空': 'Upgrade Scope Cannot Be Empty',
  '方式不能为空': 'Method Cannot Be Empty',
  '文件不能为空': 'File Cannot Be Empty',
  '检查目标版本开始': 'Check Target Version Start',
  '判断当前可选的目标版本和': 'Determine Currently Selectable Target Version and ',
  '的原版本': ' Original Version',
  '过滤目标版本的可选': 'Filter Selectable Target Versions',
  '及获取结束原版本的可选': 'and Get Selectable End Original Versions',
  '重置结束原版本与目标版本': 'Reset End Original Version and Target Version',
  '供拆分的过滤数组': 'Filter Array for Splitting',
  '被删除的数据': 'Deleted Data',
  '判断被符号': 'Determine if Symbol ',
  '目标版本与结束原版本所获得的结果': 'Result Obtained from Target Version and End Original Version',
  '过滤可选的目标版本': 'Filter Selectable Target Versions',
  '检查目标结束版本': 'Check Target End Version',
  '判断目标版本的可选项': 'Determine Selectable Options for Target Version',
  '重置开始原版本与目标版本': 'Reset Start Original Version and Target Version',
  '判断原版本的选中是否有效果': 'Determine if Original Version Selection is Valid',
  '开始目标版本与原版本所获得的结果': 'Result Obtained from Start Target Version and Original Version',
  '过滤可选的开始原版本': 'Filter Selectable Start Original Versions',
  '判断开始与结束的原版本，以获取可选择的目标版本': 'Determine Start and End Original Versions to Get Selectable Target Version',
  '需要重新选择目标版本': 'Need to Re-select Target Version',
  '过滤开始的原版本': 'Filter Start Original Versions',
  '判断目标版本是否有可选的范围中': 'Determine if Target Version Has Selectable Options in Range',
  '需要选择原版本开始版本': 'Need to Select Original Version Start Version',
  '时间改变': 'Time Changed',
  '输入': 'Input',
  '开始升级时间': 'Start Upgrade Time',
  '生效中': 'In Effect',
  '失效': 'Expired',
  '保存原版本的数据': 'Save Original Version Data',
  '你确定要删除此条规则吗？': 'Are you sure you want to delete this rule?',
  '新增升级规则': 'Add Upgrade Rule',
  '请选择升级规则': 'Please Select Upgrade Rule',
  '编辑升级规则': 'Edit Upgrade Rule',
  '文件名不能为空': 'File Name Cannot Be Empty',
  '代理商名称不能为空': 'Agent Name Cannot Be Empty',
  '分配数量': 'Allocation Quantity',
  '请输入分配数量': 'Please Enter Allocation Quantity',
  '请选择经销商': 'Please Select Distributor',
  '请选择出货区域': 'Please Select Shipment Region',
  '经销商不能为空': 'Distributor Cannot Be Empty',
  '分配区域': 'Allocation Region',
  '超出区域报警设备数量': 'Number of Alarms Exceeding Region Device Count',
  '设备新增激活统计': 'New Device Activation Statistics',
  '请选择起始月份': 'Please Select Start Month',
  '请选择结束月份': 'Please Select End Month',
  '每月激活设备': 'Monthly Activated Devices',
  '（经销商）': '(Distributor)',
  '（区域）': '(Region)',
  '设备激活曲线': 'Device Activation Curve',
  '拉取统计数据': 'Pull Statistics Data',
  '设备累计上线统计': 'Cumulative Device Online Statistics',
  '每月上线设备': 'Monthly Online Devices',
  '每上线设备': 'Per Online Device',
  '设备上线曲线': 'Device Online Curve',
  '我的数据': 'My Data',
  '我的数据用户': 'My Data User',
  '设备名称筛选': 'Device Name Filter',
  '查看设备': 'View Device',
  '申诉': 'Appeal',
  '您确定要删除设备': 'Are you sure you want to delete device ',
  '服务器': 'Server',
  '用户手机号': 'User Mobile Number',
  '手机号筛选': 'Mobile Number Filter',
  '用户邮箱': 'User Email',
  '邮箱筛选': 'Email Filter',
  '注册时间': 'Registration Time',
  '上次登录': 'Last Login',
  '在线状态': 'Online Status',
  '防制区域': 'Pest Control Area',
  '楼层管理': 'Floor Management',
  '请输入项目名称': 'Please Enter Project Name',
  '请输入客户负责人': 'Please Enter Customer Responsible Person',
  '请输入合同编号': 'Please Enter Contract Number',
  '请选择合同期限': 'Please Select Contract Term',
  '请选择维保人员': 'Please Select Maintenance Personnel',
  '请输入维保周期': 'Please Enter Maintenance Cycle',
  '请选择维保开始时间': 'Please Select Maintenance Start Time',
  '上传影像图': 'Upload Image',
  '切换成宫格': 'Switch to Grid',
  '切换成表格': 'Switch to Table',
  '公司名称搜索': 'Company Name Search',
  '暂无公司': 'No Company Yet',
  '进入项目': 'Enter Project',
  '删除防制分类': 'Delete Pest Control Classification',
  '新增防制分类': 'Add Pest Control Classification',
  '分类名称': 'Classification Name',
  '请输入分类名称': 'Please Enter Classification Name',
  '分类名称不能为空': 'Classification Name Cannot Be Empty',
  '行号': 'Row Number',
  '失败原因': 'Failure Reason',
  '平面图列表': 'Floor Plan List',
  '获取设置时的宽度高度': 'Get Width and Height at Setting Time',
  '改变平面图': 'Change Floor Plan',
  '请输入设备名称': 'Please Enter Device Name',
  '请输入设备编号': 'Please Enter Device Number',
  '通信方式': 'Communication Method',
  '请选择通信方式': 'Please Select Communication Method',
  '请选择设备用途': 'Please Select Device Purpose',
  '请选择平面图': 'Please Select Floor Plan',
  '请选择楼层': 'Please Select Floor',
  '上传设备图': 'Upload Device Image',
  '平面图编码': 'Floor Plan Code',
  '设备名称不能为空': 'Device Name Cannot Be Empty',
  '设备编码不能为空': 'Device Code Cannot Be Empty',
  '通信方式不能为空': 'Communication Method Cannot Be Empty',
  '设备用途不能为空': 'Device Purpose Cannot Be Empty',
  '项目不能为空': 'Project Cannot Be Empty',
  '楼层不能为空': 'Floor Cannot Be Empty',
  '现场位置不能为空': 'On-site Location Cannot Be Empty',
  '设备图不能为空': 'Device Image Cannot Be Empty',
  '设置平面图': 'Set Floor Plan',
  '平面图修改': 'Floor Plan Modification',
  '设置楼层': 'Set Floor',
  '控制设置': 'Control Settings',
  '开灯时间': 'Light On Time',
  '请选择开灯时间': 'Please Select Light On Time',
  '继续添加': 'Continue Adding',
  '定时拍摄': 'Timed Capture',
  '请选择定时拍摄': 'Please Select Timed Capture',
  '灯管寿命': 'Lamp Life',
  '请输入灯管寿命': 'Please Enter Lamp Life',
  '粘板寿命': 'Sticky Board Life',
  '请输入粘板寿命': 'Please Enter Sticky Board Life',
  '粘板报警值': 'Sticky Board Alarm Threshold',
  '请输入单板报警值': 'Please Enter Single Board Alarm Threshold',
  '只': '',
  '密度预警差值': 'Density Warning Difference',
  '请输入密度预警差值': 'Please Enter Density Warning Difference',
  '事件记录': 'Event Record',
  '暂无事件记录': 'No Event Records Yet',
  '运行状态': 'Operation Status',
  '最近': 'Recent ',
  '紫外线灯已运行': 'UV Lamp Has Run',
  '紫外线强度': 'UV Intensity',
  '闭': 'Closed',
  '粘板已使用': 'Sticky Board Used',
  '蝇害密度分析': 'Fly Pest Density Analysis',
  '实时查看': 'Real-time View',
  '关联控制': 'Associated Control',
  '防制趋势图': 'Pest Control Trend Chart',
  '检查固件版本': 'Check Firmware Version',
  '更换': 'Replace',
  '请输入更换': 'Please Enter Replacement',
  '最近一个月': 'Last Month',
  '最近三个月': 'Last Three Months',
  '最近半年': 'Last Half Year',
  '最近一年': 'Last Year',
  '最近三年': 'Last Three Years',
  '虫害各类': 'Pest Categories',
  '数量': 'Quantity',
  '与上次对比': 'Compared to Last Time',
  '增长率': 'Growth Rate',
  '飞虫列表数据': 'Flying Insect List Data',
  '是否可以升级': 'Whether Can Be Upgraded',
  '开机时间不能为空': 'Power On Time Cannot Be Empty',
  '定时拍摄不能为空': 'Timed Capture Cannot Be Empty',
  '灯管寿命不能为空': 'Lamp Life Cannot Be Empty',
  '粘板寿命不能为空': 'Sticky Board Life Cannot Be Empty',
  '单板报警值不能为空': 'Single Board Alarm Threshold Cannot Be Empty',
  '密度预警差值不能为空': 'Density Warning Difference Cannot Be Empty',
  '加载是否有版本更新': 'Load Whether There is Version Update',
  '分类': 'Classification',
  '密度分析时间修改': 'Density Analysis Time Modification',
  '跑马灯': 'Marquee',
  '拼接多曲线数据': 'Concatenate Multiple Curve Data',
  '较上次增长': 'Increased Compared to Last Time',
  '抓拍时间不能为空': 'Capture Time Cannot Be Empty',
  '趋势图': 'Trend Chart',
  '调用事件记录接口': 'Call Event Record Interface',
  '运动状态': 'Motion Status',
  '在离线': 'Online/Offline',
  '运行时间': 'Running Time',
  '紫外线开关': 'UV Switch',
  '判断是左侧还是右侧进入': 'Determine if Entering from Left or Right',
  '高温恢复': 'High Temperature Recovery',
  '无方法': 'No Method',
  '左向侵入': 'Leftward Intrusion',
  '右向侵入': 'Rightward Intrusion',
  '心跳': 'Heartbeat',
  '获取固件信息': 'Get Firmware Information',
  '获取控制配置信息': 'Get Control Configuration Information',
  '所属防治区域筛选': 'Belonging Pest Control Area Filter',
  '导入结果列表': 'Import Result List',
  '所属防治区域': 'Belonging Pest Control Area',
  '电池电量': 'Battery Level',
  '请选添加防制分类': 'Please Select Add Pest Control Classification',
  '导入数据': 'Import Data',
  '失败详情': 'Failure Details',
  '导入状态': 'Import Status',
  '上传成功': 'Upload Successful',
  '导入中': 'Importing',
  '导入成功': 'Import Successful',
  '部分导入成功': 'Partially Imported Successfully',
  '全部导入失败': 'All Import Failed',
  '导入开始时间': 'Import Start Time',
  '导入结束时间': 'Import End Time',
  '维保人员筛选': 'Maintenance Personnel Filter',
  '全部维保类型': 'All Maintenance Types',
  '当前所选项': 'Currently Selected Item',
  '定期维保': 'Regular Maintenance',
  '临时维保': 'Temporary Maintenance',
  '执行中': 'Executing',
  '未审核': 'Not Reviewed',
  '已审核': 'Reviewed',
  '批量下载': 'Batch Download',
  '维保报告': 'Maintenance Report',
  '维保类型': 'Maintenance Type',
  '开始照片': 'Start Photo',
  '结束照片': 'End Photo',
  '维保状态': 'Maintenance Status',
  '请选择需要加载的维保信息': 'Please Select Maintenance Information to Load',
  '选择发生变化': 'Selection Changed',
  '暂无图片': 'No Image Yet',
  '下载维保': 'Download Maintenance',
  '您确定要下载此的维保吗': 'Are you sure you want to download this maintenance?',
  '审核结果': 'Review Result',
  '审核详情': 'Review Details',
  '项目：': 'Project:',
  '负责人：': 'Responsible Person:',
  '联系电话：': 'Contact Phone:',
  '服务报告——': 'Service Report —— ',
  '定期': 'Regular',
  '临时': 'Temporary',
  '服务人员：': 'Service Personnel:',
  '服务日期：': 'Service Date:',
  '开始时间：': 'Start Time:',
  '结束时间：': 'End Time:',
  '区域环境检查': 'Area Environment Check',
  '发现': 'Found',
  '风险害虫': 'Risk Pests',
  '风险级别': 'Risk Level',
  '处理建议': 'Handling Suggestions',
  '照片': 'Photos',
  '暂无内容': 'No Content Yet',
  '维保信息汇总': 'Maintenance Information Summary',
  '防治分类': 'Pest Control Classification',
  '活动迹象': 'Activity Signs',
  '更换物品': 'Replacement Items',
  '有': 'Yes',
  '粘板': 'Sticky Board',
  '饵剂': 'Bait',
  '配件': 'Accessories',
  '物料更换统计': 'Material Replacement Statistics',
  '物料名称': 'Material Name',
  '规格': 'Specification',
  '使用位置': 'Usage Location',
  '防治设备分类': 'Pest Control Device Classification',
  '设备详情': 'Device Details',
  '害虫': 'Pests',
  '维保时间': 'Maintenance Time',
  '种类、数量': 'Species, Quantity',
  '更换、数量': 'Replacement, Quantity',
  '施药防控信息': 'Pesticide Application Control Information',
  '登记证号': 'Registration Certificate Number',
  '生产批号': 'Production Batch Number',
  '使用量': 'Usage Amount',
  '有效成分': 'Active Ingredient',
  '靶标害虫': 'Target Pest',
  '应用方法': 'Application Method',
  '应用位置': 'Application Location',
  '合同号': 'Contract Number',
  '服务项目': 'Service Project',
  '服务日期': 'Service Date',
  '服务类型': 'Service Type',
  '人员签字': 'Personnel Signature',
  '人员签字【手写】': 'Personnel Signature [Handwritten]',
  '客户签字': 'Customer Signature',
  '客户签字【手写】': 'Customer Signature [Handwritten]',
  '《沛城能源管理平台》': '"Peicheng Energy Management Platform"',
  '打开之前': 'Before Opening',
  '执行了打印': 'Executed Print',
  '关闭了打印工具': 'Closed Print Tool',
  '负责人': 'Responsible Person',
  '服务人员': 'Service Personnel',
  '获取维保报告': 'Get Maintenance Report',
  '环境检测信息': 'Environmental Detection Information',
  '请选择审核状态': 'Please Select Review Status',
  '审核说明': 'Review Description',
  '请输入审核说明': 'Please Enter Review Description',
  '审核人员': 'Reviewer',
  '请输入审核人员': 'Please Enter Reviewer',
  '审核未通过': 'Review Not Passed',
  '审核状态不能为空': 'Review Status Cannot Be Empty',
  '审核说明不能为空': 'Review Description Cannot Be Empty',
  '审核人员不能为空': 'Reviewer Cannot Be Empty',
  '出库': 'Outbound',
  '请上传资料': 'Please Upload Materials',
  '确认': 'Confirm',
  '只有在验证通过时关闭对话框': 'Close Dialog Only When Validation Passes',
  '请填写所有必填项': 'Please Fill in All Required Fields',
  '提示用户': 'Prompt User',
  '编辑硬件版本': 'Edit Hardware Version',
  '请求接口的链接': 'Link to Request Interface',
  '用户相关接口': 'User Related Interfaces',
  '登录接口': 'Login Interface',
  '修改账号状态': 'Modify Account Status',
  '获取当前用户信息': 'Get Current User Information',
  '获取地区省市县': 'Get Region, Province, City, County',
  '登录成功获取当前用户菜单': 'Get Current User Menu After Successful Login',
  '解除锁屏': 'Unlock Screen',
  '修改密码': 'Change Password',
  '获取呼叫方式': 'Get Calling Method',
  '获取当前用户的角色信息': 'Get Current User\'s Role Information',
  '根据姓名获取账号信息': 'Get Account Information Based on Name',
  '修改查看工资密码': 'Modify Password for Viewing Salary',
  '设置登录人座右铭': 'Set Logged-in User\'s Motto',
  '设置头像': 'Set Avatar',
  '注册商家账号': 'Register Merchant Account',
  '获取短信验证码': 'Get SMS Verification Code',
  '保存基本信息': 'Save Basic Information',
  '变更账号': 'Change Account',
  '实名认证提交': 'Real-name Authentication Submission',
  '企业认证': 'Enterprise Authentication',
  '企业认证倒计时': 'Enterprise Authentication Countdown',
  '实名认证倒计时': 'Real-name Authentication Countdown',
  '共用的接口': 'Shared Interfaces',
  '上传图片文件': 'Upload Image File',
  '上传其他文件': 'Upload Other Files',
  '获取客户资质标签数据': 'Get Customer Qualification Tag Data',
  '获取可导入客户部门列表': 'Get Importable Customer Department List',
  '根据文件标识获取文件信息': 'Get File Information Based on File Identifier',
  '获得组织树': 'Get Organization Tree',
  '根据部门': 'Based on Department ',
  '获取部门的下一级部门列表和部门及下属所有部门的人员信息': 'Get the next level department list of the department and personnel information for the department and all subordinate departments',
  '反馈开始': 'Feedback Start',
  '添加反馈': 'Add Feedback',
  '回复反馈': 'Reply to Feedback',
  '查询反馈列表': 'Query Feedback List',
  '反馈结束': 'Feedback End',
  '新增机构': 'Add Institution',
  '机构列表': 'Institution List',
  '编辑机构': 'Edit Institution',
  '删除机构': 'Delete Institution',
  '保存机构介绍': 'Save Institution Introduction',
  '新增机构密码': 'Add Institution Password',
  '编辑机构密码': 'Edit Institution Password',
  '删除机构编码': 'Delete Institution Code',
  '导入机构密码文件': 'Import Institution Password File',
  '新增咨询师': 'Add Consultant',
  '获取咨询师列表': 'Get Consultant List',
  '编辑咨询师': 'Edit Consultant',
  '删除咨询师': 'Delete Consultant',
  '新增专题': 'Add Topic',
  '专题列表': 'Topic List',
  '编辑专题': 'Edit Topic',
  '删除专题': 'Delete Topic',
  '获取密码列表和专题列表': 'Get Password List and Topic List',
  '获取题库列表': 'Get Question Bank List',
  '删除题库': 'Delete Question Bank',
  '下载题库': 'Download Question Bank',
  '评测记录列表': 'Evaluation Record List',
  '导出试卷': 'Export Test Paper',
  '下载试卷': 'Download Test Paper',
  '咨询师分析': 'Consultant Analysis',
  '用户分析': 'User Analysis',
  '导出数据详情': 'Export Data Details',
  '预约记录': 'Appointment Record',
  '公开课列表': 'Public Course List',
  '新增公开课': 'Add Public Course',
  '启用禁用': 'Enable/Disable',
  '编辑公开课': 'Edit Public Course',
  '删除公开课': 'Delete Public Course',
  '导出预约记录': 'Export Appointment Record',
  '审核预约记录': 'Review Appointment Record',
  '新增分类': 'Add Category',
  '获取模块列表': 'Get Module List',
  '编辑模块': 'Edit Module',
  '获取接口列表': 'Get Interface List',
  '根据模块名称获取接口列表': 'Get Interface List Based on Module Name',
  '新增菜单或页面': 'Add Menu or Page',
  '获取菜单列表': 'Get Menu List',
  '菜单列表接口配置时获取基本数据': 'Get Basic Data When Configuring Menu List Interface',
  '菜单接口配置时执行保存操作': 'Perform Save Operation When Configuring Menu Interface',
  '角色权限配置获取基本数据': 'Get Basic Data for Role Permission Configuration',
  '新增子账号': 'Add Sub-account',
  '禁用启用子账号': 'Disable/Enable Sub-account',
  '编辑子账号': 'Edit Sub-account',
  '获取子账号列表': 'Get Sub-account List',
  '账号管理': 'Account Management',
  '权限配置页面（获取菜单列表和接口列表）': 'Permission Configuration Page (Get Menu List and Interface List)',
  '配置账号的权限': 'Configure Account Permissions',
  '获取自己的角色列表': 'Get Own Role List',
  '设置默认角色': 'Set Default Role',
  '新增项目': 'Add Project',
  '编辑项目': 'Edit Project',
  '删除项目': 'Delete Project',
  '获取人员列表': 'Get Personnel List',
  '删除人员': 'Delete Personnel',
  '新增建筑物': 'Add Building',
  '编辑建筑物': 'Edit Building',
  '删除建筑物': 'Delete Building',
  '新增楼层': 'Add Floor',
  '编辑楼层': 'Edit Floor',
  '删除楼层': 'Delete Floor',
  '防制分类列表': 'Pest Control Classification List',
  '编辑防制分类': 'Edit Pest Control Classification',
  '新增设备': 'Add Device',
  '编辑设备': 'Edit Device',
  '删除设备': 'Delete Device',
  '获取告警相关下': 'Get Related to Alarms',
  '获取告警列表': 'Get Alarm List',
  '删除告警': 'Delete Alarm',
  '维保管理列表': 'Maintenance Management List',
  '审核维保记录': 'Review Maintenance Record',
  '下载维保报告': 'Download Maintenance Report',
  '查看维保报告': 'View Maintenance Report',
  '左上角设备统计': 'Top Left Device Statistics',
  '中边中部报警统计': 'Center Middle Alarm Statistics',
  '获取左下角近一年新增设备': 'Get Bottom Left Newly Added Devices in Recent Year',
  '右侧底部项目列表（中部经纬度）统计': 'Bottom Right Project List (Center Coordinates) Statistics',
  '获取下载': 'Get Download',
  '当前用户修改密码': 'Current User Change Password',
  '打包下载维保报告': 'Package Download Maintenance Report',
  '导入的文件列表': 'Imported File List',
  '查看失败的行': 'View Failed Rows',
  '获取控制设置内容': 'Get Control Setting Content',
  '秒后拉取图片到本地': 'Pull Image to Local After Seconds',
  '获取公司列表': 'Get Company List',
  '设备分销管理列表接口': 'Device Distribution Management List Interface',
  '区域列表': 'Region List',
  '经销商列表': 'Distributor List',
  '分配详情': 'Allocation Details',
  '设备详细信息列表': 'Device Detail Information List',
  '新增经销商': 'Add Distributor',
  '编辑经销商': 'Edit Distributor',
  '删除经销商': 'Delete Distributor',
  '获取分类': 'Get Classification',
  '新增字典': 'Add Dictionary',
  '删除字典': 'Delete Dictionary',
  '字典列表': 'Dictionary List',
  '设置默认': 'Set as Default',
  '编辑字典': 'Edit Dictionary',
  '删除历史记录': 'Delete History',
  '首页数据': 'Homepage Data',
  '设置设备信息': 'Set Device Information',
  '拉取一级，二级数据': 'Pull Primary, Secondary Data',
  '下发命令': 'Issue Command',
  '监测新固件': 'Monitor New Firmware',
  '下发升级固件命令': 'Issue Firmware Upgrade Command',
  '协议列表': 'Protocol List',
  '上传固件': 'Upload Firmware',
  '固件升级进度': 'Firmware Upgrade Progress',
  '关于设备下拉': 'About Device Dropdown',
  '设置时区': 'Set Time Zone',
  '列表': 'List',
  '修改平台': 'Modify Platform',
  '获取有效时间': 'Get Valid Time',
  '获取有效时间表格数据': 'Get Valid Time Table Data',
  '生成配网二维码': 'Generate Network Configuration QR Code',
  '下载记录': 'Download Record',
  '删除下载': 'Delete Download',
  '获取左侧数据': 'Get Left Side Data',
  '获取右侧折线图': 'Get Right Side Line Chart',
  '获取右侧下角': 'Get Bottom Right Corner',
  '生产管理列表': 'Production Management List',
  '生产管理项目号下拉列表': 'Production Management Project Number Dropdown List',
  '生产管理预览': 'Production Management Preview',
  '生产管理关联': 'Production Management Association',
  '获取菜单': 'Get Menu',
  '首页总览统计数据': 'Homepage Overview Statistics',
  '服务统计数据': 'Service Statistics',
  '用户统计数据': 'User Statistics',
  '产品统计数据': 'Product Statistics',
  '删除子账号': 'Delete Sub-account',
  '获取所有角色列表': 'Get All Role List',
  '角色权限配置': 'Role Permission Configuration',
  '保存操作': 'Save Operation',
  '删除角色': 'Delete Role',
  '获取角色列表': 'Get Role List',
  '获取模块列表（新增接口时）': 'Get Module List (When Adding Interface)',
  '删除区域': 'Delete Region',
  '删除商户': 'Delete Merchant',
  '首页统计': 'Homepage Statistics',
  '计划列表': 'Plan List',
  '删除计划': 'Delete Plan',
  '编辑计划': 'Edit Plan',
  '检测固件新版本': 'Detect New Firmware Version',
  '下发升级固件指令': 'Issue Firmware Upgrade Instruction',
  '设置采样频率': 'Set Sampling Frequency',
  '设置逆变器': 'Set Inverter',
  '轨迹信息设备列表': 'Trajectory Information Device List',
  '获取设备当前位置': 'Get Device Current Position',
  '获取容量趋势图': 'Get Capacity Trend Chart',
  '获取运行趋势图': 'Get Operation Trend Chart',
  '轨迹信息轨迹': 'Trajectory Information Trajectory',
  '协议新增': 'Protocol Add',
  '协议删除': 'Protocol Delete',
  '产品新增': 'Product Add',
  '产品列表': 'Product List',
  '项目密码管理': 'Project Password Management',
  '设备密码管理': 'Device Password Management',
  '新增硬件版本号': 'Add Hardware Version Number',
  '硬件版本号列表': 'Hardware Version Number List',
  '产品删除': 'Product Delete',
  '硬件版本号编辑': 'Hardware Version Number Edit',
  '硬件版本号删除': 'Hardware Version Number Delete',
  '固件版本列表': 'Firmware Version List',
  '固件版本删除': 'Firmware Version Delete',
  '升级规则列表': 'Upgrade Rule List',
  '升级规则删除': 'Upgrade Rule Delete',
  '设备下拉相关': 'Device Dropdown Related',
  '获取通讯组列表': 'Get Communication Group List',
  '获取所有枚举': 'Get All Enums',
  '获取文件': 'Get File',
  '请求接口公用': 'Request Interface Public',
  '机构密码列表': 'Institution Password List',
  '专题列表添加': 'Topic List Add',
  '导入试题文件（': 'Import Test Question File (',
  '评测记录详情': 'Evaluation Record Details',
  '专题分析': 'Topic Analysis',
  '导出测评记录': 'Export Evaluation Record',
  '编辑人员': 'Edit Personnel',
  '新增人员': 'Add Personnel',
  '获取告警相关下拉': 'Get Alarm Related Dropdown',
  '在离线记录': 'Online/Offline Record',
  '拉取图片到': 'Pull Image to ',
  '服务器接口': 'Server Interface',
  '改变': 'Change',
  '如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用': 'If your logout does not require an interface request, you can directly use the following three lines of code without using ',
  '调用接口': 'Call Interface',
  '获取用户相关信息': 'Get User Related Information',
  '此方法用来获取未读消息条数，接口只返回数值，不返回消息列表': 'This method is used to get the number of unread messages. The interface only returns the number, not the message list.',
  '获取消息列表，其中包含未读、已读、回收站三个列表': 'Get the message list, which contains three lists: unread, read, recycle bin.',
  '根据当前点击的消息的': 'Based on the ',
  '获取内容': ' of the currently clicked message, get the content',
  '把一个未读消息标记为已读': 'Mark an unread message as read',
  '删除一个已读消息到回收站': 'Delete a read message to the recycle bin',
  '还原一个已删除消息到已读消息': 'Restore a deleted message to read messages',
  '检查客户号码是否属于当前账号': 'Check if customer number belongs to current account',
  '添加客户基本信息': 'Add Customer Basic Information',
  '获取子项目的': 'Get Sub-project\'s ',
  '判断是否是数组': 'Determine if is Array',
  '获取路由': 'Get Route',
  '首页名称': 'Homepage Name',
  '首页列表': 'Homepage List',
  '所有的微服务的菜单': 'All Microservices\' Menus',
  '设置首页名称': 'Set Homepage Name',
  '设置菜单': 'Set Menu',
  '获取所有的菜单': 'Get All Menus',
  '所有枚举类型': 'All Enum Types',
  '导入部门列表': 'Import Department List',
  '客户标签': 'Customer Tags',
  '消息列表': 'Message List',
  '可允许的跟进时间': 'Allowable Follow-up Time',
  '组织树': 'Organization Tree',
  '添加一个消息列表': 'Add a Message List',
  '删除一条队列消息': 'Delete a Queue Message',
  '设置客户来源': 'Set Customer Source',
  '设置导入部门数据': 'Set Import Department Data',
  '获取配置项值': 'Get Configuration Item Value',
  '设置级联树': 'Set Cascading Tree',
  '获取所有枚举类型': 'Get All Enum Types',
  '获取客户来源': 'Get Customer Source',
  '请求参数': 'Request Parameters',
  '获取配置项': 'Get Configuration Item',
  '确定要关闭这一页吗': 'Confirm to close this page?',
  '查看维保': 'View Maintenance',
  '叉车': 'Forklift',
  '设备轨迹': 'Device Trajectory',
  '设备轨迹查询': 'Device Trajectory Query',
  '告警管理': 'Alert Management',
  '逆变器字典': 'Inverter Dictionary',
  '硬件版本': 'Hardware Version',
  '报警总览': 'Alarm Overview',
  '维保总览': 'Maintenance Overview',
  '有权限，可访问': 'Have permission, can access',
  '无权限，重定向到': 'No permission, redirect to ',
  '未登录且要跳转的页面不是登录页': 'Not logged in and the page to jump to is not the login page',
  '未登录且要跳转的页面是登录页': 'Not logged in and the page to jump to is the login page',
  '跳转到登录页': 'Jump to login page',
  '已登录且要跳转的页面是登录页': 'Logged in and the page to jump to is the login page',
  '跳转到': 'Jump to ',
  '除了原生参数外可配置的参数': 'Configurable parameters besides native parameters',
  '显示在侧边栏、面包屑和标签栏的文字': 'Text displayed in sidebar, breadcrumbs, and tab bar',
  '多语言字段': 'Multi-language field',
  '形式结合多语言使用，例子看多语言的路由配置': 'Used in combination with multi-language. See multi-language route configuration for examples.',
  '可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由': 'A callback function can be passed in, with the parameter being the current route object. See dynamic routes and routes with parameters for examples.',
  '后此级路由将不会出现在面包屑中，示例看': 'After this, this level route will not appear in breadcrumbs. Example see ',
  '群路由配置': 'Group Route Configuration',
  '后在左侧菜单不会显示该页面选项': 'After this, this page option will not be displayed in the left menu',
  '后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件': 'After this, the page will not be cached after switching tabs. If caching is needed, do not set this field, and the page component needs to set ',
  '属性和路由配置的': ' attribute and the route configuration\'s ',
  '一致': ' must match',
  '可访问该页面的权限数组，当前路由设置的权限会影响子路由': 'Array of permissions to access this page. Permissions set on the current route affect child routes.',
  '该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线': 'The icon displayed for this page in the left menu, breadcrumbs, and tab navigation. If it is a custom icon, prefix the icon name with an underscore.',
  '设置该字段，则在关闭当前': 'Setting this field will, when closing the current ',
  '页时会去': ' page, go to ',
  '里寻找该字段名对应的方法，作为关闭前的钩子函数': ' to find the method corresponding to this field name, as a hook function before closing.',
  '首页': 'Home',
  '设备导入列表': 'Device Import List',
  '错误收集': 'Error Collection',
  "产品图": "Product Image",
  "产品型号": "Product Model",
  "设备": "Device",
  "状态": "Status",
  "操作": "Operation",
  "自动根据浏览器系统语言设置语言": "Auto-set language based on browser system language",
  "写法": "Syntax",
  "协议列表名称筛选": "Protocol List Name Filter",
  "通道": "Channel",
  "未分配": "Unassigned",
  "已分配": "Assigned",
  "产品类型不能为空": "Product type cannot be empty",
  "硬件版本号不能为空": "Hardware version cannot be empty",
  "备注不能为空": "Notes cannot be empty",
  "产品名称必须": "Product name is required",
  "产品项目号必须": "Product project number is required",
  "硬件版本号必须": "Hardware version is required",
  "协议配置必须": "Protocol configuration is required",
  "协议列表名称必须": "Protocol list name is required",
  "说明": "Description",
  "请选择协议列表名称": "Please select protocol list name",
  "协议列表名称": "Protocol List Name",
  "新建产品（产品模型）": "New Product (Product Model)",
  "协议配置": "Protocol Configuration",
  "产品名称": "Product Name",
  "产品项目号": "Product Project Number",
  "请输入产品项目号": "Please enter product project number",
  "高压户储": "High Voltage Residential Storage",
  "低压户储": "Low Voltage Residential Storage",
  "逆变器": "Inverter",
  "请选择产品名称": "Please select product name",
  "请选择协议配置": "Please select protocol configuration",
  "默认": "Default",
  "自定义": "Custom",
  "全部": "All",
  "新增硬件版本": "Add Hardware Version",
  "请选择产品类型": "Please select product type",
  "产品类型": "Product Type",
  "请输入硬件版本号": "Please enter hardware version number",
  "硬件版本号筛选": "Hardware Version Filter",
  "请选择产品型号": "Please select product model",
  "导出产测成功设备": "Export Production Test Passed Devices",
  "暂无数据": "No Data Available",
  "请选择代理商": "Please select distributor",
  "请输入设备": "Please enter device",
  "设备名称": "Device Name",
  "批量分配": "Batch Assign",
  "搜索": "Search",
  "生产管理": "Production Management",
  "出库管理": "Outbound Management",
  "资料下载": "Document Download",
  "告警内容": "Alarm Content",
  "告警时间": "Alarm Time",
  "？": "?",
  "设备信息": "Device Information",
  "堆数据": "Stack Data",
  "刷新频率更改": "Refresh Rate Change",
  "簇数据": "Cluster Data",
  "单体数据": "Cell Data",
  "固件升级": "Firmware Upgrade",
  "产品品类": "Product Category",
  "当前选择的": "Currently Selected",
  "家储": "Home Storage",
  "基站": "Base Station",
  "高压": "High Voltage",
  "无从机系统": "No Slave System",
  "有从机系统，且本机为主机": "Slave System Exists, This Device is Master",
  "有从机系统，且本机为从机": "Slave System Exists, This Device is Slave",
  "项目号": "Project Number",
  "用作设备管理显示": "Used for Device Management Display",
  "协议版本号": "Protocol Version",
  "外部软件版本号": "External Software Version",
  "内部软件版本号": "Internal Software Version",
  "软件开发版本号": "Software Development Version",
  "系统": "System",
  "配网显示名称": "Networking Display Name",
  "配网": "Networking",
  "当前选择的串口逆变器": "Currently Selected Serial Inverter",
  "当前选择的网络逆变器": "Currently Selected Network Inverter",
  "参数设置": "Parameter Settings",
  "历史记录": "History",
  "告警数据": "Alarm Data",
  "密码管理": "Password Management",
  "历史轨迹": "Historical Trajectory",
  "无": "None",
  "单体高压": "Cell High Voltage",
  'MOS高温':'MOS high temperature',
  "保护值": "Protection Value",
  "保护延时": "Protection Delay",
  "保护恢复值": "Protection Recovery Value",
  "保护恢复延时": "Protection Recovery Delay",
  "单体低压": "Cell Low Voltage",
  "电池簇总体高压": "Battery Cluster Overall High Voltage",
  "电池簇总体低压": "Battery Cluster Overall Low Voltage",
  "充电过流": "Charging Overcurrent",
  "充电过流1": "Charging Overcurrent1",
  "充电过流2": "Charging Overcurrent2",
  "放电过流": "Discharging Overcurrent",
  "放电过流1": "Discharging Overcurrent1",
  "放电过流2": "Discharging Overcurrent2",
  "充电高温": "Charging High Temperature",
  "充电低温": "Charging Low Temperature",
  "放电高温": "Discharging High Temperature",
  "放电低温": "Discharging Low Temperature",
  "充电温差": "Charging Temperature Difference",
  "放电温差": "Discharging Temperature Difference",
  "电芯温升": "Cell Temperature Rise",
  "高": "High",
  "低": "Low",
  "正极绝缘漏电": "Positive Pole Insulation Leakage",
  "负极绝缘漏电": "Negative Pole Insulation Leakage",
  "环境高温": "Ambient High Temperature",
  "环境低温": "Ambient Low Temperature",
  "充电压差": "Charging Voltage Difference",
  "放电压差": "Discharging Voltage Difference",
  "端子高温": "Terminal High Temperature",
  "开启风扇": "Turn On Fan",
  "环境温度": "Ambient Temperature",
  "端子温度": "Terminal Temperature",
  "关闭风扇": "Turn Off Fan",
  "电芯故障": "Cell Fault",
  "满充截止电压": "Full Charge Cut-off Voltage",
  "满充截止电流": "Full Charge Cut-off Current",
  "低告警值": "Low Alarm Value",
  "满充": "Full Charge",
  "释放值": "Release Value",
  "均衡开启电压": "Balance Enable Voltage",
  "均衡开启压差": "Balance Enable Voltage Difference",
  "设计容量": "Design Capacity",
  "剩余容量": "Remaining Capacity",
  "满充容量": "Full Charge Capacity",
  "短路保护延时": "Short Circuit Protection Delay",
  "掉电单体电压": "Power-off Cell Voltage",
  "掉电总体电压": "Power-off Overall Voltage",
  "掉电延时时间": "Power-off Delay Time",
  "单体高压告警值": "Cell High Voltage Alarm Value",
  "单体高压保护值": "Cell High Voltage Protection Value",
  "单体高压保护延时": "Cell High Voltage Protection Delay",
  "单体高压恢复值": "Cell High Voltage Recovery Value",
  "单体低压告警值": "Cell Low Voltage Alarm Value",
  "单体低压保护值": "Cell Low Voltage Protection Value",
  "单体低压保护延时": "Cell Low Voltage Protection Delay",
  "单体低压恢复值": "Cell Low Voltage Recovery Value",
  "总体高压告警": "Overall High Voltage Alarm",
  "总体高压保护值": "Overall High Voltage Protection Value",
  "总体高压保护延时": "Overall High Voltage Protection Delay",
  "总体高压恢复值": "Overall High Voltage Recovery Value",
  "总体低压告警": "Overall Low Voltage Alarm",
  "总体低压保护值": "Overall Low Voltage Protection Value",
  "总体低压保护延时": "Overall Low Voltage Protection Delay",
  "总体低压恢复值": "Overall Low Voltage Recovery Value",
  "充电过流告警值": "Charging Overcurrent Alarm Value",
  "充电过流保护值": "Charging Overcurrent Protection Value",
  "充电过流保护延时": "Charging Overcurrent Protection Delay",
  "放电过流告警值": "Discharging Overcurrent Alarm Value",
  "放电过流保护值": "Discharging Overcurrent Protection Value",
  "放电过流保护延时": "Discharging Overcurrent Protection Delay",
  "充电高温告警值": "Charging High Temperature Alarm Value",
  "充电高温保护值": "Charging High Temperature Protection Value",
  "充电高温恢复值": "Charging High Temperature Recovery Value",
  "充电低温告警值": "Charging Low Temperature Alarm Value",
  "充电低温保护值": "Charging Low Temperature Protection Value",
  "充电低温恢复值": "Charging Low Temperature Recovery Value",
  "放电高温告警值": "Discharging High Temperature Alarm Value",
  "放电高温保护值": "Discharging High Temperature Protection Value",
  "放电高温恢复值": "Discharging High Temperature Recovery Value",
  "放电低温告警值": "Discharging Low Temperature Alarm Value",
  "放电低温保护值": "Discharging Low Temperature Protection Value",
  "放电低温恢复值": "Discharging Low Temperature Recovery Value",
  "环境高温告警值": "Ambient High Temperature Alarm Value",
  "环境高温保护值": "Ambient High Temperature Protection Value",
  "环境高温恢复值": "Ambient High Temperature Recovery Value",
  "环境低温告警值": "Ambient Low Temperature Alarm Value",
  "环境低温保护值": "Ambient Low Temperature Protection Value",
  "环境低温恢复值": "Ambient Low Temperature Recovery Value",
  "高温告警值": "High Temperature Alarm Value",
  "高温保护值": "High Temperature Protection Value",
  "高温保护恢复值": "High Temperature Protection Recovery Value",
  "休眠单体电压": "Sleep Cell Voltage",
  "休眠延时时间": "Sleep Delay Time",
  "弱电开关": "Weak Power Switch",
  "蜂鸣器": "Buzzer",
  "限流": "Current Limiting",
  "告警": "Alarm",
  "上电": "Power On",
  "编码": "Code",
  "上电绝缘检测": "Power-on Insulation Detection",
  "上电并机控制": "Power-on Parallel Control",
  "绝缘检测使能": "Insulation Detection Enable",
  "总体高压": "Overall High Voltage",
  "总体低压": "Overall Low Voltage",
  "充电继电器高温": "Charging Relay High Temperature",
  "放电继电器高温": "Discharging Relay High Temperature",
  "负极继电器高温": "Negative Relay High Temperature",
  "电芯采样": "Cell Sampling",
  "采样异常": "Sampling Exception",
  "电流故障检测": "Current Fault Detection",
  "充电继电器控制": "Charging Relay Control",
  "放电继电器控制": "Discharging Relay Control",
  "预充继电器控制": "Precharge Relay Control",
  "负极继电器控制": "Negative Relay Control",
  "加热膜继电器控制": "Heating Film Relay Control",
  "充电继电器使能": "Charging Relay Enable",
  "放电继电器使能": "Discharging Relay Enable",
  "预充继电器使能": "Precharge Relay Enable",
  "负极继电器使能": "Negative Relay Enable",
  "加热膜继电器使能": "Heating Film Relay Enable",
  "电芯高温": "Cell High Temperature",
  "电芯低温": "Cell Low Temperature",
  "高温": "High Temperature",
  "预留": "Reserved",
  "系统锁功能": "System Lock Function",
  "充电继电器粘连": "Charging Relay Sticking",
  "充电继电器失效": "Charging Relay Failure",
  "放电继电器粘连": "Discharging Relay Sticking",
  "放电继电器失效": "Discharging Relay Failure",
  "预充继电器粘连": "Precharge Relay Sticking",
  "预充继电器失效": "Precharge Relay Failure",
  "负极继电器粘连": "Negative Relay Sticking",
  "负极继电器失效": "Negative Relay Failure",
  "加热膜继电器粘连": "Heating Film Relay Sticking",
  "加热膜继电器失效": "Heating Film Relay Failure",
  "异常": "Abnormal",
  "预充故障": "Precharge Fault",
  "加热膜继电器": "Heating Film Relay",
  "绝缘板通信故障": "Insulation Board Communication Fault",
  "采样板通信故障": "Sampling Board Communication Fault",
  "电流分流器故障": "Current Shunt Fault",
  "故障": "Fault",
  "急停": "Emergency Stop",
  "水浸": "Water Immersion",
  "烟感": "Smoke Detection",
  "总压故障": "Total Voltage Fault",
  "通讯故障": "Communication Fault",
  "霍尔故障": "Hall Fault",
  "参数配置失败": "Parameter Configuration Failed",
  "高压回路故障": "High Voltage Circuit Fault",
  "继电器开关频率高故障": "Relay Switching Frequency High Fault",
  "充电继电器": "Charging Relay",
  "放电继电器": "Discharging Relay",
  "预充继电器": "Precharge Relay",
  "负极继电器": "Negative Relay",
  "加热膜": "Heating Film",
  "使用": "Use",
  "供电": "Power Supply",
  "充电器反接": "Charger Reverse Polarity",
  "充电器接入": "Charger Connected",
  "关机状态": "Shutdown Status",
  "强充指示": "Forced Charge Indication",
  "预充失败": "Precharge Failure",
  "固件更新成功标志": "Firmware Update Success Flag",
  "并机开始标志": "Parallel Start Flag",
  "并机结束标志": "Parallel End Flag",
  "并机成功标志": "Parallel Success Flag",
  "并机异常标志": "Parallel Exception Flag",
  "绝缘开始标志": "Insulation Start Flag",
  "绝缘结束标志": "Insulation End Flag",
  "绝缘检查完成": "Insulation Check Complete",
  "绝缘检查异常": "Insulation Check Exception",
  "异常掉电": "Abnormal Power Loss",
  "对外通讯失败": "External Communication Failure",
  "单机模式": "Standalone Mode",
  "并机模式": "Parallel Mode",
  "开关机状态": "Power On/Off Status",
  "满充标志": "Full Charge Flag",
  "过放标志": "Over-Discharge Flag",
  "禁充": "Charge Prohibited",
  "禁放": "Discharge Prohibited",
  "模拟数据测试模式": "Simulated Data Test Mode",
  "继电器并入禁止": "Relay Parallel Connection Prohibited",
  "主回路维护模式": "Main Circuit Maintenance Mode",
  "继电器开关频率高告警": "Relay Switching Frequency High Alarm",
  "允许并入": "Parallel Connection Allowed",
  "请求并入": "Request Parallel Connection",
  "补电模式": "Replenishment Mode",
  "总电压": "Total Voltage",
  "负载电压": "Load Voltage",
  "最大": "Max",
  "最小": "Min",
  "差值": "Difference",
  "地址": "Address",
  "电流": "Current",
  "最大电流": "Max Current",
  "最小电流": "Min Current",
  "平均电流": "Average Current",
  "单体电压最大值": "Max Cell Voltage",
  "最大单体电压": "Maximum Cell Voltage",
  "最大单体电压在": "Maximum Cell Voltage At",
  "中的地址": "Address In",
  "单体电压最小值": "Min Cell Voltage",
  "最小单体电压": "Minimum Cell Voltage",
  "最小单体电压在": "Minimum Cell Voltage At",
  "单体最大压差": "Maximum Cell Voltage Difference",
  "电池温度最大值": "Max Battery Temperature",
  "电池温度最大值在": "Max Battery Temperature At",
  "单体最大温差": "Maximum Cell Temperature Difference",
  "最大电压值": "Maximum Voltage Value",
  "最小电压值": "Minimum Voltage Value",
  "最大电压": "Maximum Voltage",
  "最大电压地址": "Maximum Voltage Address",
  "最小电压": "Minimum Voltage",
  "最小电压地址": "Minimum Voltage Address",
  "总体电压最大值": "Maximum Overall Voltage",
  "总体电压最小值": "Minimum Overall Voltage",
  "总体最大压差": "Maximum Overall Voltage Difference",
  "在线": "Online",
  "个数": "Count",
  "循环次数": "Cycle Count",
  "历史充电容量": "Historical Charging Capacity",
  "历史放电容量": "Historical Discharging Capacity",
  "地址编号": "Address Number",
  "系统状态": "System Status",
  "电池状态": "Battery Status",
  "电池温度最小值": "Min Battery Temperature",
  "电池温度最小值在": "Min Battery Temperature At",
  "单体过压保护": "Cell Overvoltage Protection",
  "单体过放保护": "Cell Over-Discharge Protection",
  "总压过压保护": "Total Voltage Overvoltage Protection",
  "总压过放保护": "Total Voltage Over-Discharge Protection",
  "充电过流保护": "Charging Overcurrent Protection",
  "放电过流保护": "Discharging Overcurrent Protection",
  "短路": "Short Circuit",
  "充电器高压": "Charger High Voltage",
  "充电高温保护（电芯）": "Charging High Temp Protection (Cell)",
  "放电高温保护（电芯）": "Discharging High Temp Protection (Cell)",
  "充电低温保护（电芯）": "Charging Low Temp Protection (Cell)",
  "放电低温保护（电芯）": "Discharging Low Temp Protection (Cell)",
  "高温保护": "High Temperature Protection",
  "环境高温保护": "Ambient High Temperature Protection",
  "环境低温保护": "Ambient Low Temperature Protection",
  "（充满）": "(Fully Charged)",
  "充电": "Charging",
  "放电": "Discharging",
  "温度传感器故障": "Temperature Sensor Fault",
  "采样芯片故障": "Sampling Chip Fault",
  "限流故障": "Current Limiting Fault",
  "总压过压": "Total Voltage Overvoltage",
  "温差": "Temperature Difference",
  "检流电阻": "Current Sense Resistor",
  "脱扣器状态": "Trip Status",
  "脱扣器": "Trip",
  "主从机掉线状态": "Master/Slave Offline Status",
  "限流指示": "Current Limiting Indication",
  "充电指示": "Charging Indication",
  "放电指示": "Discharging Indication",
  "供电指示": "Power Supply Indication",
  "充电器反接指示": "Charger Reverse Polarity Indication",
  "关机": "Shutdown",
  "加热膜指示": "Heating Film Indication",
  "单体汇总": "Cell Summary",
  "蓝牙连接": "Bluetooth Connection",
  "后台连接": "Background Connection",
  "限流关闭": "Current Limiting Off",
  "硬件过压保护": "Hardware Overvoltage Protection",
  "电池包锁定": "Battery Pack Locked",
  "过压": "Overvoltage",
  "单体过压告警": "Cell Overvoltage Alarm",
  "充电高温告警": "Charging High Temperature Alarm",
  "单体低压告警": "Cell Low Voltage Alarm",
  "总压过压告警": "Total Voltage Overvoltage Alarm",
  "总压低压告警": "Total Voltage Low Voltage Alarm",
  "充电过流告警": "Charging Overcurrent Alarm",
  "放电过流告警": "Discharging Overcurrent Alarm",
  "放电高温告警": "Discharging High Temperature Alarm",
  "充电低温告警": "Charging Low Temperature Alarm",
  "放电低温告警": "Discharging Low Temperature Alarm",
  "环境高温告警": "Ambient High Temperature Alarm",
  "环境低温告警": "Ambient Low Temperature Alarm",
  "高温告警": "High Temperature Alarm",
  "低电量告警": "Low Battery Alarm",
  "独立汇总": "Independent Summary",
  "（独立电流）": "(Independent Current)",
  "屏蔽告警": "Mute Alarm",
  "限流屏蔽": "Current Limiting Mute",
  "限流挡位": "Current Limiting Gear",
  "蜂鸣器告警功能": "Buzzer Alarm Function",
  "均衡状态": "Balance Status",
  "累计充电容量": "Accumulated Charging Capacity",
  "累计放电容量": "Accumulated Discharging Capacity",
  "快充口高温": "Fast Charging Port High Temperature",
  "慢充口高温": "Slow Charging Port High Temperature",
  "放电口高温": "Discharge Port High Temperature",
  "正极端子高温": "Positive Terminal High Temperature",
  "负极端子高温": "Negative Terminal High Temperature",
  "级保护状态": "Level Protection Status",
  "故障状态": "Fault Status",
  "开关控制状态": "Switch Control Status",
  "开关响应状态": "Switch Response Status",
  "继电器真实状态": "Relay Actual Status",
  "传感器状态": "Sensor Status",
  "特殊状态": "Special Status",
  "端子温度数量": "Terminal Temperature Count",
  "电芯温度最大值": "Max Cell Temperature",
  "电芯温度最小值": "Min Cell Temperature",
  "最大电芯温度": "Maximum Cell Temperature",
  "最小电芯温度": "Minimum Cell Temperature",
  "最大电芯温度在": "Maximum Cell Temperature At",
  "最小电芯温度在": "Minimum Cell Temperature At",
  "电压最大值": "Max Voltage",
  "电压最小值": "Min Voltage",
  "电压": "Voltage",
  "快充继电器": "Fast Charging Relay",
  "慢充继电器": "Slow Charging Relay",
  "快充继电器使能": "Fast Charging Relay Enable",
  "慢充继电器使能": "Slow Charging Relay Enable",
  "预充": "Precharge",
  "霍尔传感器": "Hall Sensor",
  "正极端子高温保护": "Positive Terminal High Temp Protection",
  "负极端子高温保护": "Negative Terminal High Temp Protection",
  "电芯采样异常": "Cell Sampling Exception",
  "加热膜开启温度": "Heating Film Turn-On Temperature",
  "加热膜关闭温度": "Heating Film Turn-Off Temperature",
  "时区设置": "Timezone Settings",
  "个人中心": "Personal Center",
  "重置密码": "Reset Password",
  "退出登录": "Logout",
  "时区": "Timezone",
  "亚洲": "Asia",
  "北美洲": "North America",
  "欧洲": "Europe",
  "南美洲": "South America",
  "非洲": "Africa",
  "中国": "China",
  "日本": "Japan",
  "韩国": "South Korea",
  "印度": "India",
  "新加坡": "Singapore",
  "马来西亚": "Malaysia",
  "泰国": "Thailand",
  "越南": "Vietnam",
  "台湾地区": "Taiwan Region",
  "香港地区": "Hong Kong Region",
  "澳门地区": "Macau Region",
  "菲律宾": "Philippines",
  "阿联酋（迪拜）": "UAE (Dubai)",
  "美国（东部）": "USA (Eastern)",
  "加拿大（东部）": "Canada (Eastern)",
  "加拿大（西部）": "Canada (Western)",
  "墨西哥": "Mexico",
  "英国": "UK",
  "德国": "Germany",
  "法国": "France",
  "意大利": "Italy",
  "西班牙": "Spain",
  "俄罗斯（莫斯科）": "Russia (Moscow)",
  "荷兰": "Netherlands",
  "瑞士": "Switzerland",
  "澳大利亚（东部）": "Australia (Eastern)",
  "澳大利亚（中部）": "Australia (Central)",
  "新西兰": "New Zealand",
  "巴西（圣保罗）": "Brazil (Sao Paulo)",
  "阿根廷": "Argentina",
  "南非": "South Africa",
  "埃及": "Egypt",
  "肯尼亚": "Kenya",
  "时区不能为空": "Timezone cannot be empty",
  "原密码": "Original Password",
  "新密码": "New Password",
  "重复新密码": "Repeat New Password",
  "原密码不能为空": "Original password cannot be empty",
  "新密码不能为空": "New password cannot be empty",
  "重复新密码不能为空": "Repeated new password cannot be empty",
  "导出": "Export",
  "代理商管理": "Distributor Management",
  "设备总数": "Total Devices",
  "在线设备数": "Online Devices",
  "代理商总数": "Total Distributors",
  "平台名称": "Platform Name",
  "中文": "Chinese",
  "英文": "English",
  "平台": "Platform",
  "刷新频率": "Refresh Rate",
  "请输入": "Please Enter",
  "保存": "Save",
  "行程开始时间": "Trip Start Time",
  "行程结束时间": "Trip End Time",
  "开始地址": "Start Address",
  "结束地址": "End Address",
  "区域管理": "Region Management",
  "告警列表": "Alarm List",
  "设备管理": "Device Management",
  "用户管理": "User Management",
  "逆变器字典管理": "Inverter Dictionary Management",
  "物联网用户列表": "IoT User List",
  "设备列表": "Device List",
  "权限管理": "Permission Management",
  "帐号管理": "Account Management",
  "角色管理": "Role Management",
  "角色名称": "Role Name",
  "请输入角色名称": "Please enter role name",
  "菜单管理": "Menu Management",
  "接口管理": "API Management",
  "控制台": "Console",
  "项目管理": "Project Management",
  "维保人员管理": "Maintenance Personnel Management",
  "账号权限": "Account Permissions",
  "模块管理": "Module Management",
  "查看": "View",
  "控制": "Control",
  "沛城能源管理平台": "Peicheng Energy Management Platform",
  "大屏数据": "Dashboard Data",
  "后台管理": "Backend Management",
  "添加": "Add",
  "导入": "Import",
  "下载": "Download",
  "新增出库": "Add Outbound",
  "新增文件": "Add File",
  "刷新": "Refresh",
  "查询": "Query",
  "重置": "Reset",
  "编辑": "Edit",
  "删除": "Delete",
  "无数据": "No Data",
  "您确定要删除": "Are you sure you want to delete",
  "吗": "?",
  "序号": "No.",
  "确定": "OK",
  "取消": "Cancel",
  "协议管理": "Protocol Management",
  "产品": "Product",
  "自定义协议": "Custom Protocol",
  "硬件版本管理": "Hardware Version Management",
  "固件管理": "Firmware Management",
  "固件版本": "Firmware Version",
  "升级规则": "Upgrade Rule",
  "资料": "Documents",
  "区域分类": "Region Category",
  "区域名称": "Region Name",
  "添加下级区域": "Add Sub-Region",
  "新增区域": "Add Region",
  "编辑区域": "Edit Region",
  "上级区域": "Parent Region",
  "请选择上级区域": "Please select parent region",
  "请输入区域名称": "Please enter region name",
  "请输入说明": "Please enter description",
  "代理商": "Distributor",
  "区域": "Region",
  "请选择区域": "Please select region",
  "请输入代理商": "Please enter distributor",
  "代理商列表": "Distributor List",
  "代理商名称": "Distributor Name",
  "文件名称": "File Name",
  "请输入文件名称": "Please enter file name",
  "添加子代理商": "Add Sub-Distributor",
  "禁用": "Disable",
  "启用": "Enable",
  "转移": "Transfer",
  "权限": "Permissions",
  "新增代理商": "Add Distributor",
  "请输入代理商名称": "Please enter distributor name",
  "联系人": "Contact Person",
  "请输入联系人": "Please enter contact person",
  "请输入地址": "Please enter address",
  "地图坐标": "Map Coordinates",
  "请单击地图获取地址": "Please click on map to get address",
  "请输入经度": "Please enter longitude",
  "请输入纬度": "Please enter latitude",
  "请输入搜索名称": "Please enter search name",
  "售后联系": "After-Sales Contact",
  "登录账号（手机号或邮箱）": "Login Account (Phone/Email)",
  "请输入登录账号（手机号或邮箱）": "Please enter login account (phone/email)",
  "登录密码": "Login Password",
  "请输入登录密码": "Please enter login password",
  "参数设置密码": "Parameter Setting Password",
  "请输入参数设置密码": "Please enter parameter setting password",
  "备注": "Notes",
  "请输入备注": "Please enter notes",
  "名称不能为空": "Name cannot be empty",
  "联系人不能为空": "Contact person cannot be empty",
  "区域不能为空": "Region cannot be empty",
  "地址不能为空": "Address cannot be empty",
  "售后联系不能为空": "After-sales contact cannot be empty",
  "手机号或邮箱不能为空": "Phone or email cannot be empty",
  "登录密码不能为空": "Login password cannot be empty",
  "地图坐标不能为空": "Map coordinates cannot be empty",
  "上传时间": "Upload Time",
  "创建时间": "Creation Time",
  "报警管理": "Alarm Management",
  "请选择状态": "Please select status",
  "未处理": "Unprocessed",
  "已处理": "Processed",
  "批量处理": "Batch Process",
  "所属代理商": "Belonging Distributor",
  "数据类型": "Data Type",
  "告警原因": "Alarm Cause",
  "处理人": "Handler",
  "处理时间": "Processing Time",
  "处理": "Process",
  "告警处理": "Alarm Processing",
  "请输入处理人": "Please enter handler",
  "请选择处理时间": "Please select processing time",
  "处理人名称不能为空": "Handler name cannot be empty",
  "处理时间不能为空": "Processing time cannot be empty",
  "设备状态": "Device Status",
  "设备分配状态": "Device Assignment Status",
  "筛选": "Filter",
  "记录时间": "Record Time",
  "选择日期": "Select Date",
  "日期": "Date",
  "版本号": "Version",
  "硬件版本号": "Hardware Version",
  "软件版本号": "Software Version",
  "产测状态": "Production Test Status",
  "产测时间": "Production Test Time",
  "最后上线时间": "Last Online Time",
  "激活时间": "Activation Time",
  "导出历史记录": "Export History",
  "查看轨迹": "View Trajectory",
  "分配": "Assign",
  "取消分配": "Unassign",
  "联网方式": "Network Mode",
  "操作人": "Operator",
  "告警记录": "Alarm Record",
  "离线": "Offline",
  "未知": "Unknown",
  "时间筛选": "Time Filter",
  "起始时间、结束时间": "Start Time, End Time",
  "时间筛选不能为空": "Time filter cannot be empty",
  "批量分配代理商": "Batch Assign Distributor",
  "分配代理商": "Assign Distributor",
  "文件": "File",
  "请上传": "Please Upload",
  "下载示例文件": "Download Sample File",
  "请输入新密码": "Please enter new password",
  "新密码必须": "New password must be",
  "您确定要取消分配": "Are you sure you want to unassign",
  "代理商必选": "Distributor is required",
  "协议类型": "Protocol Type",
  "协议编号": "Protocol ID",
  "协议名称": "Protocol Name",
  "逆变器类型": "Inverter Type",
  "编辑逆变器字典": "Edit Inverter Dictionary",
  "查看详情": "View Details",
  "请选择协议类型": "Please select protocol type",
  "请输入协议编号": "Please enter protocol ID",
  "请输入协议名称": "Please enter protocol name",
  "请选择逆变器类型": "Please select inverter type",
  "协议名称筛选": "Protocol Name Filter",
  "新增逆变器字典": "Add Inverter Dictionary",
  "协议类型不能为空": "Protocol type cannot be empty",
  "协议编号不能为空": "Protocol ID cannot be empty",
  "协议名称不能为空": "Protocol name cannot be empty",
  "逆变器类型不能为空": "Inverter type cannot be empty",
  "请选择上传": "Please select upload",
  "上传": "Upload",
  "文件不可为空": "File cannot be empty",
  "文件类型不正确": "File type incorrect",
  "您确定要导出当前数据吗？": "Are you sure you want to export current data?",
  "请选择导出时间": "Please select export time",
  "吗？": "?",
  "登录": "Login",
  "请输入账号（邮箱": "Please enter account (email",
  "手机号）": "phone number)",
  "账号不能为空": "Account cannot be empty",
  "请输入密码": "Please enter password",
  "密码不能为空": "Password cannot be empty",
  "忘记密码": "Forgot Password",
  "已经有账号": "Already have an account",
  "邮箱找回密码": "Recover Password via Email",
  "重复密码不能为空": "Repeat password cannot be empty",
  "请输入邮箱": "Please enter email",
  "邮箱不能为空": "Email cannot be empty",
  "请输入验证码": "Please enter verification code",
  "获取邮箱验证码": "Get Email Verification Code",
  "邮箱格式错误": "Invalid email format",
  "秒后重新获取": "Resend after seconds",
  "请填写必填项": "Please fill in required fields",
  "请选择项目号": "Please select project number",
  "导入结果预览": "Import Result Preview",
  "关联": "Associate",
  "总条数": "Total Count",
  "您确定要导出当前数据吗": "Are you sure you want to export current data",
  "长时间未操作": "Long time inactive, refresh rate changed to",
  "分钟": "minutes",
  "最新上线时间": "Latest Online Time",
  "列设置": "Column Settings",
  "全选": "Select All",
  "展开查询": "Expand Query",
  "收起查询": "Collapse Query",
  "激活趋势": "Activation Trend",
  "查看大图": "View Larger",
  "导出成功，请在下载记录菜单中查看": "Export successful, please check in download records menu",
  "文件生成中": "File generating",
  "导出成功": "Export Successful",
  "叉车导出开发中": "Forklift export in development",
  "导出下载": "Export Download",
  "轨迹列表": "Trajectory List",
  "首頁": "Home",
  "组件": "Components",
  "数字渐变": "Digital Gradient",
  "多功能表格": "Multi-Function Table",
  "分割窗口": "Split Panes",
  "編輯器": "Editor",
  "富文本編輯器": "Rich Text Editor",
  "自定義圖標": "Custom Icons",
  "圖片編輯器": "Image Editor",
  "上傳數據": "Upload Data",
  "群": "Group",
  "文檔": "Document",
  "上傳": "Upload",
  "粘貼表格數據": "Paste Table Data",
  "多级菜单": "Multi-Level Menu",
  "指令": "Directives",
  "導出": "Export",
  "工具函數": "Utility Functions",
  "拖拽列表": "Draggable List",
  "多語言": "Multilingual",
  "模態框題目": "Modal Title",
  "這是模態框內容": "This is modal content",
  "顯示模態框": "Show Modal",
  "注：僅此頁做了多語言，其他頁面沒有在多語言包中添加語言內容": "Note: Only this page is multilingual, other pages have not added language content to the multilingual package.",
  "錯誤收集": "Error Collection",
  "錯誤日誌": "Error Log",
  "帶參路由": "Route with Parameters",
  "動態路由": "Dynamic Route",
  "圖片裁剪": "Image Cropping",
  "消息中心": "Message Center",
  "樹狀表格": "Tree Table",
  "基础模块": "Basic Modules",
  "不能和": "Cannot be",
  "标签重复的组件，添加别名": "Components with duplicate tags, add alias",
  "除了": "Except",
  "在使用中必须是": "Must be in use",
  "其他都可以不加": "Others are optional",
  "循环注册全局组件": "Loop register global components",
  "所写的": "Written",
  "共用": "Shared",
  "属性和方法": "Properties and Methods",
  "表单校验": "Form Validation",
  "封装": "Encapsulated",
  "的基本数据": "basic data",
  "表格": "Table",
  "默认需要": "Default requires",
  "减去的高度": "subtracted height",
  "选中项": "Selected Items",
  "请求的": "Requested",
  "参数": "Parameters",
  "页面数据总数量": "Total page data count",
  "填充的数据": "Filled data",
  "从本地取": "Retrieved locally",
  "获取页面功能权限": "Get page functional permissions",
  "选择所选项": "Select Selected Items",
  "页码": "Page Number",
  "点击": "Click",
  "时请求参数的拼装": "parameter assembly when requesting",
  "重置当前页为": "Reset current page to",
  "重置当前的": "Reset current",
  "搜索框——查询客户名称函数": "Search Box - Query Customer Name Function",
  "的共用属性和方法": "shared properties and methods",
  "是否显示模态框": "Whether to show modal",
  "显示与隐藏模态框": "Show and Hide Modal",
  "带下一步操作": "With Next Step Operation",
  "删除邮件": "Delete Email",
  "您确定要删除选择的": "Are you sure you want to delete selected",
  "封邮件吗": "emails?",
  "发送请求": "Send Request",
  "删除邮件成功！": "Email deleted successfully!",
  "请选择要删除的邮件！": "Please select emails to delete!",
  "这里是上一页时间": "Here is previous page time",
  "配置显示在浏览器标签的": "Configure display in browser tab",
  "在": "In",
  "中存储的天数，默认": "days stored, default",
  "天": "days",
  "是否使用国际化，默认为": "Whether to use internationalization, default is",
  "如果不使用，则需要在路由中给需要在菜单中展示的路由设置": "If not used, routes that need to be displayed in the menu must be set in the routing",
  "用来在菜单中显示文字": "Used to display text in the menu",
  "请求基础路径": "Request Base URL",
  "测试": "Test",
  "默认打开的首页的路由": "Default open home page route",
  "值，默认为": "value, default is",
  "需要加载的插件": "Plugins to load",
  "设为": "Set to",
  "后不会在顶部显示错误日志徽标": "will not show error log badge at top",
  "后在开发环境不会收集错误信息，方便开发中排查错误": "will not collect error information in development environment, convenient for troubleshooting during development",
  "加密": "Encryption",
  "硬件故障": "Hardware Failure",
  "劫持报警": "Hijacking Alarm",
  "锁": "Lock",
  "防撬报警": "Tamper Alarm",
  "非法钥匙插入报警": "Illegal Key Insertion Alarm",
  "非法开锁报警": "Illegal Unlock Alarm",
  "门未关好报警": "Door Not Closed Alarm",
  "多次密码输错报警": "Multiple Wrong Password Alarm",
  "开锁次数超过上限": "Unlock Count Exceeded Limit",
  "低电量报警": "Low Battery Alarm",
  "设备恢复出厂值": "Device Restore Factory Settings",
  "画面移动侦测": "Motion Detection",
  "声音侦测": "Sound Detection",
  "画面遮挡": "Scene Occlusion",
  "外部人员入侵": "External Intrusion",
  "周界入侵": "Perimeter Intrusion",
  "拌线入侵": "Tripwire Intrusion",
  "语音抓拍": "Voice Snapshot",
  "感应到人体": "Human Body Detected",
  "烟雾报警": "Smoke Alarm",
  "可燃气体报警": "Flammable Gas Alarm",
  "水渍报警": "Water Leak Alarm",
  "报警": "Alarm",
  "高温报警": "High Temperature Alarm",
  "低温报警": "Low Temperature Alarm",
  "摔倒报警": "Fall Alarm",
  "可视门铃触发": "Video Doorbell Triggered",
  "检测到人体": "Human Body Detected",
  "检测到人脸": "Face Detected",
  "比对人脸": "Face Comparison",
  "允许通行": "Access Granted",
  "比对人脸，拒绝通行": "Face Comparison, Access Denied",
  "比对人脸，陌生人": "Face Comparison, Stranger",
  "发现老鼠": "Mouse Detected",
  "电子围栏越界": "Electronic Fence Breach",
  "路径监护异常": "Path Monitoring Exception",
  "血压数据异常": "Abnormal Blood Pressure Data",
  "心率数据异常": "Abnormal Heart Rate Data",
  "体温数据异常": "Abnormal Body Temperature Data",
  "血糖数据异常": "Abnormal Blood Glucose Data",
  "固件升级失败": "Firmware Upgrade Failed",
  "设备上线": "Device Online",
  "设备离线报警": "Device Offline Alarm",
  "打开": "Open",
  "接通，闭合": "Connect, Close",
  "门锁，开关，灯，插座": "Door Lock, Switch, Light, Socket",
  "关闭": "Close",
  "断开": "Disconnect",
  "普通门铃触发": "Regular Doorbell Triggered",
  "门磁打开": "Door Contact Open",
  "门磁关闭": "Door Contact Closed",
  "已佩戴": "Worn",
  "未佩戴": "Not Worn",
  "投食": "Feed",
  "宠物喂食器": "Pet Feeder",
  "设备充电中": "Device Charging",
  "外部供电": "External Power Supply",
  "云存文件上传完成": "Cloud File Upload Complete",
  "从有人变为无人": "From Occupied to Unoccupied",
  "人体感应传感器": "Motion Sensor",
  "感应到有人": "Someone Detected",
  "端穿戴温度监测汇总信息": "End Wearable Temperature Monitoring Summary",
  "这是消息内容，这个内容是使用": "This is the message content, which is edited using",
  "富文本编辑器": "a rich text editor",
  "编辑的，所以你可以看到一些": ", so you can see some",
  "格式": "formatting",
  "你可以查看": "You can view",
  "返回的数据格式，和": "returned data format, and the",
  "请求的接口，来确定你的后端接口的开发": "requested API to determine your backend API development",
  "使用你的真实接口后，前端页面基本不需要修改即可满足基本需求": "After using your real API, the frontend page basically requires no modification to meet basic requirements",
  "快来试试吧": "Come and try it",
  "配置": "Configuration",
  "请求延时，可用来测试网络延迟大时项目中一些效果": "Request delay, can be used to test some effects in the project when network latency is high",
  "登录相关和获取用户信息": "Login related and get user information",
  "加载时错误执行报错的禁用": "Disable error reporting on load",
  "后": "After",
  "出现置顶的情况": "pinning occurs",
  "表格间距": "Table Spacing",
  "多级": "Multi-level",
  "下": "under",
  "的按钮类型": "button types",
  "高宽分别对应横竖滚动条的尺寸": "Height and width correspond to the size of horizontal and vertical scrollbars",
  "重新排列搜索的列表": "Reorder search list",
  "得到两个数组的交集": "Get the intersection of two arrays",
  "两个数组的元素为数值或字符串": "Array elements are numbers or strings",
  "得到两个数组的并集": "Get the union of two arrays",
  "目标数组": "Target Array",
  "需要查询的数组": "Array to query",
  "判断要查询的数组是否至少有一个元素包含在目标数组中": "Determine if at least one element of the array to query is contained in the target array",
  "要验证的字符串或数值": "String or value to verify",
  "用来验证的列表": "List used for verification",
  "判断时间戳格式是否是毫秒": "Determine if timestamp format is in milliseconds",
  "传入的时间戳": "Incoming timestamp",
  "当前时间时间戳": "Current time timestamp",
  "传入的时间戳是否早于当前时间戳": "Whether the incoming timestamp is earlier than the current timestamp",
  "数值": "Value",
  "处理后的字符串": "Processed String",
  "如果传入的数值小于": "If the incoming value is less than",
  "，即位数只有": ", i.e., only",
  "位，则在前面补充": "digits, then pad the front with",
  "要返回的时间字符串的格式类型，传入": "Format type of the time string to return, pass",
  "则返回年开头的完整时间": "to return full time starting with year",
  "时间戳": "Timestamp",
  "相对时间字符串": "Relative Time String",
  "判断当前传入的时间戳是秒格式还是毫秒": "Determine if the current incoming timestamp is in seconds or milliseconds format",
  "如果是毫秒格式则转为秒格式": "If in milliseconds format, convert to seconds format",
  "传入的时间戳可以是数值或字符串类型，这里统一转为数值类型": "Incoming timestamp can be number or string type, uniformly converted to number type here",
  "获取当前时间时间戳": "Get current time timestamp",
  "判断传入时间戳是否早于当前时间戳": "Determine if incoming timestamp is earlier than current timestamp",
  "获取两个时间戳差值": "Get the difference between two timestamps",
  "如果": "If",
  "为": "is",
  "则差值取反": "then invert the difference",
  "前": "Before",
  "少于等于": "Less than or equal to",
  "秒": "seconds",
  "多于": "More than",
  "秒，少于等于": "seconds, less than or equal to",
  "小时": "hours",
  "秒，少于": "seconds, less than",
  "秒，且传入的时间戳早于当前": "seconds, and the incoming timestamp is earlier than current",
  "当前浏览器名称": "Current Browser Name",
  "绑定事件": "Bind Event",
  "解绑事件": "Unbind Event",
  "判断一个对象是否存在": "Determine if an object exists",
  "，如果传入第二个参数": ", if a second parameter",
  "，则是判断这个": "is passed, then determine if this",
  "对象是否存在": "object exists",
  "这个属性": "property",
  "如果没有传入": "If not passed",
  "这个参数，则判断": "this parameter, then determine if the",
  "对象是否有键值对": "object has key-value pairs",
  "对象": "Object",
  "判断两个对象是否相等，这两个对象的值只能是数字或字符串": "Determine if two objects are equal, their values can only be numbers or strings",
  "保存的天数": "Days to save",
  "本地路由": "Local Route",
  "通过路由列表得到菜单列表": "Get menu list from route list",
  "根据": "Based on",
  "获取本地的菜单权限": "Get local menu permissions",
  "角色配置的路由": "Role-configured routes",
  "所有的路由列表": "All route list",
  "权限菜单的路由是否在": "Whether the permission menu route is in",
  "中": "",
  "写入功能权限": "Write functional permissions",
  "获取菜单中，保存的": "Get the saved",
  "获取的菜单": "retrieved menu",
  "是否有": "Whether it has",
  "当前路由": "Current Route",
  "去掉首页的显示": "Remove home page display",
  "需要添加到": "Need to add to",
  "上时": "",
  "本地存储和获取标签导航列表": "Local storage and get tag navigation list",
  "其中的每个元素只包含路由原信息中的": "Each element only contains the",
  "三项": "three items from the route meta info",
  "路由列表数组": "Route list array",
  "用于找到路由列表中": "Used to find the",
  "的对象": "object in the route list",
  "现有标签导航列表": "Existing tag navigation list",
  "新添加的路由原信息对象": "Newly added route meta object",
  "如果该": "If the",
  "已经存在则不再添加": "already exists, do not add again",
  "用户权限数组，如": "User permission array, e.g.",
  "路由列表": "Route List",
  "权鉴": "Authentication",
  "即将跳转的路由": "Route about to jump to",
  "用户权限数组": "User Permission Array",
  "用户是否可跳转到该页": "Whether user can jump to this page",
  "从": "From",
  "中解析参数": "parse parameters",
  "标签列表": "Tag List",
  "当前关闭的标签的": "The",
  "回调函数需要执行的次数": "number of times the callback function needs to be executed",
  "回调函数": "Callback Function",
  "从上传组件得到的文件对象": "File object obtained from upload component",
  "参数是解析后的二维数组": "Parameter is the parsed two-dimensional array",
  "文件中解析出表格，解析成二维数组": "Parse table from file into two-dimensional array",
  "以文本格式读取": "Read in text format",
  "读到的数据": "Read data",
  "你上传的不是": "You uploaded is not",
  "表格数据二维数组": "Table data two-dimensional array",
  "从二维数组中获取表头和表格数据，将第一行作为表头，用于在": "Get table header and data from two-dimensional array, use first row as header for display in",
  "的表格中展示数据": "table",
  "判断两个路由对象是否相等": "Determine if two route objects are equal",
  "路由对象": "Route Object",
  "判断打开的标签列表里是否已存在这个新添加的路由对象": "Determine if this newly added route object already exists in the open tag list",
  "根据当前跳转的路由设置显示在浏览器标签的": "Set browser tab display based on current jump route",
  "实例": "Instance",
  "获取距离当天的时间": "Get time relative to today",
  "年": "Year",
  "月": "Month",
  "日": "Day",
  "获取": "Get",
  "的天数": "days",
  "获取当前月份的日期": "Get dates of current month",
  "时间戳转年月日": "Timestamp to Year-Month-Day",
  "时间戳转年月日时分秒": "Timestamp to Year-Month-Day Hour:Minute:Second",
  "获取距离当天时间的年月日": "Get Year-Month-Day relative to current time",
  "时分秒": "Hour:Minute:Second",
  "根据用的": "Based on",
  "显示用户操作权限": "Show user operation permissions",
  "显示用户角色": "Show user role",
  "请求回调工厂": "Request Callback Factory",
  "遍历整个路由": "Traverse entire route",
  "获取时间之差的天数": "Get day difference of time",
  "深拷贝": "Deep Copy",
  "封装接口返回": "Encapsulate API Response",
  "根据时间差返回天时分秒": "Return days, hours, minutes, seconds based on time difference",
  "得到时间差": "Get time difference",
  "计算出相差天数": "Calculate day difference",
  "计算出小时数": "Calculate hours",
  "计算天数后剩余的毫秒数": "Calculate remaining milliseconds after days",
  "小时前": "hours ago",
  "计算相差分钟数": "Calculate minute difference",
  "计算小时数后剩余的毫秒数": "Calculate remaining milliseconds after hours",
  "分钟前": "minutes ago",
  "计算相差秒数": "Calculate second difference",
  "计算分钟数后剩余的毫秒数": "Calculate remaining milliseconds after minutes",
  "秒前": "seconds ago",
  "递归菜单列表": "Recursively traverse menu list",
  "获取当前的年月日时分秒": "Get current year, month, day, hour, minute, second",
  "月份": "Month",
  "获取当前的年月日": "Get current year, month, day",
  "根据时获取前后的时间": "Get time before and after based on hours",
  "获取前面": "Get previous",
  "个月": "months",
  "获取当前月份": "Get current month",
  "自定义判断元素类型": "Custom element type judgment",
  "参数过滤函数": "Parameter filtering function",
  "请求拦截": "Request Interception",
  "过滤参数": "Filter Parameters",
  "添加全局的": "Add global",
  "不建议开启，因为界面不友好": "Not recommended to enable, unfriendly interface",
  "响应拦截": "Response Interception",
  "登录过期，重新登录": "Login expired, please login again",
  "状态，跳转登录页面": "status, redirect to login page",
  "登录过期": "Login Expired",
  "登录过期，请求重新登录": "Login expired, request to login again",
  "湖北省荆州市江陵县白马寺镇": "Baimasi Town, Jiangling County, Jingzhou City, Hubei Province",
  "枣石高速头陀寺南": "South of Toutuo Temple, Zaoshi Expressway",
  "米": "meters",
  "心跳校验": "Heartbeat Check",
  "每隔三秒发送心跳": "Send heartbeat every three seconds",
  "次心跳均未响应重连": "reconnect after no response for heartbeats",
  "这里发送一个心跳，后端收到后，返回一个心跳消息，": "Here send a heartbeat, after backend receives it, return a heartbeat message,",
  "拿到返回的心跳就说明连接正常": "Getting the returned heartbeat means the connection is normal",
  "心跳包": "Heartbeat Packet",
  "计算答复的超时次数": "Calculate timeout count for responses",
  "异常后重新连接": "Reconnect after exception",
  "监听推送的数据": "Listen for pushed data",
  "拿到任何消息都说明当前连接是正常的": "Getting any message indicates the current connection is normal",
  "创建一个更高度自定义事件，并派发": "Create a more highly customizable event and dispatch it",
  "连接发生错误": "Connection error occurred",
  "连接成功": "Connection successful",
  "心跳检测重置": "Heartbeat detection reset",
  "发送": "Send",
  "设置": "set up",
  "消息": "Message",
  "对外提供": "Externally provided",
  "开启": "Open",
  "若是": "If",
  "正在开启状态，则等待": "is in opening state, then wait",
  "后重新调用": "before recalling",
  "未开启": "Not opened",
  "重新调用初始化": "Recall initialization",
  "数据发送": "Data sending",
  "注册": "Register",
  "内置插件": "Built-in Plugins",
  "生产环境关掉提示": "Turn off prompts in production environment",
  "全局注册应用配置": "Globally register app configuration",
  "注册指令": "Register Directives",
  "菜单": "Menu",
  "法律法规": "Laws and Regulations",
  "服务条款": "Terms of Service",
  "法律声明及隐私权政策": "Legal Notice and Privacy Policy",
  "登录区域的共用属性和方法": "Shared properties and methods for login area",
  "请选择服务条款和法律声明": "Please select Terms of Service and Legal Notice",
  "国别": "Country",
  "用户注册": "User Registration",
  "找回密码": "Retrieve Password",
  "请登录": "Please Login",
  "显示与隐藏密码": "Show and Hide Password",
  "记住密码": "Remember Password",
  "同意并阅读": "Agree and Read",
  "《服务条款》": "Terms of Service",
  "《法律声明及隐私权政策》": "Legal Notice and Privacy Policy",
  "邮箱获取验证码": "Get Verification Code via Email",
  "你确定要删除吗": "Are you sure you want to delete?",
  "封装带有": "Encapsulated with",
  "和": "and",
  "的": "",
  "提供二个插槽": "Provides two slots",
  "如操作按钮组": "e.g. operation button group",
  "如排序字段": "e.g. sort field",
  "常用": "Common",
  "内容": "Content",
  "不常用的": "Uncommon",
  "折叠": "Collapse",
  "搜索和重置按钮": "Search and Reset buttons",
  "选中的值": "Selected Value",
  "是否显示查询区域": "Whether to show query area",
  "用于显示当前": "Used to display current",
  "表头的": "table header's",
  "到本地": "to local",
  "显示查询区域": "Show Query Area",
  "基本样式": "Basic Style",
  "单元格之间": "Between cells",
  "的样式": "style",
  "是否显示高级搜索": "Whether to show advanced search",
  "头部操作按钮": "Header Operation Buttons",
  "表格数据": "Table Data",
  "表格列数据": "Table Column Data",
  "是否显示间隔斑马纹": "Whether to show striped rows",
  "是否显示纵向边框": "Whether to show vertical borders",
  "是否显示": "Whether to show",
  "表格高度": "Table Height",
  "分页总数": "Pagination Total",
  "分页尺寸": "Pagination Size",
  "分页": "Pagination",
  "默认需要减去的高度": "Default height to subtract",
  "全不选": "Deselect All",
  "显示的列数": "Number of columns displayed",
  "刷新表格": "Refresh Table",
  "重置当前": "Reset Current",
  "显示面板": "Show Panel",
  "选择改变时触发": "Triggered when selection changes",
  "输入关键字搜索": "Enter keyword to search",
  "全局设置是否可编辑": "Global setting for editability",
  "是否可搜索": "Searchable",
  "搜索控件所在位置，": "Search control position,",
  "返回值": "Return Value",
  "：同": ": Same as",
  "函数中的": "in the function",
  "同上": "Same as above",
  "：除上面三个参数外，还有一个": ": Besides the above three parameters, there is also a",
  "修改后的数据": "Modified Data",
  "高级搜索": "Advanced Search",
  "上一页": "Previous Page",
  "下一页": "Next Page",
  "表头": "Table Header",
  "返回值：事件对象，但是在事件对象中加入了两个参数：": "Return Value: Event object, but with two parameters added:",
  "当前是否在最小值处": "Whether currently at minimum value",
  "当前是否在最大值处": "Whether currently at maximum value",
  "事件列表为": "Event list is",
  "编辑器的事件，更多事件类型，请参考：": "Editor events, for more event types, refer to:",
  "起始值，即动画开始前显示的数值": "Start value, the value displayed before animation starts",
  "结束值，即动画结束后显示的数值": "End value, the value displayed after animation ends",
  "保留几位小数": "Number of decimal places to keep",
  "分隔整数和小数的符号，默认是小数点": "Symbol separating integer and decimal, default is decimal point",
  "动画持续的时间，单位是秒": "Animation duration in seconds",
  "动画延迟开始的时间，单位是秒": "Animation delay start time in seconds",
  "是否禁用": "Disabled",
  "动画效果": "Animation Effect",
  "是否使用分组，分组后每三位会用一个符号分隔": "Whether to use grouping, groups of three digits are separated by a symbol",
  "用于分组": "Used for grouping",
  "的符号": "symbol",
  "是否简化显示，设为": "Whether to simplify display, set to",
  "后会使用": "will use",
  "单位来做相关省略": "units for abbreviation",
  "自定义单位，如": "Custom units, e.g.",
  "即大于": "i.e. greater than",
  "位数小于": "digits less than",
  "位数的用": "digits use",
  "来做省略": "for abbreviation",
  "即显示为": "i.e. display as",
  "上传图片": "Upload Image",
  "裁剪": "Crop",
  "轴渐变": "Axis Gradient",
  "不显示刻度": "Do Not Show Scale",
  "坐标轴两边留白策略": "Axis Margin Strategy",
  "区域中分隔线": "Separator Line in Area",
  "提示组件框": "Tooltip Component Box",
  "相关行为": "Related Behaviors",
  "长宽比": "Aspect Ratio",
  "自定义名称映射": "Custom Name Mapping",
  "是否开启鼠标缩放和平移漫游": "Enable Mouse Zoom and Pan Roaming",
  "初始化": "Initialize",
  "报警信息": "Alarm Information",
  "触发数据": "Trigger Data",
  "单选": "Single Select",
  "高温与还原": "High Temperature and Restore",
  "报警数据": "Alarm Data",
  "多米尼加": "Dominican Republic",
  "巴勒斯坦": "Palestine",
  "巴哈马": "Bahamas",
  "东帝汶": "East Timor",
  "阿富汗": "Afghanistan",
  "几内亚比绍": "Guinea-Bissau",
  "科特迪瓦": "Cote d'Ivoire",
  "锡亚琴冰川": "Siachen Glacier",
  "英属印度洋领土": "British Indian Ocean Territory",
  "安哥拉": "Angola",
  "阿尔巴尼亚": "Albania",
  "阿联酋": "United Arab Emirates",
  "亚美尼亚": "Armenia",
  "法属南半球和南极领地": "French Southern and Antarctic Lands",
  "澳大利亚": "Australia",
  "奥地利": "Austria",
  "阿塞拜疆": "Azerbaijan",
  "布隆迪": "Burundi",
  "比利时": "Belgium",
  "贝宁": "Benin",
  "布基纳法索": "Burkina Faso",
  "孟加拉国": "Bangladesh",
  "保加利亚": "Bulgaria",
  "波斯尼亚和黑塞哥维那": "Bosnia and Herzegovina",
  "白俄罗斯": "Belarus",
  "伯利兹": "Belize",
  "百慕大": "Bermuda",
  "玻利维亚": "Bolivia",
  "巴西": "Brazil",
  "文莱": "Brunei",
  "不丹": "Bhutan",
  "博茨瓦纳": "Botswana",
  "中非": "Central African Republic",
  "加拿大": "Canada",
  "智利": "Chile",
  "象牙海岸": "Ivory Coast",
  "喀麦隆": "Cameroon",
  "刚果民主共和国": "Democratic Republic of the Congo",
  "刚果": "Congo",
  "哥伦比亚": "Colombia",
  "哥斯达黎加": "Costa Rica",
  "古巴": "Cuba",
  "北塞浦路斯": "Northern Cyprus",
  "塞浦路斯": "Cyprus",
  "捷克": "Czech Republic",
  "吉布提": "Djibouti",
  "丹麦": "Denmark",
  "阿尔及利亚": "Algeria",
  "厄瓜多尔": "Ecuador",
  "厄立特里亚": "Eritrea",
  "爱沙尼亚": "Estonia",
  "埃塞俄比亚": "Ethiopia",
  "芬兰": "Finland",
  "斐": "Fiji",
  "福克兰群岛": "Falkland Islands",
  "加蓬": "Gabon",
  "格鲁吉亚": "Georgia",
  "加纳": "Ghana",
  "几内亚": "Guinea",
  "冈比亚": "Gambia",
  "赤道几内亚": "Equatorial Guinea",
  "希腊": "Greece",
  "格陵兰": "Greenland",
  "危地马拉": "Guatemala",
  "法属圭亚那": "French Guiana",
  "圭亚那": "Guyana",
  "洪都拉斯": "Honduras",
  "克罗地亚": "Croatia",
  "海地": "Haiti",
  "匈牙利": "Hungary",
  "印度尼西亚": "Indonesia",
  "爱尔兰": "Ireland",
  "伊朗": "Iran",
  "伊拉克": "Iraq",
  "冰岛": "Iceland",
  "以色列": "Israel",
  "牙买加": "Jamaica",
  "约旦": "Jordan",
  "哈萨克斯坦": "Kazakhstan",
  "吉尔吉斯斯坦": "Kyrgyzstan",
  "柬埔寨": "Cambodia",
  "科索沃": "Kosovo",
  "科威特": "Kuwait",
  "老挝": "Laos",
  "黎巴嫩": "Lebanon",
  "利比里亚": "Liberia",
  "利比亚": "Libya",
  "斯里兰卡": "Sri Lanka",
  "莱索托": "Lesotho",
  "立陶宛": "Lithuania",
  "卢森堡": "Luxembourg",
  "拉脱维亚": "Latvia",
  "摩洛哥": "Morocco",
  "摩尔多瓦": "Moldova",
  "马达加斯加": "Madagascar",
  "马其顿": "Macedonia",
  "马里": "Mali",
  "缅甸": "Myanmar",
  "黑山": "Montenegro",
  "蒙古": "Mongolia",
  "莫桑比克": "Mozambique",
  "毛里塔尼亚": "Mauritania",
  "马拉维": "Malawi",
  "纳米比亚": "Namibia",
  "新喀里多尼亚": "New Caledonia",
  "尼日尔": "Niger",
  "尼日利亚": "Nigeria",
  "尼加拉瓜": "Nicaragua",
  "挪威": "Norway",
  "尼泊尔": "Nepal",
  "阿曼": "Oman",
  "巴基斯坦": "Pakistan",
  "巴拿马": "Panama",
  "秘鲁": "Peru",
  "巴布亚新几内亚": "Papua New Guinea",
  "波兰": "Poland",
  "波多黎各": "Puerto Rico",
  "朝鲜": "North Korea",
  "葡萄牙": "Portugal",
  "巴拉圭": "Paraguay",
  "卡塔尔": "Qatar",
  "罗马尼亚": "Romania",
  "俄罗斯": "Russia",
  "卢旺达": "Rwanda",
  "西撒哈拉": "Western Sahara",
  "沙特阿拉伯": "Saudi Arabia",
  "苏丹": "Sudan",
  "南苏丹": "South Sudan",
  "塞内加尔": "Senegal",
  "所罗门群岛": "Solomon Islands",
  "塞拉利昂": "Sierra Leone",
  "萨尔瓦多": "El Salvador",
  "索马里兰": "Somaliland",
  "索马里": "Somalia",
  "塞尔维亚": "Serbia",
  "苏里南": "Suriname",
  "斯洛伐克": "Slovakia",
  "斯洛文尼亚": "Slovenia",
  "瑞典": "Sweden",
  "斯威士兰": "Eswatini",
  "叙利亚": "Syria",
  "乍得": "Chad",
  "多哥": "Togo",
  "塔吉克斯坦": "Tajikistan",
  "土库曼斯坦": "Turkmenistan",
  "特里尼达和多巴哥": "Trinidad and Tobago",
  "突尼斯": "Tunisia",
  "土耳其": "Turkey",
  "坦桑尼亚": "Tanzania",
  "乌干达": "Uganda",
  "乌克兰": "Ukraine",
  "乌拉圭": "Uruguay",
  "美国": "United States",
  "乌兹别克斯坦": "Uzbekistan",
  "委内瑞拉": "Venezuela",
  "瓦努阿图": "Vanuatu",
  "西岸": "West Bank",
  "也门": "Yemen",
  "赞比亚": "Zambia",
  "津巴布韦": "Zimbabwe",
  "获取当前的选中状态": "Get Current Selected State",
  "紫外线信息": "UV Information",
  "恢复": "Restore",
  "粘板信息": "Glue Board Information",
  "大飞虫": "Large Flying Insect",
  "小飞虫": "Small Flying Insect",
  "电量": "Battery Level",
  "温湿度信息": "Temperature and Humidity Information",
  "温湿度": "Temperature and Humidity",
  "维保信息": "Maintenance Information",
  "维保": "Maintenance",
  "正常": "Normal",
  "刻度标签": "Scale Label",
  "分隔线": "Separator Line",
  "坐标轴线": "Axis Line",
  "多条拆线图": "Multiple Line Chart",
  "显示内容": "Display Content",
  "坐标轴先": "Axis First",
  "温度": "Temperature",
  "湿度": "Humidity",
  "海门": "Haimen",
  "鄂尔多斯": "Ordos",
  "招远": "Zhaoyuan",
  "舟山": "Zhoushan",
  "齐齐哈尔": "Qiqihar",
  "盐城": "Yancheng",
  "赤峰": "Chifeng",
  "青岛": "Qingdao",
  "乳山": "Rushan",
  "金昌": "Jinchang",
  "泉州": "Quanzhou",
  "莱西": "Laixi",
  "日照": "Rizhao",
  "胶南": "Jiaonan",
  "南通": "Nantong",
  "拉萨": "Lhasa",
  "云浮": "Yunfu",
  "梅州": "Meizhou",
  "文登": "Wendeng",
  "上海": "Shanghai",
  "攀枝花": "Panzhihua",
  "威海": "Weihai",
  "承德": "Chengde",
  "厦门": "Xiamen",
  "汕尾": "Shanwei",
  "潮州": "Chaozhou",
  "丹东": "Dandong",
  "太仓": "Taicang",
  "曲靖": "Qujing",
  "烟台": "Yantai",
  "福州": "Fuzhou",
  "瓦房店": "Wafangdian",
  "即墨": "Jimo",
  "抚顺": "Fushun",
  "玉溪": "Yuxi",
  "张家口": "Zhangjiakou",
  "阳泉": "Yangquan",
  "莱州": "Laizhou",
  "湖州": "Huzhou",
  "汕头": "Shantou",
  "昆山": "Kunshan",
  "宁波": "Ningbo",
  "湛江": "Zhanjiang",
  "揭阳": "Jieyang",
  "荣成": "Rongcheng",
  "连云港": "Lianyungang",
  "葫芦岛": "Huludao",
  "常熟": "Changshu",
  "东莞": "Dongguan",
  "河源": "Heyuan",
  "淮安": "Huai'an",
  "泰州": "Taizhou",
  "南宁": "Nanning",
  "营口": "Yingkou",
  "惠州": "Huizhou",
  "江阴": "Jiangyin",
  "蓬莱": "Penglai",
  "韶关": "Shaoguan",
  "嘉峪关": "Jiayuguan",
  "广州": "Guangzhou",
  "延安": "Yan'an",
  "太原": "Taiyuan",
  "清远": "Qingyuan",
  "中山": "Zhongshan",
  "昆明": "Kunming",
  "寿光": "Shouguang",
  "盘锦": "Panjin",
  "长治": "Changzhi",
  "深圳": "Shenzhen",
  "珠海": "Zhuhai",
  "宿迁": "Suqian",
  "咸阳": "Xianyang",
  "铜川": "Tongchuan",
  "平度": "Pingdu",
  "佛山": "Foshan",
  "海口": "Haikou",
  "江门": "Jiangmen",
  "章丘": "Zhangqiu",
  "肇庆": "Zhaoqing",
  "大连": "Dalian",
  "临汾": "Linfen",
  "吴江": "Wujiang",
  "石嘴山": "Shizuishan",
  "沈阳": "Shenyang",
  "苏州": "Suzhou",
  "茂名": "Maoming",
  "嘉兴": "Jiaxing",
  "长春": "Changchun",
  "胶州": "Jiaozhou",
  "银川": "Yinchuan",
  "张家港": "Zhangjiagang",
  "三门峡": "Sanmenxia",
  "锦州": "Jinzhou",
  "南昌": "Nanchang",
  "柳州": "Liuzhou",
  "三亚": "Sanya",
  "自贡": "Zigong",
  "吉林": "Jilin",
  "阳江": "Yangjiang",
  "泸州": "Luzhou",
  "西宁": "Xining",
  "宜宾": "Yibin",
  "呼和浩特": "Hohhot",
  "成都": "Chengdu",
  "大同": "Datong",
  "镇江": "Zhenjiang",
  "桂林": "Guilin",
  "张家界": "Zhangjiajie",
  "宜兴": "Yixing",
  "北海": "Beihai",
  "西安": "Xi'an",
  "金坛": "Jintan",
  "东营": "Dongying",
  "牡丹江": "Mudanjiang",
  "遵义": "Zunyi",
  "绍兴": "Shaoxing",
  "扬州": "Yangzhou",
  "常州": "Changzhou",
  "潍坊": "Weifang",
  "重庆": "Chongqing",
  "台州": "Taizhou",
  "南京": "Nanjing",
  "滨州": "Binzhou",
  "贵阳": "Guiyang",
  "无锡": "Wuxi",
  "本溪": "Benxi",
  "克拉玛依": "Karamay",
  "渭南": "Weinan",
  "马鞍山": "Ma'anshan",
  "宝鸡": "Baoji",
  "焦作": "Jiaozuo",
  "句容": "Jurong",
  "北京": "Beijing",
  "徐州": "Xuzhou",
  "衡水": "Hengshui",
  "包头": "Baotou",
  "绵阳": "Mianyang",
  "乌鲁木齐": "Urumqi",
  "枣庄": "Zaozhuang",
  "杭州": "Hangzhou",
  "淄博": "Zibo",
  "鞍山": "Anshan",
  "溧阳": "Liyang",
  "库尔勒": "Korla",
  "安阳": "Anyang",
  "开封": "Kaifeng",
  "济南": "Jinan",
  "德阳": "Deyang",
  "温州": "Wenzhou",
  "九江": "Jiujiang",
  "邯郸": "Handan",
  "临安": "Lin'an",
  "兰州": "Lanzhou",
  "沧州": "Cangzhou",
  "临沂": "Linyi",
  "南充": "Nanchong",
  "天津": "Tianjin",
  "富阳": "Fuyang",
  "泰安": "Tai'an",
  "诸暨": "Zhuji",
  "郑州": "Zhengzhou",
  "哈尔滨": "Harbin",
  "聊城": "Liaocheng",
  "芜湖": "Wuhu",
  "唐山": "Tangshan",
  "平顶山": "Pingdingshan",
  "邢台": "Xingtai",
  "德州": "Dezhou",
  "济宁": "Jining",
  "荆州": "Jingzhou",
  "宜昌": "Yichang",
  "义乌": "Yiwu",
  "丽水": "Lishui",
  "洛阳": "Luoyang",
  "秦皇岛": "Qinhuangdao",
  "株洲": "Zhuzhou",
  "石家庄": "Shijiazhuang",
  "莱芜": "Laiwu",
  "常德": "Changde",
  "保定": "Baoding",
  "湘潭": "Xiangtan",
  "金华": "Jinhua",
  "岳阳": "Yueyang",
  "长沙": "Changsha",
  "衢州": "Quzhou",
  "廊坊": "Langfang",
  "菏泽": "Heze",
  "合肥": "Hefei",
  "武汉": "Wuhan",
  "大庆": "Daqing",
  "在这里做一个点击事件的监听，绑定的是": "Here add a click event listener, bound to",
  "方法": "Method",
  "设置样式": "Set Style",
  "雷达图": "Radar Chart",
  "紫外线灯开": "UV Light On",
  "紫外线灯关": "UV Light Off",
  "强度": "Intensity",
  "开关": "Switch",
  "仪表盘刻度的分割段数": "Number of segments on gauge scale",
  "属性": "Property",
  "控制线条样式": "Control line style",
  "刻度": "Scale",
  "线": "Line",
  "样式": "Style",
  "坐标轴小标记": "Axis minor ticks",
  "控制线长": "Control line length",
  "（详见": "(See details",
  "）控制线条样式": ") control line style",
  "其余属性默认使用全局文本样式，详见": "Other properties use global text style by default, see",
  "仪表盘指针。": "Gauge pointer.",
  "是否显示指针": "Whether to show pointer",
  "。": ".",
  "指针长度，可以是绝对数值，也可以是相对于半径的百分比": "Pointer length, can be absolute value or percentage relative to radius",
  "指针宽度": "Pointer width",
  "仪表盘指针样式": "Gauge pointer style",
  "仪表盘详情，用于显示数据": "Gauge detail, used to display data",
  "默认全局居中": "Centered globally by default",
  "，单位": ", unit",
  "速度": "Speed",
  "转速": "Rotation Speed",
  "油表": "Fuel Gauge",
  "水表": "Water Meter",
  "在线离线": "Online Offline",
  "电量趋势": "Battery Trend",
  "→": "→",
  "从网页或其他应用软件复制表格数据，粘贴到这里": "Copy table data from web or other apps, paste here",
  "。默认第一行是表头，使用回车键添加新行，使用": ". First row is header by default. Use Enter to add new row, use",
  "键区分列。": "key to separate columns.",
  "处理粘贴操作": "Handle paste operation",
  "检查除第一行的每一行列数是否与第一行相同": "Check if number of columns in each row (except first) matches first row",
  "标记不符合格式的一行": "Mark rows that don't match format",
  "需要放在菜单上面的内容，如": "Content to place above menu, e.g.",
  "，写在": ", written in",
  "标签内部，如下": "tag, as follows",
  "我的路径": "My Path",
  "初始化设置面包屑导航和标签导航": "Initialize breadcrumb and tag navigation",
  "设置初始语言": "Set initial language",
  "如果当前打开页面不在标签栏中，跳到": "If current open page not in tag bar, jump to",
  "页": "page",
  "示闲": "Idle",
  "示忙": "Busy",
  "语言": "Language",
  "語言": "Language",
  "中文简体": "Simplified Chinese",
  "中文繁体": "Traditional Chinese",
  "重新刷新数据": "Refresh Data",
  "提交请求": "Submit Request",
  "实名认证": "Real-name Authentication",
  "实名认证提交成功": "Real-name authentication submitted successfully",
  "打开帮助中心": "Open Help Center",
  "点击了个人中心": "Clicked Personal Center",
  "登录信息": "Login Information",
  "对于": "For",
  "位，至少包含字母数字其中两种": "digits, must include at least two of letters, numbers",
  "新密码与重复新密码不一致": "New password and repeated new password do not match",
  "用于存储当前上传的文件": "Used to store currently uploaded files",
  "频率不能为空": "Frequency cannot be empty",
  "平台中文名不能为空": "Platform Chinese name cannot be empty",
  "平台英文名不能为空": "Platform English name cannot be empty",
  "代理商不能为空": "Distributor cannot be empty",
  "个人信息": "Personal Information",
  "时区设置不能为空": "Timezone setting cannot be empty",
  "美国（中部）": "USA (Central)",
  "美国（山地）": "USA (Mountain)",
  "美国（太平洋）": "USA (Pacific)",
  "大洋洲": "Oceania",
  "建议": "Suggestions",
  "反馈": "Feedback",
  "购物车": "Shopping Cart",
  "退出全屏": "Exit Fullscreen",
  "全屏": "Fullscreen",
  "全屏方案": "Fullscreen Solution",
  "确保": "Ensure",
  "是必需的": "is required",
  "群呼": "Group Call",
  "点呼": "Point Call",
  "队列，": "Queue,",
  "是否禁用队列开关": "Disable queue switch",
  "切换点呼和群呼": "Switch point call and group call",
  "是否是客服": "Is customer service",
  "不需要国家编码": "No country code needed",
  "事件类型是“分机状态”": "Event type is 'Extension Status'",
  "是分机的当前状态，可以在每个状态内做一些控制操作。": "is the current status of the extension, control operations can be done within each status.",
  "下线、示闲按钮可用，其余不可用": "Offline, Idle buttons available, others disabled",
  "上线按钮可用，其余不可用": "Online button available, others disabled",
  "示闲中": "Idling",
  "示忙、拨号、下线按钮可用，其余不可用": "Busy, Dial, Offline buttons available, others disabled",
  "示忙中": "Busying",
  "示闲、下线按钮可用，其余不可用": "Idle, Offline buttons available, others disabled",
  "通话结束整理中": "Call ended, organizing",
  "此处一般情况会自动调用一次示闲操作。如果不调用，那么每通电话结束后都会是这个状态，话务员需要手工示闲才能打、接电话": "Here usually automatically calls idle operation once. If not called, this state persists after every call, operator must manually idle to make/receive calls.",
  "通话中。不论呼入呼出，都是这个状态，在内部根据其它字段进行详细划分": "In call. Regardless of incoming/outgoing, this state. Detailed division internally based on other fields.",
  "呼入振铃，此处可": "Incoming ring, here can",
  "一个页面作为来电弹屏": "a page as incoming call popup",
  "呼出振铃，此处可": "Outgoing ring, here can",
  "一个页面作为电去弹屏": "a page as outgoing call popup",
  "话务台已接听，无论是呼入接听还是呼出接听都是这个状态": "Console answered, whether incoming or outgoing call answered, this state.",
  "判断当前角色": "Determine current role",
  "是客服": "is customer service",
  "还是销售": "or sales",
  "根据手机号获取客户数据": "Get customer data by phone number",
  "无此客户": "No such customer",
  "自己客户": "Own customer",
  "别人的客户": "Other's customer",
  "电话被挂断": "Call hung up",
  "电话挂断后自动示闲": "Auto idle after call hangup",
  "弹出": "Pop up",
  "删除之前打开的模态框": "Delete previously opened modal",
  "更新客户信息": "Update customer information",
  "新增客户信息": "Add customer information",
  "保存成功": "Save successful",
  "设置需要刷新的列表": "Set list needing refresh",
  "保存失败：请完善客户信息，或记录信息于私有客户列表中重新添加": "Save failed: Complete customer info, or record info in private customer list and re-add",
  "客户姓名必填": "Customer name required",
  "客户情况校验": "Customer situation validation",
  "客户情况至少十个字": "Customer situation at least ten characters",
  "跟进记录为必填内容": "Follow-up record is required",
  "跟进记录至少": "Follow-up record at least",
  "个字": "characters",
  "跟进类型不能为空": "Follow-up type cannot be empty",
  "下次跟进时间为必填内容": "Next follow-up time is required",
  "当回收客户时，跟进类型为必填内容": "When recycling customer, follow-up type is required",
  "当回收客户时，跟进记录为必填内容": "When recycling customer, follow-up record is required",
  "添加请求参数，保存到": "Add request parameters, save to",
  "接口": "API",
  "跟进内容": "Follow-up Content",
  "资质标签": "Qualification Tags",
  "添加客户或是更新客户信息": "Add customer or update customer info",
  "如果传过来的是": "If passed is",
  "保存资质标签": "Save qualification tags",
  "添加跟进": "Add Follow-up",
  "编辑客户信息时": "When editing customer info",
  "保存成功！": "Save successful!",
  "回收客户": "Recycle Customer",
  "判断": "Determine",
  "是否为空": "is empty",
  "客户回访弹屏": "Customer Follow-up Popup",
  "客户回访": "Customer Follow-up",
  "添加回访成功": "Follow-up added successfully",
  "请填写回访记录": "Please fill in follow-up record",
  "关闭所有": "Close All",
  "关闭其他": "Close Others",
  "关闭所有，除了": "Close All Except",
  "关闭除当前页和": "Close All Except Current Page and",
  "页的其他页": "page",
  "标签在可视区域左侧": "Tag left of visible area",
  "标签在可视区域": "Tag in visible area",
  "标签在可视区域右侧": "Tag right of visible area",
  "绑定的值的类型": "Type of bound value",
  "设置": "Set",
  "事件触发时间间隔": "Event trigger interval",
  "是否开启本地存储": "Enable local storage",
  "这个方法一定要在所有配置项之后调用": "This method must be called after all configuration items",
  "如果本地有存储加载本地存储内容": "If local storage exists, load local storage content",
  "拖拽指令": "Drag Directive",
  "这里传入作为拖拽触发器的": "Here pass in the drag trigger's",
  "选择器": "Selector",
  "这里传入需要移动容器的": "Here pass in the container to move's",
  "拖动结束之后是否恢复到原来的位置": "Whether to restore to original position after drag ends",
  "在输入框中使用": "Use in input box",
  "绑定的值": "Bound Value",
  "复制成功后的回调": "Callback after successful copy",
  "复制失败后的回调": "Callback after failed copy",
  "审核通过": "Approved",
  "审核不通过": "Rejected",
  "机构编码不能为空": "Institution code cannot be empty",
  "检查图片的": "Check image",
  "上传之前检查": "Check before upload",
  "删除文件": "Delete File",
  "结果": "Result",
  "删除上传的对象": "Delete uploaded object",
  "文件格式错误": "Invalid file format",
  "类型文件": "type files",
  "文件过大": "File too large",
  "文件大小不能超过": "File size cannot exceed",
  "所属机构": "Affiliated Institution",
  "请选择所属机构": "Please select affiliated institution",
  "机构密码": "Institution Password",
  "请输入机构密码": "Please enter institution password",
  "机构密码不能为空": "Institution password cannot be empty",
  "时间": "Time",
  "请选择时间": "Please select time",
  "类型": "Type",
  "请选择类型": "Please select type",
  "公开课": "Public Course",
  "专家": "Expert",
  "所属机构不能为空": "Affiliated institution cannot be empty",
  "公开课名称": "Public Course Name",
  "当前选择的应用": "Currently Selected App",
  "共用的查询与重置": "Shared Query and Reset",
  "共用的右侧添加按钮": "Shared Add Button on Right",
  "是否企业认证": "Enterprise Certified",
  "编号": "ID",
  "用户姓名": "User Name",
  "性别": "Gender",
  "用户电话": "User Phone",
  "预约类型": "Appointment Type",
  "专题": "Topic",
  "意向咨询师": "Preferred Consultant",
  "意向咨询时间": "Preferred Consultation Time",
  "预约时间": "Appointment Time",
  "预约状态": "Appointment Status",
  "预约成功": "Appointment Successful",
  "待确认": "Pending Confirmation",
  "拒绝": "Rejected",
  "取消预约": "Cancel Appointment",
  "审核": "Review",
  "新增": "Add",
  "机构介绍": "Institution Introduction",
  "机构名称": "Institution Name",
  "机构主页": "Institution Homepage",
  "机构负责人": "Institution Head",
  "联系电话": "Contact Number",
  "机构地址": "Institution Address",
  "请输入机构名称": "Please enter institution name",
  "请输入机构负责人": "Please enter institution head",
  "请输入联系电话": "Please enter contact number",
  "请输入机构地址": "Please enter institution address",
  "机构": "Institution",
  "查看图片": "View Image",
  "机构名称不能为空": "Institution name cannot be empty",
  "图片不能为空": "Image cannot be empty",
  "机构负责人不能为空": "Institution head cannot be empty",
  "联系电话不能为空": "Contact number cannot be empty",
  "机构地址不能为空": "Institution address cannot be empty",
  "机构简介不能为空": "Institution introduction cannot be empty",
  "姓名": "Name",
  "请输入姓名": "Please enter name",
  "咨询师头像": "Consultant Avatar",
  "电话": "Phone",
  "请输入电话": "Please enter phone",
  "身份证号": "ID Card Number",
  "请输入身份证号": "Please enter ID card number",
  "职位": "Position",
  "请输入职位": "Please enter position",
  "专业": "Specialty",
  "请输入专业": "Please enter specialty",
  "擅长": "Expertise",
  "请输入擅长": "Please enter expertise",
  "简介": "Introduction",
  "请输入简介": "Please enter introduction",
  "姓名不能为空": "Name cannot be empty",
  "电话号码不能为空": "Phone number cannot be empty",
  "电话号码格式不合法": "Invalid phone number format",
  "身份证号码不能为空": "ID card number cannot be empty",
  "身份证输入不合法": "Invalid ID card input",
  "职位不能为空": "Position cannot be empty",
  "专业不能为空": "Specialty cannot be empty",
  "擅长不能为空": "Expertise cannot be empty",
  "咨询师头像不能为空": "Consultant avatar cannot be empty",
  "简介不能为空": "Introduction cannot be empty",
  "请输入公开课名称": "Please enter public course name",
  "请选择专题": "Please select topic",
  "讲师": "Lecturer",
  "请选择讲师": "Please select lecturer",
  "请选择开始和结束时间": "Please select start and end time",
  "最大人数": "Max Participants",
  "请输入最大人数": "Please enter max participants",
  "标签": "Tags",
  "团体咨询": "Group Counseling",
  "课程描述": "Course Description",
  "公开课名称不能为空": "Public course name cannot be empty",
  "专题不能为空": "Topic cannot be empty",
  "咨询师不能为空": "Consultant cannot be empty",
  "时间不能为空": "Time cannot be empty",
  "最大人数不能为空": "Max participants cannot be empty",
  "课程描述不能为空": "Course description cannot be empty",
  "标签不能为空": "Tags cannot be empty",
  "修改机构": "Modify Institution",
  "或": "or",
  "机构不能为空": "Institution cannot be empty",
  "导入文件不能为空": "Import file cannot be empty",
  "查看报名人数": "View Registrants",
  "所属专题": "Belonging Topic",
  "开课时间": "Course Start Time",
  "过滤预约记录": "Filter Appointment Records",
  "您确定要": "Are you sure you want to",
  "所属分类": "Belonging Category",
  "请选择所属分类": "Please select belonging category",
  "题目": "Questions",
  "下载模板": "Download Template",
  "测评专题": "Assessment Topic",
  "预约专题": "Appointment Topic",
  "所属分类不能为空": "Belonging category cannot be empty",
  "题目文件不能为空": "Questions file cannot be empty",
  "测评分类": "Assessment Category",
  "题目名称": "Question Name",
  "对应机构密码": "Corresponding Institution Password",
  "查看对应机构密码": "View Corresponding Institution Password",
  "添加数组": "Add Array",
  "专题名称": "Topic Name",
  "专题类型": "Topic Type",
  "请输入专题名称": "Please enter topic name",
  "请选择专题类型": "Please select topic type",
  "专题名称不能为空": "Topic name cannot be empty",
  "接口名称": "API Name",
  "请输入接口名称": "Please enter API name",
  "所属模块": "Belonging Module",
  "请选择模块": "Please select module",
  "模块": "Module",
  "接口说明": "API Description",
  "请输入接口说明": "Please enter API description",
  "请选择所属模块": "Please select belonging module",
  "接口名称筛选": "API Name Filter",
  "全部模块": "All Modules",
  "全部状态": "All Statuses",
  "请输入模块名": "Please enter module name",
  "请输入模块代码": "Please enter module code",
  "初始化数据": "Initialize Data",
  "重置搜索框": "Reset Search Box",
  "翻页": "Page Turn",
  "控制模态框显示隐藏": "Control modal show/hide",
  "显示隐藏": "Show/Hide",
  "本条数据": "This data",
  "新增接口": "Add API",
  "添加成功！": "Added successfully!",
  "编辑接口": "Edit API",
  "修改成功！": "Modified successfully!",
  "删除接口": "Delete API",
  "确认删除接口": "Confirm delete API",
  "删除成功！": "Deleted successfully!",
  "模块代码": "Module Code",
  "加载": "Load",
  "新增模块": "Add Module",
  "修改模块": "Modify Module",
  "删除模块": "Delete Module",
  "确认删除模块": "Confirm delete module",
  "请输入模块": "Please enter module",
  "模块名称": "Module Name",
  "请输入模块名称": "Please enter module name",
  "描述": "Description",
  "请输入描述！": "Please enter description!",
  "表单字段": "Form Field",
  "防止表单未注册": "Prevent form unregistered",
  "当": "When",
  "发生改变时，为表单设置值": "changes, set value for form",
  "角色": "Role",
  "是否默认": "Is Default",
  "判断当前行是否可以点击": "Determine if current row is clickable",
  "控制是否禁用": "Control whether disabled",
  "只有在可编辑的情况下才进行状态变化": "State change only when editable",
  "直接允许状态变化": "Directly allow state change",
  "开": "On",
  "关": "Off",
  "权限配置": "Permission Configuration",
  "获取选中项目获取选中及半选节点": "Get selected items, get selected and half-selected nodes",
  "数组中是否存在": "Whether exists in array",
  "当没有会选时，将": "When no selection, set",
  "强行加入": "Forcibly add",
  "先取编辑时所先的值": "First take the value selected during editing",
  "如果没有": "If not",
  "再从原信息里面取": "Then get from original info",
  "组成的数组": "composed array",
  "我的角色管理数据": "My role management data",
  "新增角色": "Add Role",
  "编辑角色": "Edit Role",
  "编辑提交": "Edit Submit",
  "请检查必填项": "Please check required fields",
  "确认删除角色": "Confirm delete role",
  "获取相应权限": "Get corresponding permissions",
  "接口配置": "API Configuration",
  "当前": "Current",
  "当前所选的列": "Currently selected columns",
  "所属于的接口": "Belonging API",
  "选中的项": "Selected Items",
  "当前选中的接口列表": "Currently selected API list",
  "初始化接口配置": "Initialize API configuration",
  "接口取消": "API Cancel",
  "接口保存": "API Save",
  "当前所选": "Current Selection",
  "配置接口": "Configure API",
  "选择配置接口": "Select Configuration API",
  "设置当前的": "Set current",
  "清空选择项": "Clear Selection",
  "选中菜单权限的": "Selected menu permissions'",
  "角色说明": "Role Description",
  "请输入角色说明": "Please enter role description",
  "新增子菜单": "Add Submenu",
  "新增页面": "Add Page",
  "请查看父级模块": "Please check parent module",
  "模块名必填": "Module name required",
  "模块说明必填": "Module description required",
  "首先判断一下，是页面": "First determine if it's a page",
  "还是子菜单": "or submenu",
  "子菜单": "Submenu",
  "页面": "Page",
  "判断是否是顶级菜单": "Determine if top-level menu",
  "编辑菜单": "Edit Menu",
  "编辑成功！": "Edited successfully!",
  "删除菜单": "Delete Menu",
  "确定是否删除该菜单？": "Confirm delete this menu?",
  "添加子页面": "Add Subpage",
  "编辑页面": "Edit Page",
  "修改页面": "Modify Page",
  "删除页面": "Delete Page",
  "确定是否删除该页面？": "Confirm delete this page?",
  "修改接口配置": "Modify API Configuration",
  "上级菜单": "Parent Menu",
  "页面名称": "Page Name",
  "请输入页面名称": "Please enter page name",
  "路径": "Path",
  "请输入路径": "Please enter path",
  "排序": "Sort",
  "请输入排序": "Please enter sort order",
  "页面说明": "Page Description",
  "请输入页面说明": "Please enter page description",
  "请选择接口配置": "Please select API configuration",
  "菜单名称": "Menu Name",
  "请输入菜单名称": "Please enter menu name",
  "菜单说明": "Menu Description",
  "请输入菜单说明": "Please enter menu description",
  "设备属性配置": "Device Property Configuration",
  "用户名称筛选": "User Name Filter",
  "采购单价": "Purchase Unit Price",
  "税率": "Tax Rate",
  "以下，": "Below,",
  "表示": "Indicates",
  "手机号": "Phone Number",
  "用户名称": "User Name",
  "企业名称": "Company Name",
  "创建日期": "Creation Date",
  "详情": "Details",
  "详细信息": "Detailed Information",
  "您真的想": "Do you really want to",
  "这个帐号吗？": "this account?",
  "帐号信息": "Account Information",
  "您真的想删除这个": "Do you really want to delete this",
  "帐号": "Account",
  "请输入帐号": "Please enter account",
  "验证码": "Verification Code",
  "密码": "Password",
  "请选择角色": "Please select role",
  "请输入企业名称": "Please enter company name",
  "获取验证码": "Get Verification Code",
  "验证码不能为空": "Verification code cannot be empty",
  "重新获取验证码": "Resend Verification Code",
  "验证码发送成功": "Verification code sent successfully",
  "累计预约排名": "Cumulative Appointment Ranking",
  "身份证": "ID Card",
  "获取机构列表": "Get Institution List",
  "预约用户": "Appointment Users",
  "人": "People",
  "咨询用户": "Consultation Users",
  "人次": "Person-times",
  "数据详情": "Data Details",
  "周": "Week",
  "预约用户（人次）": "Appointment Users (Person-times)",
  "测评用户（人次）": "Assessment Users (Person-times)",
  "专题预约占比": "Topic Appointment Proportion",
  "专题预约次数": "Topic Appointment Count",
  "次": "Times",
  "评测分类名称": "Assessment Category Name",
  "请输入评测分类名称": "Please enter assessment category name",
  "评测分类名称为空": "Assessment category name is empty",
  "名称": "Name",
  "机构密码吗？": "institution password?",
  "心灵密码": "Mind Password",
  "下载导入模板": "Download Import Template",
  "测评时间": "Assessment Time",
  "综合评分": "Comprehensive Score",
  "综合建议": "Comprehensive Suggestions",
  "评测详细": "Assessment Details",
  "得分": "Score",
  "测评得分": "Assessment Score",
  "用户": "User",
  "产品激活占比": "Product Activation Proportion",
  "产品故障占比": "Product Fault Proportion",
  "产品活跃占比": "Product Active Proportion",
  "累计设备激活排名": "Cumulative Device Activation Ranking",
  "产品激活数量": "Product Activation Count",
  "产品活跃数量": "Product Active Count",
  "付费产品数量": "Paid Product Count",
  "国家": "Country",
  "设备激活": "Device Activation",
  "个": "Units",
  "商品销售额": "Product Sales",
  "元": "Yuan",
  "总览": "Overview",
  "服务": "Service",
  "当前年月日": "Current Year-Month-Day",
  "产品激活": "Product Activation",
  "注册用户": "Registered Users",
  "销售总额趋势图": "Total Sales Trend Chart",
  "用户活跃": "User Active",
  "设备活跃": "Device Active",
  "新增商品订单趋势": "New Product Order Trend",
  "今天": "Today",
  "活跃比例": "Active Proportion",
  "故障比例": "Fault Proportion",
  "用户注册占比": "User Registration Proportion",
  "销售量占比": "Sales Volume Proportion",
  "销售额占比": "Sales Amount Proportion",
  "在线的设备数": "Online Device Count",
  "增长": "Growth",
  "趋势钱": "Trend Money",
  "数据统计": "Data Statistics",
  "获取当前时间数据": "Get Current Time Data",
  "判断是否全屏情况": "Determine if fullscreen",
  "移除事件监听": "Remove Event Listener",
  "设备统计": "Device Statistics",
  "报警统计": "Alarm Statistics",
  "报警总数": "Total Alarms",
  "近一年新增设备数": "New Devices Added in Past Year",
  "客户负责人": "Customer Responsible",
  "维保人员": "Maintenance Personnel",
  "警情记录": "Alarm Record",
  "项目": "Project",
  "发生【": "Occurred [",
  "】报警": "] Alarm",
  "项目列表": "Project List",
  "项目名称搜索": "Project Name Search",
  "设备数据详情": "Device Data Details",
  "项目名称：": "Project Name:",
  "坐标": "Coordinates",
  "在线设备": "Online Devices",
  "离线设备": "Offline Devices",
  "故障设备": "Faulty Devices",
  "告警总数": "Total Alarms",
  "项目名称": "Project Name",
  "设备数量": "Device Count",
  "获取报警统计": "Get Alarm Statistics",
  "近一年的新增设备统计": "New Device Statistics for Past Year",
  "获取未处理的告警": "Get Unprocessed Alarms",
  "您还有": "You still have",
  "条报警信息未处理，请及时处理": "unprocessed alarms, please handle promptly",
  "获取告警记录": "Get Alarm Records",
  "获取项目及设备统计": "Get Project and Device Statistics",
  "点击行数时": "When clicking row number",
  "未在地图上标注": "Not marked on map",
  "未处理的告警": "Unprocessed Alarms",
  "设备名称：": "Device Name:",
  "设备序号：": "Device Serial:",
  "报警类型：": "Alarm Type:",
  "报警时间：": "Alarm Time:",
  "所属项目：": "Belonging Project:",
  "防治分类：": "Control Category:",
  "位置：": "Location:",
  "处理状态：": "Processing Status:",
  "处理详述：": "Processing Details:",
  "查看维保信息": "View Maintenance Info",
  "处理状态不能为空": "Processing status cannot be empty",
  "暂无维保信息": "No maintenance information",
  "处理描述：": "Processing Description:",
  "提交": "Submit",
  "报警记录": "Alarm Record",
  "报警内容": "Alarm Content",
  "信息统计": "Information Statistics",
  "警情监控": "Alarm Monitoring",
  "设备激活占比": "Device Activation Proportion",
  "商品销售总额": "Total Product Sales",
  "注册用户数": "Registered User Count",
  "对比列表": "Comparison List",
  "当前设备在线数": "Current Online Device Count",
  "新增端口订单趋势": "New Port Order Trend",
  "地图数据": "Map Data",
  "数据": "Data",
  "底部左": "Bottom Left",
  "底部右": "Bottom Right",
  "下拉国别": "Dropdown Country",
  "返回控制台": "Return to Console",
  "代理商数量": "Distributor Count",
  "用户总数": "Total Users",
  "平台接入设备总数": "Total Platform Connected Devices",
  "点击我": "Click Me",
  "商户名称：": "Merchant Name:",
  "商户负责人：": "Merchant Responsible:",
  "商户联系电话：": "Merchant Contact:",
  "控制器数量：": "Controller Count:",
  "探测器数量：": "Detector Count:",
  "巡检时间：最近": "Inspection Time: Recent",
  "查看照片": "View Photos",
  "设备告警": "Device Alarm",
  "甲烷": "Methane",
  "氢气": "Hydrogen",
  "可燃气": "Combustible Gas",
  "硫化氢": "Hydrogen Sulfide",
  "氧气": "Oxygen",
  "传感器列表": "Sensor List",
  "排行数值列表": "Ranking Value List",
  "设备在线数量": "Online Device Count",
  "设备离线数量": "Offline Device Count",
  "在线率": "Online Rate",
  "商户": "Merchant",
  "管理员": "Administrator",
  "普通用户": "Regular User",
  "平台维护": "Platform Maintenance",
  "超级管理员": "Super Administrator",
  "获取商户列表": "Get Merchant List",
  "获取逆解析方法实例": "Get Reverse Geocode Method Instance",
  "获取自动定位方法": "Get Auto Location Method",
  "地图点击事件": "Map Click Event",
  "获取时": "Get Hour",
  "获取分": "Get Minute",
  "获取秒": "Get Second",
  "时": "Hour",
  "分": "Minute",
  "中部设备地图": "Center Device Map",
  "右边顶部角色统计": "Top Right Role Statistics",
  "用户活跃统计": "User Activity Statistics",
  "左侧顶部在线率": "Top Left Online Rate",
  "日告警数量分析": "Daily Alarm Count Analysis",
  "告警排行": "Alarm Ranking",
  "告警排行分析": "Alarm Ranking Analysis",
  "，": ", ",
  "红色；": "Red; ",
  "黄色；": "Yellow; ",
  "其它，绿色": "Others, Green",
  "设置播放状态": "Set Playback State",
  "如果你还需要水平居中，可以加上这个属性": "If you also need horizontal centering, add this property",
  "的高度": "height",
  "为了清楚地展示": "To clearly display",
  "的边界": "boundary",
  "的设备屏幕": "device screen",
  "商品销售额占比": "Product Sales Proportion",
  "商品订阅占比": "Product Subscription Proportion",
  "商品销售量占比": "Product Sales Volume Proportion",
  "累计销售排名": "Cumulative Sales Ranking",
  "销售总额": "Total Sales",
  "销售总量": "Total Sales Volume",
  "新增订阅": "New Subscriptions",
  "订阅比例": "Subscription Proportion",
  "产品注册占比": "Product Registration Proportion",
  "用户付费占比": "User Payment Proportion",
  "累计用户注册排名": "Cumulative User Registration Ranking",
  "注册总数": "Total Registrations",
  "活跃总数": "Total Active",
  "付费总数": "Total Paid",
  "付费占比": "Payment Proportion",
  "付费比例": "Payment Ratio",
  "注册用户总数": "Total Registered Users",
  "活跃用户总数": "Total Active Users",
  "付费用户总数": "Total Paying Users",
  "周一": "Monday",
  "周二": "Tuesday",
  "周三": "Wednesday",
  "周四": "Thursday",
  "周五": "Friday",
  "周六": "Saturday",
  "周日": "Sunday",
  "运营商": "Operator",
  "网络服务": "Network Service",
  "总量": "Total",
  "银行": "Bank",
  "证券": "Securities",
  "游戏": "Game",
  "视频": "Video",
  "餐饮": "Catering",
  "外卖": "Takeout",
  "快递": "Express",
  "电商": "E-commerce",
  "左边": "Left",
  "充放电趋势": "Charge/Discharge Trend",
  "中间": "Center",
  "右边": "Right",
  "总容量": "Total Capacity",
  "值": "Value",
  "右侧告警": "Right Alarms",
  "大屏左下方近": "Bottom Left of Large Screen Recent",
  "日激活": "Daily Activations",
  "仅顶级账号可见": "Visible only to top-level accounts",
  "大屏左上角在线数据": "Top Left of Large Screen Online Data",
  "获取顶部数据": "Get Top Data",
  "找到时打印": "Print when found",
  "添加标记到地图": "Add Marker to Map",
  "创建自定义样式的": "Create custom styled",
  "位置": "Position",
  "创建": "Create",
  "使用自定义样式的内容": "Content with custom style",
  "添加点击事件": "Add Click Event",
  "我的": "My",
  "我的大屏数据": "My Large Screen Data",
  "我的列表数据": "My List Data",
  "顶部数据": "Top Data",
  "获取大屏左下方近": "Get Bottom Left of Large Screen Recent",
  "头部": "Header",
  "收缩": "Collapse",
  "全屏时": "When fullscreen",
  "激活状态筛选": "Activation Status Filter",
  "所属经销商": "Belonging Distributor",
  "：": ": ",
  "总电压：": "Total Voltage: ",
  "总电流：": "Total Current: ",
  "请选择日期": "Please select date",
  "至": "to",
  "起点：": "Start Point: ",
  "终点：": "End Point: ",
  "用时": "Time Taken",
  "里程": "Mileage",
  "耗电": "Power Consumption",
  "起点": "Start Point",
  "四川省成都市武侯区环球中心": "Global Center, Wuhou District, Chengdu, Sichuan",
  "终点": "End Point",
  "四川省成都市龙泉驿区龙泉山": "Longquan Mountain, Longquanyi District, Chengdu, Sichuan",
  "公里": "kilometers",
  "暂停": "Pause",
  "继续": "Continue",
  "重放": "Replay",
  "拉取行程": "Pull Trip",
  "拉取点": "Pull Point",
  "拉取其他点": "Pull Other Points",
  "拉取轨迹": "Pull Trajectory",
  "拉取其他店": "Pull Other Stores",
  "这里获取了检索的位置并跳转": "Here gets the retrieved location and jumps",
  "创建一个新的图标，可以是任意的图片": "Create a new icon, can be any image",
  "将新的图标应用到标记上": "Apply the new icon to the marker",
  "画轨迹": "Draw Trajectory",
  "先注释掉地图": "First comment out the map",
  "微软雅黑": "Microsoft YaHei",
  "修改垂直滚动条": "Modify vertical scrollbar",
  "修改宽度": "Modify width",
  "修改滚动条轨道背景色": "Modify scrollbar track background color",
  "修改滚动条滑块颜色": "Modify scrollbar thumb color",
  "修改滚动条滑块悬停时的颜色": "Modify scrollbar thumb hover color",
  "修改滚动条滑块移动时的颜色": "Modify scrollbar thumb active color",
  "修改滚动条滑块的圆角": "Modify scrollbar thumb border radius",
  "重点参数：": "Key Parameters:",
  "轨迹回放控制": "Trajectory Playback Control",
  "开始动画": "Start Animation",
  "暂停动画": "Pause Animation",
  "继续动画": "Resume Animation",
  "停止动画": "Stop Animation",
  "地图实例": "Map Instance",
  "巡航器实例": "Cruise Control Instance",
  "当前播放轨迹下标": "Current Playback Trajectory Index",
  "轨迹实例": "Trajectory Instance",
  "是否播放": "Is Playing",
  "是否完成": "Is Completed",
  "播放器总数": "Total Players",
  "播放器当前数": "Current Player Count",
  "下次播放轨迹从当前值开始": "Next playback trajectory starts from current value",
  "每段路的起止坐标": "Start and end coordinates of each road segment",
  "轨迹坐标": "Trajectory Coordinates",
  "当前播放速度下标": "Current Playback Speed Index",
  "速度列表，可自定义配置": "Speed list, customizable",
  "进度": "Progress",
  "加载地图": "Load Map",
  "级别": "Level",
  "中心点坐标": "Center Point Coordinates",
  "默认在杭州": "Default in Hangzhou",
  "创建一个": "Create a",
  "图标尺寸": "Icon Size",
  "图标的取图地址": "Icon image URL",
  "图标所用图片大小": "Icon image size",
  "图标取图偏移量": "Icon image offset",
  "将": "Set",
  "传入": "to",
  "的路径参数为模块名中": "'s path parameter as the module name",
  "之后的部分": "after",
  "当前环境不支持": "Current environment does not support",
  "！": "!",
  "启动页面": "Start Page",
  "图片加载成功，重新绘制一次": "Image loaded successfully, redraw once",
  "图片加载失败！": "Image loading failed!",
  "轨迹线的样式": "Trajectory line style",
  "巡航器初始化": "Cruise Control Initialization",
  "创建一个巡航器": "Create a cruise control",
  "判断是否传入": "Determine if passed",
  "关联第": "Associate with the",
  "条轨迹": "trajectory",
  "循环播放": "Loop Playback",
  "清空走过的路线": "Clear traveled route",
  "开始播放": "Start Playback",
  "路段未开始并且没有结束的时候": "When the road segment has not started and not ended",
  "暂停恢复动画": "Pause/Resume Animation",
  "并且动画没有完成的时候": "and animation is not completed",
  "判断是否传入初始坐标": "Determine if initial coordinates are passed",
  "巡航完成事触发": "Cruise completion event triggered",
  "暂停播放": "Pause Playback",
  "停止": "Stop",
  "停止播放": "Stop Playback",
  "为重新播放准备": "Prepare for replay",
  "查询当前位置": "Query current location",
  "创建地图": "Create Map",
  "初始化地图中心点": "Initialize map center point",
  "修改": "Modify",
  "相对于": "Relative to",
  "的位置": "position",
  "设备当前位置": "Device current position",
  "设置文本标注偏移量": "Set text label offset",
  "时间：": "Time: ",
  "详细地址：": "Detailed Address: ",
  "经度：": "Longitude: ",
  "纬度：": "Latitude: ",
  "设置文本标注内容": "Set text label content",
  "正在播放禁止拖拽播放器": "Playing, dragging player is prohibited",
  "新的样式": "New style",
  "默认使用": "Use by default",
  "模式，如果希望使用带有俯仰角的": "mode, if want to use with pitch angle",
  "模式，请设置": "mode, please set",
  "初始化地图层级": "Initialize map level",
  "打开高德地图": "Open Gaode Map",
  "所属的地图实例": "Belonging map instance",
  "将点、线相关的": "Point and line related",
  "全部置": "all set to",
  "中间点": "Midpoint",
  "使用图片": "Use image",
  "经过路径的样式": "Passed path style",
  "轨迹回放": "Trajectory Playback",
  "选中拉": "Selected Pull",
  "创建标注": "Create Annotation",
  "将标注添加到地图中": "Add annotation to map",
  "指定定位位置。": "Specify positioning location.",
  "当标注显示在地图上时，其所指向的地理位置距离图标左上": "When the annotation is displayed on the map, the geographic location it points to is",
  "角各偏移": "pixels offset from the top left corner of the icon",
  "像素和": "pixels and",
  "像素。您可以看到在本例中该位置即是": "pixels. You can see in this example that location is the",
  "图标中央下端的尖角位置。": "pointed tip at the bottom center of the icon.",
  "设置图片偏移。": "Set image offset.",
  "当您需要从一幅较大的图片中截取某部分作为标注图标时，您": "When you need to crop a portion of a larger image as the annotation icon, you",
  "需要指定大图的偏移位置，此做法与": "need to specify the offset position of the large image, similar to",
  "技术类似。": "technology.",
  "设置图片偏移": "Set Image Offset",
  "创建标注对象并添加到地图": "Create annotation object and add to map",
  "导出日志记录": "Export Log Records",
  "注：这里只会显示成功保存到服务端的错误日志，而且页面错误日志不会在浏览器持久化存储，刷新页面即会丢失": "Note: Only error logs successfully saved to the server are displayed here. Page error logs are not persistently stored in the browser and will be lost upon page refresh.",
  "信息": "Information",
  "错误日志": "Error Log",
  "请输入现在使用的密码": "Please enter your current password",
  "请输入新密码，至少": "Please enter new password, at least",
  "位字符": "characters",
  "确认新密码": "Confirm New Password",
  "请再次输入新密码": "Please re-enter new password",
  "两次输入密码不一致": "Passwords entered twice do not match",
  "请输入原密码": "Please enter original password",
  "请至少输入": "Please enter at least",
  "个字符": "characters",
  "最多输入": "Enter at most",
  "保存编辑后内容": "Save edited content",
  "密码编辑": "Password Edit",
  "编辑密码": "Edit Password",
  "编辑密码模态框显示": "Edit Password Modal Show",
  "是否认证": "Is Authenticated",
  "账号类型": "Account Type",
  "请输入企业编码": "Please enter enterprise code",
  "企业编码为": "Enterprise code is",
  "位大字字母和数字": "digits uppercase letters and numbers",
  "位字母和数字": "digits letters and numbers",
  "请输入企业名称（中文": "Please enter company name (Chinese",
  "请输入企业名称（英文": "Please enter company name (English",
  "请输入手机号": "Please enter phone number",
  "手机号格式不对": "Invalid phone number format",
  "街道地址必填": "Street address required",
  "邮箱必填": "Email required",
  "不正确的电子邮件格式": "Incorrect email format",
  "判断当前状态": "Determine current status",
  "判断企业编码是否填写": "Determine if enterprise code is filled",
  "判断是否进行实名认证": "Determine if real-name authentication is performed",
  "实名认证中": "Real-name authentication in progress",
  "未配置接口地址，请设置": "API address not configured, please set",
  "升级账号": "Upgrade Account",
  "编辑账号": "Edit Account",
  "拉取区域": "Pull Region",
  "只级一级国家": "Only level one countries",
  "编辑地址": "Edit Address",
  "原账号必填": "Original account required",
  "新账号必填": "New account required",
  "判断帐号类型": "Determine account type",
  "接收部门": "Receiving Department",
  "请选择部门": "Please select department",
  "接收人": "Recipient",
  "请先选部门": "Please select department first",
  "再选接收人": "then select recipient",
  "反馈内容": "Feedback Content",
  "请输入反馈内容": "Please enter feedback content",
  "上传附件": "Upload Attachment",
  "限制": "Limit",
  "内的": "within",
  "格式图片": "format images",
  "是否匿名": "Anonymous",
  "否": "No",
  "是": "Yes",
  "选择的部门": "Selected Department",
  "反馈接受对象": "Feedback Recipient",
  "附件，用": "Attachment, separated by",
  "隔开，如果有多个的话": "if multiple",
  "请选择反馈": "Please select feedback",
  "意见接收人": "Feedback Recipient",
  "请填写内容": "Please fill in content",
  "回复": "Reply",
  "查询部门下得人员": "Query personnel under department",
  "": "",
  "获取组织树": "Get Organization Tree",
  "已经有帐号": "Already have an account",
  "审核中": "Under Review",
  "审核失败": "Review Failed",
  "提交成功，我们正在审核，我们会在": "Submitted successfully, under review. We will respond within",
  "小时内给您回复，请耐心等待": "hours, please wait patiently",
  "倒计时": "Countdown",
  "尊敬的": "Dear",
  "的公司": "'s company",
  "您好！我们很高兴的通知您，您的企业认证已经成功通过审核！您可以完整的使用我们平台提供的服务。祝您使用愉快！": "Hello! We are pleased to inform you that your enterprise certification has been approved! You can fully use our platform services. Enjoy!",
  "公司": "Company",
  "您好！我们非常遗憾的通知您，您的企业认证审核失败了！您可以通过修改以下存在的问题，重新发起审核。": "Hello! We regret to inform you that your enterprise certification review failed! You can modify the existing issues and resubmit for review.",
  "秒转时分秒，求模很重要，数字的下舍入": "Seconds to HH:MM:SS, modulo is important, floor the number",
  "定时器": "Timer",
  "查看企业账号": "View Enterprise Account",
  "为未提交企业认证，，": "is unsubmitted enterprise certification,",
  "为等待审核，": "is pending review,",
  "为审核通过，": "is approved,",
  "为审核失败": "is review failed",
  "未提交企业认证": "Unsubmitted Enterprise Certification",
  "切换到添加界面": "Switch to add interface",
  "切换到结果界面": "Switch to result interface",
  "上一步操作": "Previous Step",
  "下一步操作": "Next Step",
  "提交数据": "Submit Data",
  "重新提交企业认证信息": "Resubmit enterprise certification information",
  "企业编码": "Enterprise Code",
  "位企业编码": "digit enterprise code",
  "企业编码不能为空": "Enterprise code cannot be empty",
  "文件访问前缀": "File Access Prefix",
  "下载链接": "Download Link",
  "…": "…",
  "跳转到确认认证页面": "Jump to confirmation certification page",
  "上一步需要回填的数据": "Data to backfill in previous step",
  "确认认证资料": "Confirm Certification Materials",
  "社会信用代码": "Unified Social Credit Code",
  "请输入社会信用代码": "Please enter unified social credit code",
  "法人姓名": "Legal Person Name",
  "请输入法人姓名": "Please enter legal person name",
  "所在地区": "Location",
  "邮箱": "Email",
  "授权认证": "Authorization Certification",
  "下载授权认证": "Download Authorization Certification",
  "营业执照": "Business License",
  "下载营业执照": "Download Business License",
  "通知公告条件筛选": "Notice Filter",
  "反馈时间": "Feedback Time",
  "反馈类型（是或否匿名）": "Feedback Type (Anonymous or Not)",
  "请填写反馈内容": "Please fill in feedback content",
  "反馈类型": "Feedback Type",
  "匿名": "Anonymous",
  "实名": "Real Name",
  "意见反馈人": "Feedback Provider",
  "反馈附件": "Feedback Attachment",
  "回复人": "Replier",
  "回复时间": "Reply Time",
  "回复内容": "Reply Content",
  "是否将弹层放置于": "Whether to place popup in",
  "内，在": ", in",
  "、带有": ", with",
  "列内使用时，建议添加此属性": "columns, it is recommended to add this property",
  "反馈人：": "Feedback Provider: ",
  "反馈时间：": "Feedback Time: ",
  "反馈内容：": "Feedback Content: ",
  "附件：": "Attachment: ",
  "升级企业账号": "Upgrade Enterprise Account",
  "企业信息": "Enterprise Information",
  "请填写您的企业信息": "Please fill in your enterprise information",
  "下载授权认证模板，签订盖好企业公章后上传至平台审核": "Download authorization template, sign and stamp with company seal, then upload for platform review",
  "上传文件": "Upload File",
  "已上传一个文件": "One file uploaded",
  "下一步": "Next",
  "授权认证模板": "Authorization Template",
  "上一步": "Previous",
  "重新填写企业信息": "Refill enterprise information",
  "审核状态": "Review Status",
  "请输入企业信用代码": "Please enter enterprise credit code",
  "请上传营业执照": "Please upload business license",
  "具体地址必填": "Specific address required",
  "请填写邮箱": "Please fill in email",
  "请上传文件": "Please upload file",
  "认证中": "Certifying",
  "显示倒计时": "Show Countdown",
  "上传图显示": "Upload Image Display",
  "示例图地址": "Example Image URL",
  "提交实名认证": "Submit Real-name Authentication",
  "实名认证成功": "Real-name Authentication Successful",
  "更新": "Update",
  "获取示例图": "Get Example Image",
  "示例图": "Example Image",
  "图片": "Image",
  "重新实名认证": "Re-authenticate Real-name",
  "回填实名认证信息": "Backfill Real-name Authentication Info",
  "您没有浏览这个页面的权限": "You don't have permission to view this page",
  "返回首页": "Return to Home",
  "返回上一页": "Return to Previous Page",
  "您的页面好像飞走了": "Your page seems to have flown away",
  "鬼知道服务器经历了什么": "Who knows what the server experienced",
  "基本信息": "Basic Information",
  "客户基本信息": "Customer Basic Information",
  "客户姓名": "Customer Name",
  "客户电话": "Customer Phone",
  "上门日期": "On-site Date",
  "类别": "Category",
  "客户来源": "Customer Source",
  "申请贷款金额": "Loan Application Amount",
  "签约日期": "Signing Date",
  "合同类型": "Contract Type",
  "抵押": "Mortgage",
  "权证": "Warrant",
  "信贷": "Credit",
  "垫资": "Advance Funding",
  "合同信息": "Contract Information",
  "合同": "Contract",
  "签约时间": "Signing Time",
  "签约金额": "Signing Amount",
  "合同状态": "Contract Status",
  "报审信息": "Submission Information",
  "签约数据": "Signing Data",
  "收款合计": "Total Receipts",
  "退款合计": "Total Refunds",
  "实收款合计": "Actual Receipts Total",
  "客服回访": "Customer Service Follow-up",
  "客户回访内容": "Customer Follow-up Content",
  "请输入至少": "Please enter at least",
  "个字以上": "characters",
  "渠道名称": "Channel Name",
  "批款金额": "Approval Amount",
  "成本": "Cost",
  "返点": "Rebate",
  "渠道成本": "Channel Cost",
  "报审人": "Submitter",
  "报审时间": "Submission Time",
  "放款日期": "Disbursement Date",
  "费用类型": "Fee Type",
  "收": "Receive",
  "退款时间": "Refund Time",
  "退款金额": "Refund Amount",
  "操作类型": "Operation Type",
  "客户类型": "Customer Type",
  "合同渠道贷款状态": "Contract Channel Loan Status",
  "根据枚举值，返回对应的": "Based on enum value, return corresponding",
  "校验必填必": "Validate required",
  "导出为": "Export as",
  "自定义删除": "Custom Delete",
  "图片宽度": "Image Width",
  "父级距离顶部的高度": "Parent distance from top height",
  "内部距离顶部的高度": "Internal distance from top height",
  "图片原始宽度高度": "Original image width height",
  "改变图片的": "Change image's",
  "加载完成执行": "Execute after loading completes",
  "打印": "Print",
  "图片的宽度": "Image width",
  "的宽度与高度": "width and height",
  "时的图片宽度数据": "image width data at that time",
  "监听图片的滚动条滚动，并计算距离顶部的调试": "Listen to image scrollbar scroll, and calculate distance from top for debugging",
  "父级高度：": "Parent Height: ",
  "找到元素的屏幕位置": "Find element's screen position",
  "缩放改变时": "When zoom changes",
  "还原": "Restore",
  "放大": "Zoom In",
  "缩小": "Zoom Out",
  "鼠标滑轮滚动": "Mouse Wheel Scroll",
  "滑轮向上滚动": "Wheel Scroll Up",
  "滑轮向下滚动": "Wheel Scroll Down",
  "当前点击位置": "Current Click Position",
  "获取原样的比例": "Get original scale",
  "添加位置": "Add Position",
  "通过现在的比例获取原始的": "Get original from current scale",
  "轴加上滚动条距离顶部的高度": "axis plus scrollbar distance from top height",
  "换算原比例图片": "Convert to original scale image",
  "组件基础用法": "Component Basic Usage",
  "可添加左右文字": "Can add left/right text",
  "自定义样式": "Custom Style",
  "设置数据格式": "Set Data Format",
  "转换单位简化数据": "Convert units, simplify data",
  "自定义单位": "Custom Unit",
  "原始数据：": "Original Data: ",
  "可异步更新数据": "Can update data asynchronously",
  "综合实例": "Comprehensive Example",
  "原始数据": "Original Data",
  "千多": "Thousands",
  "万多": "Tens of Thousands",
  "十万多": "Hundreds of Thousands",
  "十多": "Tens",
  "百多": "Hundreds",
  "百万多": "Millions",
  "千万多": "Ten Millions",
  "亿多": "Hundred Millions",
  "包装表格和页码": "Wrapped Table and Pagination",
  "客户池分页信息": "Customer Pool Pagination Info",
  "表单加载。。。": "Form Loading...",
  "处理数据": "Process Data",
  "页码改变的回调，返回改变后的页码": "Callback when page number changes, returns new page number",
  "设置加载": "Set Loading",
  "确认提交": "Confirm Submit",
  "树状表格组件": "Tree Table Component",
  "，基于": ", based on",
  "进行开发，修复了一些": ", fixed some",
  "，添加了一些新属性": ", added some new properties",
  "支持使用": "Supports using",
  "进行自定义列渲染内容": "for custom column rendering content",
  "文档请看": "See Documentation",
  "高级查询面板": "Advanced Query Panel",
  "）实现": ") implementation",
  "是否显示面板展开按钮": "Whether to show panel expand button",
  "默认不显示（": "Not shown by default (",
  "面板标题": "Panel Title",
  "（默认显示": "(Default shows",
  "“高级查询”）": "'Advanced Query')",
  "查询条件内容": "Query Condition Content",
  "通过“分发": "Via 'Dispatch",
  "”实现": "' implementation",
  "参考模版": "Reference Template",
  "注：": "Note: ",
  "上需要添加": "needs to be added",
  "样式，": "style,",
  "确定事件": "Confirm Event",
  "面板隐藏": "Panel Hide",
  "取消事件": "Cancel Event",
  "展开面板（父级组件调用（": "Expand Panel (Parent component calls (",
  "面板显示切换（需要开启": "Panel Toggle (Requires enabling",
  "，组件内部调用）": ", called internally by component)",
  "暂时数据": "Temporary Data",
  "内置图标": "Built-in Icons",
  "组件支持自定义图标的显示，具体自定义图标字体文件的制作请参考文档。": "Component supports custom icon display. For custom icon font file creation, please refer to the documentation.",
  "组件同时支持": "Component also supports",
  "内置图标类型和自定义图标类型，为了区别这两种类型，需要在自定义图标名称前加下划线": "built-in and custom icon types. To distinguish, prefix custom icon names with underscore.",
  "添加跟进记录": "Add Follow-up Record",
  "客户资料": "Customer Profile",
  "请输入客户姓名": "Please enter customer name",
  "新增必填）": "Required for new)",
  "需求金额": "Required Amount",
  "男": "Male",
  "女": "Female",
  "客户星级": "Customer Star Rating",
  "意向标签": "Intention Tags",
  "客户情况": "Customer Situation",
  "请输入客户情况": "Please enter customer situation",
  "跟进记录": "Follow-up Record",
  "跟进类型": "Follow-up Type",
  "下次跟进记录": "Next Follow-up Record",
  "请选择下次跟进记录": "Please select next follow-up record",
  "预约上门时间": "Schedule On-site Visit Time",
  "请选择预约上门时间": "Please select on-site visit time",
  "回收该客户": "Recycle this customer",
  "请填写备注信息必须大于": "Please fill in notes must be greater than",
  "获取客户资质标签失败": "Failed to get customer qualification tags",
  "请选择下次跟进时间": "Please select next follow-up time",
  "当前所选时间": "Currently Selected Time",
  "当前时间": "Current Time",
  "下次跟进时间为": "Next follow-up time is",
  "天以内": "days within",
  "客户信息": "Customer Information",
  "贷款金额": "Loan Amount",
  "请输入客户情况至少": "Please enter customer situation at least",
  "跟进人": "Follower",
  "跟进日期": "Follow-up Date",
  "是否回收用户": "Whether to recycle user",
  "请填写跟进内容": "Please fill in follow-up content",
  "跟进内容至少": "Follow-up content at least",
  "请选择跟进类型": "Please select follow-up type",
  "客户名称不能为空": "Customer name cannot be empty",
  "请输入跟进内容": "Please enter follow-up content",
  "跟进内容不少于": "Follow-up content not less than",
  "请选择预约时间": "Please select appointment time",
  "面谈记录": "Interview Record",
  "显示跟进记录": "Show Follow-up Record",
  "切记设置": "Remember to set",
  "属性时，一定要添加": "property, must add",
  "修饰符": "modifier",
  "待办事项": "To Do",
  "完成事项": "Completed Items",
  "操作记录": "Operation Records",
  "修改编辑器内容": "Modify Editor Content",
  "显示可拖动弹窗": "Show Draggable Popup",
  "这个按钮也是可以拖动的": "This button is also draggable",
  "标题": "Title",
  "拖动这里即可拖动整个弹窗": "Drag here to drag the entire popup",
  "复制成功": "Copy Successful",
  "复制失败": "Copy Failed",
  "这是输入的内容": "This is the input content",
  "会自动将你程序中的错误收集起来，你可以将错误日志发给后端保存起来。如果你不需要这个功能，将": "will automatically collect errors in your program. You can send error logs to backend for saving. If not needed, remove",
  "里的": "'s",
  "属性删掉即可。": "property.",
  "另外在开发环境下，你程序中的错误都会被收集起来，这样可能不利于你排查错误，你可以将": "Also in dev environment, all errors are collected, which may hinder troubleshooting. You can set",
  "如果你只是想收集错误日志，不希望登录用户看到错误日志，你可以不提供查看日志的入口，只需将": "If only collecting error logs and don't want logged-in users to see them, omit log viewing entry. Just set",
  "点击测试触发程序错误": "Click Test to Trigger Program Error",
  "点击测试触发": "Click Test to Trigger",
  "接口请求错误": "API Request Error",
  "接口请求是请求": "API request is to request",
  "的一个不存在接口，所以服务端会报": "a non-existent interface, so server will report",
  "错误，错误收集机制会收集这个错误，测试的时候有一定网络延迟，所以点击按钮之后稍等一会才会收集到错误。": "error. Error collection mechanism will collect it. Due to network latency during testing, wait a moment after clicking to collect error.",
  "获取下载记录": "Get Download Records",
  "默认开发者帐号": "Default Developer Account",
  "沛城": "Peicheng",
  "当前语言": "Current Language",
  "打印切换的语言值": "Print switched language value",
  "企业员工提交": "Enterprise Employee Submission",
  "登录成功": "Login Successful",
  "隐私政策": "Privacy Policy",
  "生效日期：": "Effective Date: ",
  "更新日期：": "Updated Date: ",
  "提示条款": "Notice Clause",
  "您的信任对我们非常重要，我们深知用户信息安全的重要性，我们将按照法律法规要求，采取安全保护措施，保护您的用户信息安全可控。鉴此，（或简称“我们”）制定本《隐私政策》（以下或简称“本政策”）并提醒您：在使用网站的各项服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后方使用相关产品和服务。一旦您开始使用服务，将被视为对本政策内容的接受和认可。": "Your trust is very important to us. We understand the importance of user information security and will take security measures in accordance with laws and regulations to protect your user information security and controllability. Therefore, (or 'we') formulated this 'Privacy Policy' (hereinafter or referred to as 'this Policy') and remind you: Before using the services of the website, please read this Policy carefully and thoroughly understand it. Only after confirming full understanding and agreement, use related products and services. Once you start using the service, it will be deemed as acceptance and recognition of the content of this Policy.",
  "如对本政策内容有任何疑问、意见或建议，您可通过的客服电话（": "If you have any questions, opinions or suggestions about the content of this Policy, you can contact our customer service hotline (",
  "）与我们联系。": ") to contact us.",
  "定义": "Definition",
  "网站：指控制台（域名为：": "Website: Refers to the console (domain: ",
  "）以及物联客户端（如": ") and IoT client (e.g. ",
  "）。": ").",
  "：除非另有约定，指三棵（深圳）物联科技有限公司。": ": Unless otherwise agreed, refers to Sanko (Shenzhen) IoT Technology Co., Ltd.",
  "用户信息：用户信息是指您注册网站账户，使用的服务以及为了向您提供服务，您提交的或者收集的用户会员类信息，如姓名、联系方式等，具体详见隐私权政策第三条所述的信息。": "User Information: User information refers to the information you submit or collect for providing services when registering website accounts, using services, such as name, contact information, etc. For details, see the information described in Article 3 of the Privacy Policy.",
  "业务数据：不同于用户信息，是指的用户利用的服务上传、下载、分发等通过的技术服务处理的数据。": "Business Data: Different from user information, refers to data processed by technical services used by users, such as upload, download, distribution, etc.",
  "范围": "Scope",
  '协议列表名称(中文)': 'Protocol list name (Chinese)',
  '协议列表名称筛选': 'Protocol list name filter',
  '通道0': 'Channel 0',
  '通道1': 'Channel 1',
  '未分配': 'Unassigned',
  '已分配': 'Assigned',
  '产品类型不能为空': 'Product type cannot be empty',
  '硬件版本号不能为空': 'Hardware version number cannot be empty',
  '备注不能为空': 'Remarks cannot be empty',
  '产品名称必须': 'The product name must be',
  '产品项目号必须': 'Product project number is required',
  '硬件版本号必须': 'Hardware version number is required',
  '协议配置必须': 'Protocol configuration is required',
  '协议列表名称必须': 'The name of the protocol list must be',
  '说明': 'Explanation: Please update the custom protocol list in a timely manner to facilitate information synchronization',
  '请选择协议列表名称': 'Please select protocol list name',
  '协议列表名称': 'Protocol list name',
  '新建产品（产品模型）': 'New Product (Product Model)',
  '协议配置': 'Protocol configuration',
  '产品名称': 'Product name',
  '产品项目号': 'Product project number',
  '请输入产品项目号': 'Please enter product project number',
  "高压户储": "High Voltage Residential Storage",
  "低压户储": "Low Voltage Residential Storage",
  '逆变器': 'Inverter',
  '请选择产品名称': 'Please select product name',
  '请选择协议配置': 'Please select protocol configuration',
  '默认': 'default',
  '自定义': 'customize',
  '全部': 'All',
  '新增硬件版本': 'Add hardware version',
  '请选择产品类型': 'Please select product type',
  '产品类型': 'Product type',
  '请输入硬件版本号': 'Please enter hardware version number',
  '硬件版本号筛选': 'Hardware version filter',
  '请选择产品型号': 'Please select product model',
  '产品型号': 'Product model',
  '导出产测成功设备': "Export successfully tested device",
  '暂无数据': 'No data',
  detailsNew: 'deviceList',
  '请选择代理商': 'Please select agent',
  '请输入设备ID/设备名称/IMEI': 'Please enter device ID/device name/IMEI',
  trajectory: "Trajectory list",
  '批量分配': 'Batch allocation',
  '搜索': 'search for',
  '导出产测成功设备id': 'Export successfully tested device IDs',
  '生产管理': 'Production management',
  '出库管理': 'Outbound management',
  '资料下载': 'Data Download',
  downloadlist: "Export download",
  '告警内容': 'Alarm content',
  '告警时间': 'Alarm time',
  dailishangzongshu: 'Total number of agents',
  jihuoqushi: "Activate trend",
  area: 'Area',
  zaixianshebeishu: 'Number of online devices',
  shebeizongshu: 'Total number of devices',
  jingxiaoshang: 'Agent management',
  userman: 'User management',
  dictman: 'Inverter dictionary management',
  thingsuser: 'List of Internet of Things users',
  devicedistribution: 'Device list',
  distributionLog: 'Historical record',
  details: 'Details',
  control: "Control",
  homeTitle: 'PACEEX energy console',
  bigData: 'Large screen data',
  controlConsole: "Control console",
  backman: 'Background management',
  logout: 'Logout',
  add: 'Add',
  import: 'Import',
  export: 'Export',
  refresh: "Refresh",
  query: 'Query',
  reset: 'Reset',
  operation: 'Operation',
  edit: 'Edit',
  delete: 'Delete',
  nodata: 'No data',
  isdelete: 'You are sure you want to delete',
  ma: 'this data',
  serialnumber: 'Serial number',
  ok: 'OK',
  cancel: 'Cancel',
  protocolman: 'Protocol manage',
  protocollist: 'Protocol manage',
  protocollist2: 'View',
  product: "Product",
  projectprotocollist: 'Custom Protocol',
  hardwareman: "Hardware version management",
  hardwarelist: 'Hardware version management',
  firmwareman: 'Firmware Management',
  firmwarelist: 'Firmware version',
  uplist: 'Upgrade Rules',
  areamenu: {
    regional_classification: 'Regional classification',
    serialnumber: 'Serial number',
    regionname: 'Region name',
    addsubordinatearea: 'Add subordinate area',
    addarea: 'Add area',
    editarea: 'Edit area',
    superiorregion: 'Superior region',
    seletesuperiorregion: "Select an upper-level region",
    enterregionname: 'Please enter a region name',
    instructions: 'Instructions',
    enterdescription: 'Please enter a description',
  },
  agentmenu: {
    area: 'Area',
    selectarea: 'Please select a region',
    agentlist: "Agent list",
    serialnumber: 'Serial number',
    agentname: "Agent name",
    addsubagent: "Add sub-agent",
    forbidden: 'Forbidden',
    enable: 'Enable',
    transfer: 'Transfer',
    authority: 'Limits of authority',
    addagent: 'Add agent',
    agentnameplaceholer: 'Please enter the agent name',
    contactperson: 'Contact person',
    contactpersonplaceholer: 'Please enter contact person',
    address: 'Address',
    addressplaceholer: 'Please enter the address',
    maplnglat: "Map coordinates(Please click on the map to obtain the address)",
    enterlng: "Please enter the longitude",
    enterlat: "Please enter latitude",
    entersearchname: 'Please enter a search name',
    aftercontact: 'After-sales contact',
    aftercontactplaceholer: 'Please enter after-sales contact',
    loginaccount: 'Login account (mobile number or email)',
    loginaccountplaceholer: 'Please enter the login account (mobile number or email)',
    loginpassword: 'Login password',
    loginpasswordplaceholer: 'Please enter your login password',
    paramsconfigpass: 'Parameter setting Password',
    paramsconfigpassplaceholer: 'Please enter the parameters to set the password',
    remark: 'Remark',
    remarkplaceholer: 'Please enter remarks',
    namecannotbenull: 'The name cannot be empty',
    contactcannotbenull: 'The contact cannot be empty',
    areacannotbenull: 'The region cannot be empty',
    addresscannotbenull: 'The address cannot be empty',
    aftercannotbenull: 'The after-sales contact cannot be empty',
    mobileoremailcannotbenull: 'The mobile phone number or email address cannot be empty',
    loginpasswordcannotbenull: 'The login password cannot be empty',
    mapcannotbenull: 'Map coordinates cannot be empty',
  },
  alarmmenu: {
    createtime:'Createtime',
    'filename': 'Filename',
    alarmmanage: 'Alarm manage',
    agent: 'Agent',
    agentplaceholer: 'Please select an agent',
    selectstatus: 'Please select status',
    nothandle: 'untreated',
    okhandle: 'processed',
    batchprocessing: 'Batch processing',
    did: 'Did',
    affiliatedagent: 'Affiliated agent',
    datatype: 'Data type',
    address: 'Address',
    alarmcause: 'Alarm cause',
    alarmtime: 'Alarm time',
    status: 'Status',
    handleuser: 'Processor',
    handletime: 'Processing time',
    handle: 'Handle',
    nothandle: 'untreated',
    okhandle: 'processed',
    alarmhandle: 'Alarm handling',
    handleuserplaceholder: 'Please enter a handler',
    handletimeplaceholder: 'Please select a processing time',
    handleusernotbenull: 'The handler name cannot be empty',
    handletimenotbenull: 'The processing time cannot be empty',
  },
  devicelist: {
    devicestatus: 'Device status',
    deviceallocationstatus: 'Eevice allocation status',
    did: 'Did',
    deviceidfiltering: 'Ddevice id filtering',
    agent: 'Agent',
    selectagent: 'Please select an agent',
    deviceallocationstatus: 'Device allocation status',
    did: 'Did',
    recordtime: 'Record time',
    electriccurrent: 'Electric current',
    totalvoltage: 'Total voltage',
    remainingcapacity: 'Remaining capacity',
    fullchargecapacity: 'Full charge capacity',
    datechoose: "Select date",
    date: 'Date',
    version: 'Version',
    status: 'Status',
    hardwareversionnumber: 'Hardware version number',
    softwareversionnumber: 'Software version number',
    ccstatus: 'Production testing status',
    cctime: 'Production testing time',
    lastonlinetime: 'Last online time',
    activationtime: 'Activation time',
    exporthistory: 'Export history',
    control: 'Control',
    see: 'View',
    viewtrajectory: 'View trajectory',
    distribution: 'Distribution',
    canceldistribution: 'Cancel allocation',
    alarmlog: "Alarm log",
    historylog: "Historical records",
    projectnum: 'PROJECT NO',
    hardwareversion: 'hardware version',
    softwareversion: 'Software version',
    modelcode: 'Model code',
    online: 'Online',
    offline: 'Offline',
    notknow: 'Unknown',
    passman: 'password management',
    daochuhis: 'Export History',
    timechoose: 'Time filtering',
    qishijieshu: 'Start time, end time',
    qishijieshunotnull: 'Time filtering cannot be empty',
    mostfenpei: 'Batch allocation of agents',
    fenpei: 'Assign agents',
    didfile: 'Device ID file',
    uploadxlsx: 'Please upload the xlsx file',
    downexample: 'Download sample file',
    newpass: 'Password',
    inputnewpass: 'Please enter a new password',
    newpassnotnull: 'New password required',
    cancelfenpei: 'Unassign',
    quedingcancel: 'Are you sure you want to cancel the allocation',
    dailinotnull: 'Agent must be selected',
  },
  dictmenu: {
    protocoltype: 'Protocol type',
    protocolnumber: "Protocol number",
    protocolname: "Protocol name(Chinese)",
    protocolnameen: "Protocol name(English)",
    invertertype: 'Inverter type',
    creationtime: 'Creation time',
    viewdetails: 'View details',
    protocoltypeholder: 'Please choose protocol type',
    protocolnumberholder: 'Please enter protocol number',
    protocolnameholder: 'Please enter protocol name(Chinese)',
    protocolnameholderEN: 'Please enter protocol name(English)',
    invertertypeholder: 'Please choose inverter type',
    protocolnamefilter: 'Protocol name filter',
    addinverterdict: 'Add inverter dict',
    protocoltypenotnull: 'Protocol type can not be null',
    protocolnumbernotnull: 'Protocol number can not be null',
    protocolnamenotnull: 'Protocol name can not null',
    invertertypenotnull: 'Inverter type can not be null',
    uploadxls: 'Please choose to upload xlsx file',
    downloadexample: 'Download sample file',
    upload: 'Upload',
    uploadPlaceHolder: 'XLSX file cannot be empty',
    uploadPlaceHolderType: 'The file type is incorrect',
    sureexport: 'Are you sure you want to export the current data?',
    suredelete: 'Are you sure you want to delete',
    ma: '？',
  },
  loginArea: {
    title: 'Login',
    userNameplaceholder: 'Input user name',
    userNameNotNull: 'Username can not be empty',
    passwordplaceholder: 'Input password',
    passwordNotNull: 'password can not be blank',
    forgetPassword: 'forget password',
    haveAccount: 'Already have an account',
    OK: 'OK',
    emailbackPass: 'Email to retrieve password',
    repasswordplaceholder: 'Inputrepeat password',
    repasswordNotNull: 'Repeat password can not be blank',
    emailplaceholder: 'Please enter your email address',
    emailNotNull: 'Email cannot be empty',
    codeplaceholder: 'Please enter the mobile verification code',
    getvcode: 'Obtain email verification code',
    inputAgainPass: "Duplicate new password cannot be empty",
    emailIncorrect: 'Email format error',
    getVodeSecondAfter: 'Seconds retrieve ',
    requireFieldsNotice: 'Please fill in the required fields'
  },
  productModule: {
    projectcode: 'PROJECT NO',
    projectcodeholder: 'Please select project number',
    upload: 'Upload',
    uploadcsv: 'Please upload CSV file',
    downloadexample: 'Download sample file',
    daoruyulan: 'Import result preview',
    guanliansn: 'Associated SN',
    totalnum: 'Total number',
    uploadtime: 'Upload Time',
    exportsn: 'Export SN (CSV)',
    exportholder: 'Are you sure you want to export the current data',
    exportasr: 'ASR Download (JSON)',
  },
  Changelang: {
        '实时数据': 'Real-time Data',
  'PV数据': 'PV Data',
    '实时监测':'Real-time Monitoring',
    '加热膜故障':'Heating film malfunction',
    '慢充电继电器粘连':'Slow charging relay adhesion',
    '慢充电继电器失效':'Slow charging relay failure',
    '快充电继电器失效':'Fast charging relay failure',
    '快充电继电器粘连':'Fast charging relay adhesion',
    '正级端子高温':'Positive terminal high temperature',
    '负级端子高温':'Negative terminal high temperature',
    '快充电口高温':'Fast charging port high temperature',
    '慢充电口高温':'Slow charging port high temperature',
    '快充电继电器':'Fast charging relay',
    '慢充电继电器':'Slow charging relay',
    '严重低压状态':'Severe low voltage state',
    '已占用':'Already occupied',
    '快充信号':'Fast charging signal',
    '放电信号':'Discharge signal',
    '慢充信号':'Slow charging signal',
    '正级端子高温':'Positive terminal high temperature',
    '在线PACK个数':'Number of online PACKs',
    '端子温度1':'Terminal temperature 1',
    '端子温度2':'.Terminal temperature 2',
    '端子温度3':'Terminal temperature 3',
    '端子温度4':'Terminal temperature 4',
    '端子温度5':'Terminal temperature 5',
    '开启':'Turn on',
    '关闭':'Turn off',
    '一级保护状态':"First level protection status",
    '二级保护状态':"Secondary protection status",
    '三级保护状态':"Level 3 protection status",
    '开关真实状态':"Real state of switch",
    '正常':"normal",
    '保护':'protect',
    '系统信息':'system information',
    '故障':'fault',
    '告警':'alarm',
    '电压':'voltage',
    '容量':'capacity',
    '温度':'temperature',
    '状态':'state',
    '汇总数据': 'Summary Data',
    'PACK详情数据': 'PACK Details Data',
    '设备信息': 'Device info',
    '堆数据': 'Stack data',
    '刷新频率更改': '刷新频率更改',
    '刷新频率更改2': 'Long term inactivity, refresh rate changed to 60 minutes',
    '簇数据': 'Cluster data',
    '单体数据': 'Individual data',
    '固件升级': 'Firmware Upgrade',
    '产品品类': 'Product Category',
    '当前选择的CAN逆变器ID': 'The currently selected CAN inverter ID',
    '家储': 'Home savings',
    '基站': 'base station',
    '高压BCU': 'High voltage BCU',
    '高压BAU': 'High voltage BAU',
    '无从机系统': 'No machine system',
    '有从机系统，且本机为主机': 'There is a slave system, and the local machine is the master',
    '有从机系统，且本机为从机': 'There is a slave system, and the local machine is a slave',
    '项目号': 'PROJECT NO',
    '用作设备管理显示': 'Used for device management display',
    '协议版本号': 'Protocol version number',
    '外部软件版本号': 'External software version number',
    '内部软件版本号': 'Internal software version number',
    '软件开发版本号': 'Software development version number',
    '系统SN': 'System SN',
    '配网显示名称(配网SN)': 'Distribution Network Display Name (Distribution Network SN)',
    '当前选择的串口逆变器ID': 'The currently selected serial inverter ID',
    '当前选择的网络逆变器ID': 'The currently selected network inverter ID',

    '参数设置': 'Parameter settings',
    '历史记录': 'historical records',
    '告警数据': 'Alarm data',
    '密码管理': 'Password manager',
    '历史轨迹': 'Historical Trajectory',
    'BMS SN': 'BMS SN',
    'PACK SN': 'PACK SN',
    '无': 'No Data',
    '单体高压1_保护值': 'Single high voltage protection value',
    '单体高压1_保护延时': 'Single high voltage protection delay',
    '单体高压1_保护恢复值': 'Single high voltage 1_protection recovery value',
    '单体高压1_保护恢复延时': 'Single high voltage 1_protection recovery delay',
    '单体高压2_保护值': 'Single high voltage protection value',
    '单体高压2_保护延时': 'Single high voltage protection delay',
    '单体高压2_保护恢复值': 'Single high voltage protection recovery value',
    '单体高压2_保护恢复延时': 'Single high voltage protection recovery delay',
    '单体高压3_保护值': 'Single high voltage 3_ protection value',
    '单体高压3_保护延时': 'Single high voltage 3_ protection delay',
    '单体高压3_保护恢复值': 'Single high voltage 3_ protection recovery value',
    '单体高压3_保护恢复延时': 'Single high voltage 3_ protection recovery delay',
    '单体低压1_保护值': 'Single low voltage protection value',
    '单体低压1_保护延时': 'Single low voltage 1_protection delay',
    '单体低压1_保护恢复值': 'Single low voltage 1_protection recovery value',
    '单体低压1_保护恢复延时': 'Single low voltage 1_protection recovery delay',
    '单体低压2_保护值': 'Single low voltage protection value',
    '单体低压2_保护延时': 'Single low-voltage protection delay',
    '单体低压2_保护恢复值': 'Single low-voltage protection recovery value',
    '单体低压2_保护恢复延时': 'Single low voltage protection recovery delay',
    '单体低压3_保护值': 'Single low voltage 3_ protection value',
    '单体低压3_保护延时': 'Single low voltage 3_ protection delay',
    '单体低压3_保护恢复值': 'Single low voltage 3_ protection recovery value',
    '单体低压3_保护恢复延时': 'Single low voltage 3_ protection recovery delay',
    '电池簇总体高压1_保护值': 'Overall high-voltage protection value of battery cluster',
    '电池簇总体高压1_保护延时': 'Overall high voltage protection delay of battery cluster',
    '电池簇总体高压1_保护恢复值': 'Overall high voltage protection recovery value of battery cluster',
    '电池簇总体高压1_保护恢复延时': 'Overall high voltage protection and recovery delay of battery cluster',
    '电池簇总体高压2_保护值': 'Overall high-voltage protection value of battery cluster',
    '电池簇总体高压2_保护延时': 'Overall high voltage protection delay of battery cluster',
    '电池簇总体高压2_保护恢复值': 'Overall high voltage protection recovery value of battery cluster',
    '电池簇总体高压2_保护恢复延时': 'Overall high voltage of battery cluster, protection and recovery delay',
    '电池簇总体高压3_保护值': 'Overall high voltage protection value of battery cluster 3_',
    '电池簇总体高压3_保护延时': 'Battery cluster overall high voltage 3_ protection delay',
    '电池簇总体高压3_保护恢复值': 'Overall high voltage 3_ protection recovery value of battery cluster',
    '电池簇总体高压3_保护恢复延时': 'Battery cluster overall high voltage 3_ protection recovery delay',
    '电池簇总体低压1_保护值': 'Overall low voltage protection value of battery cluster',
    '电池簇总体低压1_保护延时': 'Overall low voltage protection delay of battery cluster',
    '电池簇总体低压1_保护恢复值': 'Overall low voltage protection recovery value of battery cluster',
    '电池簇总体低压1_保护恢复延时': 'Battery cluster overall low voltage 1_protection recovery delay',
    '电池簇总体低压2_保护值': 'Overall low voltage protection value of battery cluster',
    '电池簇总体低压2_保护延时': 'Overall low voltage protection delay of battery cluster',
    '电池簇总体低压2_保护恢复值': 'Overall low voltage protection recovery value of battery cluster',
    '电池簇总体低压2_保护恢复延时': 'Overall low voltage protection and recovery delay of battery cluster',
    '电池簇总体低压3_保护值': 'Overall low voltage protection value of battery cluster 3_',
    '电池簇总体低压3_保护延时': 'Battery cluster overall low voltage 3_ protection delay',
    '电池簇总体低压3_保护恢复值': 'Overall low voltage 3_ protection recovery value of battery cluster',
    '电池簇总体低压3_保护恢复延时': 'Battery cluster overall low voltage 3_ protection recovery delay',
    '充电过流1_保护值': 'Charging overcurrent protection value',
    '充电过流1_保护延时': 'Charging overcurrent protection delay',
    '充电过流1_保护恢复值': 'Charging overcurrent protection recovery value',
    '充电过流1_保护恢复延时': 'Charging overcurrent 1_protection recovery delay',
    '充电过流2_保护值': 'Charging overcurrent protection value',
    '充电过流2_保护延时': 'Charging overcurrent protection delay',
    '充电过流3_保护值': 'Charging overcurrent 3_ protection value',
    '充电过流3_保护延时': 'Charging overcurrent 3_ protection delay',
    '放电过流1_保护值': 'Discharge overcurrent protection value',
    '放电过流1_保护延时': 'Discharge overcurrent protection delay',
    '放电过流1_保护恢复值': 'Discharge overcurrent 1_protection recovery value',
    '放电过流1_保护恢复延时': 'Discharge overcurrent 1_protection recovery delay',
    '放电过流2_保护值': 'Discharge overcurrent protection value',
    '放电过流2_保护延时': 'Discharge overcurrent protection delay',
    '放电过流3_保护值': 'Discharge overcurrent 3_ protection value',
    '放电过流3_保护延时': 'Discharge overcurrent 3_ protection delay',
    '充电高温1_保护值': 'Charging high temperature protection value',
    '充电高温1_保护延时': 'Charging high temperature 1_protection delay',
    '充电高温1_保护恢复值': 'Charging high temperature 1_protection recovery value',
    '充电高温1_保护恢复延时': 'Charging high temperature 1_protection recovery delay',
    '充电高温2_保护值': 'Charging high temperature protection value',
    '充电高温2_保护延时': 'Charging High Temperature 2-Protection Delay',
    '充电高温2_保护恢复值': 'Charging High Temperature 2-Protection Recovery Value',
    '充电高温2_保护恢复延时': 'Charging high temperature 2-protection recovery delay',
    '充电高温3_保护值': 'Charging high temperature 3_ protection value',
    '充电高温3_保护延时': 'Charging high temperature 3_ protection delay',
    '充电高温3_保护恢复值': 'Charging high temperature 3_ protection recovery value',
    '充电高温3_保护恢复延时': 'Charging high temperature 3_ protection recovery delay',
    '充电低温1_保护值': 'Low temperature charging protection value',
    '充电低温1_保护延时': 'Charging low temperature 1_protection delay',
    '充电低温1_保护恢复值': 'Charging low temperature 1_protection recovery value',
    '充电低温1_保护恢复延时': 'Charging low temperature 1_protection recovery delay',
    '充电低温2_保护值': 'Low temperature charging protection value',
    '充电低温2_保护延时': 'Charging low temperature 2-protection delay',
    '充电低温2_保护恢复值': 'Charging low-temperature protection recovery value',
    '充电低温2_保护恢复延时': 'Charging at low temperature with protection and recovery delay',
    '充电低温3_保护值': 'Charging low temperature 3_ protection value',
    '充电低温3_保护延时': 'Charging low temperature 3_ protection delay',
    '充电低温3_保护恢复值': 'Charging low temperature 3_ protection recovery value',
    '充电低温3_保护恢复延时': 'Charging low temperature 3_ protection recovery delay',
    '放电高温1_保护值': 'High temperature discharge protection value',
    '放电高温1_保护延时': 'Discharge high temperature 1_protection delay',
    '放电高温1_保护恢复值': 'Discharge high temperature 1_protection recovery value',
    '放电高温1_保护恢复延时': 'Discharge high temperature 1_protection recovery delay',
    '放电高温2_保护值': 'High temperature discharge protection value',
    '放电高温2_保护延时': 'Discharge high temperature 2-protection delay',
    '放电高温2_保护恢复值': 'High temperature discharge protection recovery value',
    '放电高温2_保护恢复延时': 'Discharge high temperature 2-protection recovery delay',
    '放电高温3_保护值': 'Discharge high temperature 3_ protection value',
    '放电高温3_保护延时': 'Discharge high temperature 3_ protection delay',
    '放电高温3_保护恢复值': 'Discharge high temperature 3_ protection recovery value',
    '放电高温3_保护恢复延时': 'Discharge high temperature 3_ protection recovery delay',
    '放电低温1_保护值': 'Low temperature discharge protection value',
    '放电低温1_保护延时': 'Low temperature discharge protection delay',
    '放电低温1_保护恢复值': 'Low temperature discharge protection recovery value',
    '放电低温1_保护恢复延时': 'Discharge low temperature 1_protection recovery delay',
    '放电低温2_保护值': 'Low temperature discharge protection value',
    '放电低温2_保护延时': 'Low temperature discharge 2-protection delay',
    '放电低温2_保护恢复值': 'Low temperature discharge protection recovery value',
    '放电低温2_保护恢复延时': 'Low temperature discharge 2-protection recovery delay',
    '放电低温3_保护值': 'Discharge low temperature 3_ protection value',
    '放电低温3_保护延时': 'Discharge low temperature 3_ protection delay',
    '放电低温3_保护恢复值': 'Low temperature discharge 3_ protection recovery value',
    '放电低温3_保护恢复延时': 'Discharge low temperature 3_ protection recovery delay',
    '充电温差1_保护值': 'Charging temperature difference 1_protection value',
    '充电温差1_保护延时': 'Charging temperature difference 1_protection delay',
    '充电温差1_保护恢复值': 'Charging temperature difference 1_protection recovery value',
    '充电温差1_保护恢复延时': 'Charging temperature difference 1_protection recovery delay',
    '充电温差2_保护值': 'Charging temperature difference 2-protection value',
    '充电温差2_保护延时': 'Charging temperature difference 2-protection delay',
    '充电温差2_保护恢复值': 'Charging temperature difference 2-protection recovery value',
    '充电温差2_保护恢复延时': 'Charging temperature difference 2-protection recovery delay',
    '充电温差3_保护值': 'Charging temperature difference 3_ protection value',
    '充电温差3_保护延时': 'Charging temperature difference 3_ protection delay',
    '充电温差3_保护恢复值': 'Charging temperature difference 3_ protection recovery value',
    '充电温差3_保护恢复延时': 'Charging temperature difference 3_ protection recovery delay',
    '放电温差1_保护值': 'Discharge temperature difference 1_protection value',
    '放电温差1_保护延时': 'Discharge temperature difference 1_protection delay',
    '放电温差1_保护恢复值': 'Discharge temperature difference 1_protection recovery value',
    '放电温差1_保护恢复延时': 'Discharge temperature difference 1_protection recovery delay',
    '放电温差2_保护值': 'Discharge temperature difference 2-protection value',
    '放电温差2_保护延时': 'Discharge temperature difference 2-protection delay',
    '放电温差2_保护恢复值': 'Discharge temperature difference 2-protection recovery value',
    '放电温差2_保护恢复延时': 'Discharge temperature difference 2-protection recovery delay',
    '放电温差3_保护值': 'Discharge temperature difference 3_ protection value',
    '放电温差3_保护延时': 'Discharge temperature difference 3_ protection delay',
    '放电温差3_保护恢复值': 'Discharge temperature difference 3_ protection recovery value',
    '放电温差3_保护恢复延时': 'Discharge temperature difference 3_ protection recovery delay',
    '电芯温升1_保护值': 'Cell temperature rise 1_protection value',
    '电芯温升1_保护延时': 'Cell temperature rise 1_protection delay',
    '电芯温升1_保护恢复值': 'Cell temperature rise 1_protection recovery value',
    '电芯温升1_保护恢复延时': 'Cell temperature rise 1_protection recovery delay',
    '电芯温升2_保护值': 'Cell temperature rise 2-protection value',
    '电芯温升2_保护延时': 'Cell temperature rise 2-protection delay',
    '电芯温升2_保护恢复值': 'Cell temperature rise 2-protection recovery value',
    '电芯温升2_保护恢复延时': 'Cell temperature rise 2-protection recovery delay',
    '电芯温升3_保护值': 'Cell temperature rise 3_ protection value',
    '电芯温升3_保护延时': 'Cell temperature rise 3_ protection delay',
    '电芯温升3_保护恢复值': 'Cell temperature rise 3_ protection recovery value',
    '电芯温升3_保护恢复延时': 'Cell temperature rise 3_ protection recovery delay',
    'SOC高1_保护值': 'SOC high 1_protection value',
    'SOC高1_保护延时': 'SOC high 1_protection delay',
    'SOC高1_保护恢复值': 'SOC high 1_protection recovery value',
    'SOC高1_保护恢复延时': 'SOC high 1_protection recovery delay',
    'SOC高2_保护值': 'SOC high 2 protection value',
    'SOC高2_保护延时': 'SOC high 2 protection delay',
    'SOC高2_保护恢复值': 'SOC high 2 protection recovery value',
    'SOC高2_保护恢复延时': 'SOC high 2 protection recovery delay',
    'SOC高3_保护值': 'SOC high 3_ protection value',
    'SOC高3_保护延时': 'SOC high 3_ protection delay',
    'SOC高3_保护恢复值': 'SOC high 3_ protection recovery value',
    'SOC高3_保护恢复延时': 'SOC high 3_ protection recovery delay',
    'SOC低1_保护值': 'SOC low 1_protection value',
    'SOC低1_保护延时': 'SOC low 1_protection delay',
    'SOC低1_保护恢复值': 'SOC low 1_protection recovery value',
    'SOC低1_保护恢复延时': 'SOC low 1_protection recovery delay',
    'SOC低2_保护值': 'SOC low 2-protection value',
    'SOC低2_保护延时': 'SOC low 2 protection delay',
    'SOC低2_保护恢复值': 'SOC low 2 protection recovery value',
    'SOC低2_保护恢复延时': 'SOC low 2 protection recovery delay',
    'SOC低3_保护值': 'SOC low 3_ protection value',
    'SOC低3_保护延时': 'SOC low 3_ protection delay',
    'SOC低3_保护恢复值': 'SOC low 3_ protection recovery value',
    'SOC低3_保护恢复延时': 'SOC low 3_ protection recovery delay',
    '正极绝缘漏电1_保护值': 'Positive electrode insulation leakage protection value',
    '正极绝缘漏电1_保护延时': 'Positive electrode insulation leakage 1_protection delay',
    '正极绝缘漏电1_保护恢复值': 'Positive electrode insulation leakage 1_protection recovery value',
    '正极绝缘漏电1_保护恢复延时': 'Positive electrode insulation leakage 1_protection recovery delay',
    '正极绝缘漏电2_保护值': 'Positive electrode insulation leakage protection value',
    '正极绝缘漏电2_保护延时': 'Positive electrode insulation leakage 2-protection delay',
    '正极绝缘漏电2_保护恢复值': 'Positive electrode insulation leakage 2-protection recovery value',
    '正极绝缘漏电2_保护恢复延时': 'Positive electrode insulation leakage 2-protection recovery delay',
    '正极绝缘漏电3_保护值': 'Positive electrode insulation leakage 3_ protection value',
    '正极绝缘漏电3_保护延时': 'Positive electrode insulation leakage 3_ protection delay',
    '正极绝缘漏电3_保护恢复值': 'Positive electrode insulation leakage 3_ protection recovery value',
    '正极绝缘漏电3_保护恢复延时': 'Positive electrode insulation leakage 3_ protection recovery delay',
    '负极绝缘漏电1_保护值': 'Negative insulation leakage protection value',
    '负极绝缘漏电1_保护延时': 'Negative insulation leakage 1_protection delay',
    '负极绝缘漏电1_保护恢复值': 'Negative insulation leakage 1_protection recovery value',
    '负极绝缘漏电1_保护恢复延时': 'Negative insulation leakage 1_protection recovery delay',
    '负极绝缘漏电2_保护值': 'Negative insulation leakage protection value',
    '负极绝缘漏电2_保护延时': 'Negative insulation leakage 2-protection delay',
    '负极绝缘漏电2_保护恢复值': 'Negative insulation leakage 2-protection recovery value',
    '负极绝缘漏电2_保护恢复延时': 'Negative insulation leakage 2-protection recovery delay',
    '负极绝缘漏电3_保护值': 'Negative insulation leakage 3_ protection value',
    '负极绝缘漏电3_保护延时': 'Negative insulation leakage 3_ protection delay',
    '负极绝缘漏电3_保护恢复值': 'Negative insulation leakage 3_ protection recovery value',
    '负极绝缘漏电3_保护恢复延时': 'Negative insulation leakage 3_ Protection recovery delay',
    '环境高温1_保护值': 'Environmental high temperature protection value',
    '环境高温1_保护延时': 'Environmental high temperature protection delay',
    '环境高温1_保护恢复值': 'Environmental high temperature protection recovery value',
    '环境高温1_保护恢复延时': 'Environmental high temperature 1_protection recovery delay',
    '环境高温2_保护值': 'Environmental high temperature protection value',
    '环境高温2_保护延时': 'Environmental high temperature 2-protection delay',
    '环境高温2_保护恢复值': 'Environmental high temperature protection recovery value',
    '环境高温2_保护恢复延时': 'Environmental high temperature 2-protection recovery delay',
    '环境高温3_保护值': 'Environmental high temperature 3_ protection value',
    '环境高温3_保护延时': 'Environmental high temperature 3_ Protection delay',
    '环境高温3_保护恢复值': 'Environmental high temperature 3_ protection recovery value',
    '环境高温3_保护恢复延时': 'Environmental high temperature 3_ Protection and recovery delay',
    '环境低温1_保护值': 'Environmental low temperature protection value',
    '环境低温1_保护延时': 'Environmental low temperature protection delay',
    '环境低温1_保护恢复值': 'Environmental low temperature protection recovery value',
    '环境低温1_保护恢复延时': 'Environmental low temperature 1_protection recovery delay',
    '环境低温2_保护值': 'Environmental low temperature protection value',
    '环境低温2_保护延时': 'Low temperature environment with protection delay',
    '环境低温2_保护恢复值': 'Environmental low temperature protection recovery value',
    '环境低温2_保护恢复延时': 'Low temperature environment with protection and recovery delay',
    '环境低温3_保护值': 'Low temperature environment 3_ protection value',
    '环境低温3_保护延时': 'Low temperature environment 3_ Protection delay',
    '环境低温3_保护恢复值': 'Low temperature environment 3_ protection recovery value',
    '环境低温3_保护恢复延时': 'Low temperature environment 3_ Protection and recovery delay',
    '充电压差1_保护值': 'Charging voltage difference 1_protection value',
    '充电压差1_保护延时': 'Charging voltage difference 1_protection delay',
    '充电压差1_保护恢复值': 'Charging voltage difference 1_protection recovery value',
    '充电压差1_保护恢复延时': 'Charging voltage difference 1_protection recovery delay',
    '充电压差2_保护值': 'Charging voltage difference 2-protection value',
    '充电压差2_保护延时': 'Charging voltage difference 2-protection delay',
    '充电压差2_保护恢复值': 'Charging voltage difference 2-protection recovery value',
    '充电压差2_保护恢复延时': 'Charging voltage difference 2-protection recovery delay',
    '充电压差3_保护值': 'Charging voltage difference 3_ protection value',
    '充电压差3_保护延时': 'Charging voltage difference 3_ protection delay',
    '充电压差3_保护恢复值': 'Charging voltage difference 3_ protection recovery value',
    '充电压差3_保护恢复延时': 'Charging voltage difference 3_ protection recovery delay',
    '放电压差1_保护值': 'Discharge voltage difference 1_protection value',
    '放电压差1_保护延时': 'Discharge voltage difference 1_protection delay',
    '放电压差1_保护恢复值': 'Discharge voltage difference 1_protection recovery value',
    '放电压差1_保护恢复延时': 'Discharge voltage difference 1_protection recovery delay',
    '放电压差2_保护值': 'Discharge voltage difference 2-protection value',
    '放电压差2_保护延时': 'Voltage difference 2-protection delay',
    '放电压差2_保护恢复值': 'Discharge voltage difference 2-protection recovery value',
    '放电压差2_保护恢复延时': 'Voltage difference 2-protection recovery delay',
    '放电压差3_保护值': 'Discharge voltage difference 3_ protection value',
    '放电压差3_保护延时': 'Discharge voltage difference 3_ protection delay',
    '放电压差3_保护恢复值': 'Discharge voltage difference 3_ protection recovery value',
    '放电压差3_保护恢复延时': 'Discharge voltage difference 3_ protection recovery delay',
    '端子高温1_保护值': 'Terminal high temperature protection value',
    '端子高温1_保护延时': 'Terminal high temperature protection delay',
    '端子高温1_保护恢复值': 'Terminal high temperature 1_protection recovery value',
    '端子高温1_保护恢复延时': 'Terminal high temperature 1_protection recovery delay',
    '端子高温2_保护值': 'Terminal high temperature protection value',
    '端子高温2_保护延时': 'Terminal high temperature 2-protection delay',
    '端子高温2_保护恢复值': 'Terminal high temperature protection recovery value',
    '端子高温2_保护恢复延时': 'Terminal high temperature 2-protection recovery delay',
    '端子高温3_保护值': 'Terminal high temperature 3_ protection value',
    '端子高温3_保护延时': 'Terminal high temperature 3_ protection delay',
    '端子高温3_保护恢复值': 'Terminal high temperature 3_ protection recovery value',
    '端子高温3_保护恢复延时': 'Terminal high temperature 3_ protection recovery delay',
    '开启风扇_环境温度': 'Turn on the fan_ ambient temperature',
    '开启风扇_端子温度': 'Turn on fan_terminal temperature',
    '关闭风扇_环境温度': 'Turn off fan _ ambient temperature',
    '关闭风扇_端子温度': 'Turn off fan_terminal temperature',
    '电芯故障_保护值': 'Cell Fault Protection Value',
    '电芯故障_保护延时': 'Cell Fault Protection Delay',
    '电芯故障_保护恢复值': 'Cell failure protection recovery value',
    '电芯故障_保护恢复延时': 'Cell Failure - Protection Recovery Delay',
    '满充截止电压': 'Full charge cut-off voltage',
    '满充截止电流': 'Full charge cut-off current',
    '最高电压': 'Maximum Voltage',
    '最低电压': 'Minimum Voltage',
    '最高温度': 'Maximum Temperature',
    '最低温度': 'Minimum Temperature',
    'SOC低告警值': 'SOC low alarm value',
    '满充SOC释放值': 'Fully charged SOC release value',
    '均衡开启电压': 'Balanced turn-on voltage',
    '均衡开启压差': 'Balanced opening pressure difference',
    '设计容量': 'design capacity',
    '剩余容量': 'remaining capacity',
    '满充容量': 'Full charge capacity',
    '短路保护延时': 'Short circuit protection delay',
    '掉电单体电压': 'Single cell voltage in case of power failure',
    '掉电总体电压': 'Overall voltage during power failure',
    '掉电延时时间': 'Power outage delay time',
    '单体高压告警值': 'Single high voltage alarm value',
    '单体高压保护值': 'Single high voltage protection value',
    '单体高压保护延时': 'Single high voltage protection delay',
    '单体高压恢复值': 'Single high pressure recovery value',
    '单体低压告警值': 'Single low voltage alarm value',
    '单体低压保护值': 'Individual low voltage protection value',
    '单体低压保护延时': 'Single low voltage protection delay',
    '单体低压恢复值': 'Low pressure recovery value of individual unit',
    '总体高压告警': 'Overall high voltage alarm',
    '总体高压保护值': 'Overall high voltage protection value',
    '总体高压保护延时': 'Overall high voltage protection delay',
    '总体高压恢复值': 'Overall high voltage recovery value',
    '总体低压告警': 'Overall low voltage alarm',
    '总体低压保护值': 'Overall low voltage protection value',
    '总体低压保护延时': 'Overall low voltage protection delay',
    '总体低压恢复值': 'Overall low pressure recovery value',
    '充电过流告警值': 'Charging overcurrent alarm value',
    '充电过流保护值': 'Charging overcurrent protection value',
    '充电过流保护延时': 'Charging overcurrent protection delay',
    '充电过流保护值2': 'Charging overcurrent protection value 2',
    '充电过流保护延时2': 'Charging overcurrent protection delay 2',
    '放电过流告警值': 'Discharge overcurrent alarm value',
    '放电过流保护值': 'Discharge overcurrent protection value',
    '放电过流保护延时': 'Discharge overcurrent protection delay',
    '放电过流保护值2': 'Discharge overcurrent protection value 2',
    '放电过流保护延时2': 'Discharge overcurrent protection delay 2',
    '充电高温告警值': 'Charging high temperature alarm value',
    '充电高温保护值': 'Charging high temperature protection value',
    '充电高温恢复值': 'Charging high temperature recovery value',
    '充电低温告警值': 'Low temperature charging alarm value',
    '充电低温保护值': 'Low temperature protection value for charging',
    '充电低温恢复值': 'Low temperature recovery value during charging',
    '放电高温告警值': 'Discharge high temperature alarm value',
    '放电高温保护值': 'High temperature protection value for discharge',
    '放电高温恢复值': 'High temperature recovery value of discharge',
    '放电低温告警值': 'Low temperature discharge alarm value',
    '放电低温保护值': 'Low temperature protection value for discharge',
    '放电低温恢复值': 'Low temperature recovery value of discharge',
    '环境高温告警值': 'Environmental high temperature alarm value',
    '环境高温保护值': 'Environmental high temperature protection value',
    '环境高温恢复值': 'Environmental high temperature recovery value',
    '环境低温告警值': 'Environmental low temperature alarm value',
    '环境低温保护值': 'Environmental low-temperature protection value',
    '环境低温恢复值': 'Low temperature recovery value of the environment',
    'MOS高温告警值': 'MOS high temperature alarm value',
    'MOS高温保护值': 'MOS high temperature protection value',
    'MOS高温保护恢复值': 'MOS high temperature protection recovery value',
    '休眠单体电压': 'Sleep cell voltage',
    '休眠延时时间': 'Sleep delay time',
    '弱电开关': 'Weak current switch',
    '蜂鸣器': 'Buzzer',
    '限流': 'current-limiting',
    'LED告警': 'LED alarm',
    '上电BCU编码': 'Power on BCU code',
    '上电BMU编码': 'Power on BMU code',
    '上电绝缘检测': 'Power on insulation testing',
    '上电并机控制': 'Power on parallel control',
    '绝缘检测使能': 'Insulation detection enable',
    '单体高压': 'Single high pressure',
    '单体低压': 'Individual low pressure',
    '总体高压': 'Overall high pressure',
    '总体低压': 'Overall low pressure',
    '充电过流': 'Charging overcurrent',
    '放电过流': 'Discharge overcurrent',
    '充电高温': 'Charging at high temperature',
    '放电高温': 'High temperature discharge',
    '充电低温': 'Charging at low temperature',
    '放电低温': 'Low temperature discharge',
    '环境高温': 'High temperature environment',
    '环境低温': 'Low temperature environment',
    '充电继电器高温': 'Charging relay high temperature',
    '放电继电器高温': 'High temperature discharge relay',
    '负极继电器高温': 'Negative relay high temperature',
    'SOC高': 'SOC high',
    'SOC低': 'SOC low',
    '正极绝缘漏电': 'Positive electrode insulation leakage',
    '负极绝缘漏电': 'Negative insulation leakage',
    '充电压差': 'Charging voltage difference',
    '放电压差': 'Discharge voltage difference',
    '充电温差': 'Charging temperature difference',
    '电芯温升': 'Cell temperature rise',
    '电芯采样': 'Cell sampling',
    'NTC采样异常': 'NTC sampling anomaly',
    '电流故障检测': 'Current fault detection',
    '充电继电器控制': 'Charging relay control',
    '放电继电器控制': 'Discharge relay control',
    '预充继电器控制': 'Pre charge relay control',
    '负极继电器控制': 'Negative relay control',
    '加热膜继电器控制': 'Heating film relay control',
    '充电继电器使能': 'Charging relay enable',
    '放电继电器使能': 'Enable discharge relay',
    '预充继电器使能': 'Pre charge relay enable',
    '负极继电器使能': 'Negative relay enable',
    '加热膜继电器使能': 'Heating film relay enable',
    '电芯高温': 'Cell high temperature',
    '电芯低温': 'Low temperature battery cells',
    '环境温度': 'ambient temperature',
    'MOS高温': 'MOS high temperature',
    '预留': 'reserve',
    '系统锁功能': 'System lock function',
    '放电温差': 'Discharge temperature difference',
    '端子高温': 'Terminal high temperature',
    '充电继电器粘连': 'Charging relay adhesion',
    '充电继电器失效': 'Charging relay failure',
    '放电继电器粘连': 'Discharge relay adhesion',
    '放电继电器失效': 'Discharge relay failure',
    '预充继电器粘连': 'Pre charging relay adhesion',
    '预充继电器失效': 'Pre charge relay failure',
    '负极继电器粘连': 'Negative relay adhesion',
    '负极继电器失效': 'Negative relay failure',
    '加热膜继电器粘连': 'Adhesion of heating film relay',
    '加热膜继电器失效': 'Heating film relay failure',
    '12V异常': '12V abnormal',
    '电芯故障': 'Cell malfunction',
    '预充故障': 'Pre charging fault',
    '加热膜继电器': 'Heating film relay',
    '绝缘板通信故障': 'Insulation board communication failure',
    '采样板通信故障': 'Sampling board communication failure',
    '电流分流器故障': 'Current shunt fault',
    'NTC故障': 'NTC malfunction',
    '急停': 'Emergency stop',
    '水浸': 'Water immersion',
    '烟感': 'Smoke detector',
    '总压故障': 'Total pressure malfunction',
    'AFE通讯故障': 'AFE communication malfunction',
    '霍尔故障': 'Hall fault',
    '参数配置失败': 'Parameter configuration failed',
    '高压回路故障': 'High voltage circuit malfunction',
    '继电器开关频率高故障': 'Relay switch frequency high fault',
    '充电继电器': 'charging relay',
    '放电继电器': 'Discharge relay',
    '预充继电器': 'Pre charging relay',
    '负极继电器': 'Negative relay',
    '加热膜': 'Heating film',
    '使用Pack供电': 'Use Pack Power Supply',
    '充电器反接': 'Reverse connection of charger',
    '充电器接入': 'Charger connection',
    '关机状态': 'Shutdown status',
    '强充指示': 'Strong charging instruction',
    '预充失败': 'Pre charging failed',
    '固件更新成功标志': 'Successful firmware update flag',
    '并机开始标志': 'Parallel start sign',
    '并机结束标志': 'End of Parallel Operation Flag',
    '并机成功标志': 'Parallel success flag',
    '并机异常标志': 'Parallel abnormal flag',
    '绝缘开始标志': 'Insulation start mark',
    '绝缘结束标志': 'Insulation end sign',
    '绝缘检查完成': 'Insulation inspection completed',
    '绝缘检查异常': 'Abnormal insulation inspection',
    '满充': 'Fully charged',
    '异常掉电': 'Abnormal power outage',
    '485对外通讯失败': '485 external communication failed',
    '单机模式': 'standalone mode',
    '并机模式': 'Parallel mode',
    '开关机状态': 'Power on/off status',
    '满充标志': 'Full Charge Flag',
    '过放标志': 'Over release sign',
    'PCS禁充': 'PCS charging prohibited',
    'PCS禁放': 'PCS prohibition',
    '模拟数据测试模式': 'Simulated data testing mode',
    '继电器并入禁止': 'Relay integration prohibited',
    '主回路维护模式': 'Main circuit maintenance mode',
    '继电器开关频率高告警': 'Relay switch frequency high alarm',
    '允许并入': 'Allow integration',
    '请求并入': 'Request to merge',
    '补电模式': 'Recharge mode',
    '总电压': 'total voltage',
    '负载电压': 'load voltage',
    'SOH': 'SOH',
    'SOC': 'SOC',
    '最大SOC': 'Maximum SOC',
    '最小SOC': 'Minimum SOC',
    'SOC差值': 'SOC difference',
    '最大SOC BCU地址': 'Maximum SOC BCU Address',
    '最小SOC BCU地址': 'Minimum SOC BCU Address',
    '电流': 'electric current',
    '最大电流': 'Maximum current',
    '最小电流': 'Minimum current',
    '平均电流': 'average current',
    '最大电流BCU地址': 'Maximum current BCU address',
    '最小电流BCU地址': 'Minimum current BCU address',
    '单体电压最大值': 'Maximum individual voltage',
    '最大单体电压BCU地址': 'Maximum cell voltage BCU address',
    '最大单体电压BMU地址': 'Maximum individual voltage BMU address',
    '最大单体电压在BMU中的地址(Cell)': 'Address of maximum cell voltage in BMU (Cell)',
    '单体电压最小值': 'Minimum value of individual voltage',
    '最小单体电压BCU地址': 'Minimum cell voltage BCU address',
    '最小单体电压BMU地址': 'Minimum cell voltage BMU address',
    '最小单体电压在BMU中的地址(Cell)': 'Address of minimum cell voltage in BMU (Cell)',
    '单体最大压差': 'Maximum pressure difference per unit',
    '电池温度最大值': 'Maximum battery temperature',
    '电池温度最大值BCU地址': 'Maximum Battery Temperature BCU Address',
    '电池温度最大值BMU地址': 'Maximum Battery Temperature BMU Address',
    '电池温度最大值在BMU中的地址(Cell)': 'Address of maximum battery temperature in BMU (Cell)',
    '单体最大温差': 'Maximum temperature difference per unit',
    'BMU最大电压值': 'BMU maximum voltage value',
    'BMU最小电压值': 'BMU minimum voltage value',
    'BMU最大电压BCU地址': 'BMU maximum voltage BCU address',
    'BMU最大电压地址': 'BMU maximum voltage address',
    'BMU最小电压BCU地址': 'BMU minimum voltage BCU address',
    'BMU最小电压地址': 'BMU minimum voltage address',
    '总体电压最大值': 'Maximum overall voltage',
    '总体电压最大值BCU地址': 'Overall maximum voltage BCU address',
    '总体电压最小值': 'Minimum overall voltage value',
    '总体电压最小值BCU地址': 'Minimum overall voltage BCU address',
    '总体最大压差': 'Overall maximum pressure difference',
    '在线BCU个数': 'Number of online BCUs',
    '循环次数': 'Number of cycles',
    '历史充电容量': 'Historical charging capacity',
    '历史放电容量': 'Historical discharge capacity',
    'BCU地址编号(0-254)': 'BCU Address Number (0-254)',
    '系统状态': 'system state',
    '电池状态': 'battery status',
    '电池温度最小值': 'Minimum battery temperature',
    '电池温度最小值BCU地址': 'Minimum Battery Temperature BCU Address',
    '电池温度最小值BMU地址': 'Minimum Battery Temperature BMU Address',
    '电池温度最小值在BMU中的地址(Cell)': 'Address of minimum battery temperature in BMU (Cell)',
    '总体电压最大值BMU地址': 'Maximum overall voltage BMU address',
    '总体电压最小值BMU地址': 'Minimum overall voltage BMU address',
    '在线BMU个数': 'Number of online BMUs',
    '单体过压保护': 'Single unit overvoltage protection',
    '单体过放保护': 'Single unit over discharge protection',
    '总压过压保护': 'Total pressure overvoltage protection',
    '总压过放保护': 'Total pressure over discharge protection',
    '充电过流保护': 'Charging overcurrent protection',
    '放电过流保护': 'Discharge overcurrent protection',
    '短路': 'short circuit',
    '充电器高压': 'Charger high voltage',
    '充电高温保护（电芯）': 'Charging high temperature protection (battery cell)',
    '放电高温保护（电芯）': 'High temperature discharge protection (battery cell)',
    '充电低温保护（电芯）': 'Low temperature protection for charging (battery cell)',
    '放电低温保护（电芯）': 'Low temperature protection for discharge (battery cell)',
    'MOS高温保护': 'MOS high temperature protection',
    '环境高温保护': 'Environmental high temperature protection',
    '环境低温保护': 'Environmental low-temperature protection',
    'Fully（充满）': 'Fully (Full)',
    '充电MOS故障': 'Charging MOS fault',
    '放电MOS故障': 'Discharge MOS fault',
    '温度传感器故障': 'Temperature sensor malfunction',
    '通讯故障': 'Communication Failure',
    '采样芯片故障': 'Sampling chip malfunction',
    '限流故障': 'Current limiting fault',
    '总压过压': 'Total pressure overvoltage',
    '温差': 'Temperature difference',
    '检流电阻': 'Current sensing resistor',
    '脱扣器状态': 'Release status',
    '脱扣器': 'Release',
    '主从机掉线状态': 'Master-slave disconnection status',
    '12V故障': '12V fault',
    '指示':'indication',
    '限流指示': 'Current limiting indication',
    '充电指示': 'charge indicator',
    '放电指示': 'Discharge indication',
    '使用Pack供电指示': 'Use Pack power indicator',
    '充电器反接指示': 'Charger reverse connection indicator',
    'ACin': 'ACin',
    '关机': 'Shutdown',
    '加热膜指示': 'Heating film indicator',
    'PACK地址编号(0-254)': 'PACK Address Number (0-254)',
    '总电压(单体汇总)': 'Total voltage (individual summary)',
    '最大单体电压PACK地址': 'Maximum individual voltage PACK address',
    '最大单体电压在PACK中的地址(Cell)': 'Address of maximum cell voltage in PACK (Cell)',
    '最小单体电压PACK地址': 'Minimum Unit Voltage PACK Address',
    '最小单体电压在PACK中的地址(Cell)': 'Address of minimum cell voltage in PACK (Cell)',
    '电池温度最大值Pack地址': 'Maximum Battery Temperature Pack Address',
    '电池温度最大值在Pack中的地址(Cell)': 'The address of the maximum battery temperature in the Pack (Cell)',
    '电池温度最小值Pack地址': 'Minimum Battery Temperature Pack Address',
    '电池温度最小值在Pack中的地址(Cell)': 'The address of the minimum battery temperature in the Pack (Cell)',
    '总体电压最大值Pack地址': 'Maximum overall voltage Pack address',
    '总体电压最小值Pack地址': 'Minimum Overall Voltage Pack Address',
    '在线Pack个数': 'Number of online packs',
    '蓝牙连接': 'Bluetooth connectivity',
    'WiFi后台连接': 'WiFi backend connection',
    '限流关闭(硬件过压保护)': 'Current limiting shutdown (hardware overvoltage protection)',
    '电池包锁定': 'Battery pack locking',
    'MCU过压': 'MCU overvoltage',
    '单体过压告警': 'Single unit overvoltage alarm',
    '充电高温告警': 'Charging high temperature alarm',
    '单体低压告警': 'Single low voltage alarm',
    '总压过压告警': 'Total pressure overvoltage alarm',
    '总压低压告警': 'Total pressure low pressure alarm',
    '充电过流告警': 'Charging overcurrent alarm',
    '放电过流告警': 'Discharge overcurrent alarm',
    '放电高温告警': 'Discharge high temperature alarm',
    '充电低温告警': 'Charging low temperature alarm',
    '放电低温告警': 'Low temperature discharge alarm',
    '环境高温告警': 'Environmental high temperature alarm',
    '环境低温告警': 'Environmental low temperature alarm',
    'MOS高温告警': 'MOS high temperature alarm',
    '低电量告警': 'Low battery warning',
    '总电压2(独立汇总)': 'Total voltage 2 (independently summarized)',
    '电流2（独立电流）': 'Current 2 (independent current)',
    '屏蔽告警': 'Block alarms',
    '限流屏蔽': 'Current limiting shielding',
    '限流挡位': 'Current limiting gear',
    '蜂鸣器告警功能': 'Buzzer alarm function',
    '均衡状态': 'Equilibrium state',
    '累计充电容量': 'Accumulated charging capacity',
    '累计放电容量': 'Accumulated discharge capacity',
    '总体高压1_保护值': 'Overall high voltage protection value',
    '总体高压1_保护延时': 'Overall high voltage protection delay',
    '总体高压1_保护恢复值': 'Overall high voltage 1_protection recovery value',
    '总体高压1_保护恢复延时': 'Overall high voltage 1_protection recovery delay',
    '总体高压2_保护值': 'Overall high voltage protection value',
    '总体高压2_保护延时': 'Overall high voltage protection delay',
    '总体高压2_保护恢复值': 'Overall high voltage protection recovery value',
    '总体高压2_保护恢复延时': 'Overall high voltage protection recovery delay',
    '总体高压3_保护值': 'Overall high voltage 3_ protection value',
    '总体高压3_保护延时': 'Overall high voltage 3_ protection delay',
    '总体高压3_保护恢复值': 'Overall high voltage 3_ protection recovery value',
    '总体高压3_保护恢复延时': 'Overall high voltage 3_ protection recovery delay',
    '总体低压1_保护值': 'Overall low voltage protection value',
    '总体低压1_保护延时': 'Overall low voltage protection delay',
    '总体低压1_保护恢复值': 'Overall low voltage 1_protection recovery value',
    '总体低压1_保护恢复延时': 'Overall low voltage 1_protection recovery delay',
    '总体低压2_保护值': 'Overall low voltage protection value',
    '总体低压2_保护延时': 'Overall low-voltage protection delay',
    '总体低压2_保护恢复值': 'Overall low voltage protection recovery value',
    '总体低压2_保护恢复延时': 'Overall low voltage protection recovery delay',
    '总体低压3_保护值': 'Overall low voltage 3_ protection value',
    '总体低压3_保护延时': 'Overall low voltage 3_ protection delay',
    '总体低压3_保护恢复值': 'Overall low voltage 3_ protection recovery value',
    '总体低压3_保护恢复延时': 'Overall low voltage 3_ protection recovery delay',
    '快充口高温1_保护值': 'High temperature protection value of fast charging port',
    '快充口高温1_保护延时': 'Fast charging port high temperature 1_protection delay',
    '快充口高温1_保护恢复值': 'Fast charging port high temperature 1_protection recovery value',
    '快充口高温1_保护恢复延时': 'Fast charging port high temperature 1_protection recovery delay',
    '快充口高温2_保护值': 'Fast charging port high temperature protection value',
    '快充口高温2_保护延时': 'Fast charging port high temperature 2-protection delay',
    '快充口高温2_保护恢复值': 'Fast charging port high temperature 2-protection recovery value',
    '快充口高温2_保护恢复延时': 'Fast charging port high temperature 2-protection recovery delay',
    '快充口高温3_保护值': 'Fast charging port high temperature 3_ protection value',
    '快充口高温3_保护延时': 'Fast charging port high temperature 3_ protection delay',
    '快充口高温3_保护恢复值': 'Fast charging port high temperature 3_ protection recovery value',
    '快充口高温3_保护恢复延时': 'Fast charging port high temperature 3_ protection recovery delay',
    '慢充口高温1_保护值': 'Slow charging port high-temperature protection value',
    '慢充口高温1_保护延时': 'Slow charging port high temperature 1_protection delay',
    '慢充口高温1_保护恢复值': 'Slow charging port high temperature 1_protection recovery value',
    '慢充口高温1_保护恢复延时': 'Slow charging port high temperature 1_protection recovery delay',
    '慢充口高温2_保护值': 'Slow charging port high temperature protection value',
    '慢充口高温2_保护延时': 'Slow charging port high temperature 2-protection delay',
    '慢充口高温2_保护恢复值': 'Slow charging port high temperature 2-protection recovery value',
    '慢充口高温2_保护恢复延时': 'Slow charging port high temperature 2-protection recovery delay',
    '慢充口高温3_保护值': 'Slow charging port high temperature 3_ protection value',
    '慢充口高温3_保护延时': 'Slow charging port high temperature 3_ protection delay',
    '慢充口高温3_保护恢复值': 'Slow charging port high temperature 3_ protection recovery value',
    '慢充口高温3_保护恢复延时': 'Slow charging port high temperature 3_ Protection recovery delay',
    '放电口高温1_保护值': 'High temperature protection value of discharge port',
    '放电口高温1_保护延时': 'Discharge port high temperature 1_protection delay',
    '放电口高温1_保护恢复值': 'Discharge port high temperature 1_protection recovery value',
    '放电口高温1_保护恢复延时': 'Discharge port high temperature 1_protection recovery delay',
    '放电口高温2_保护值': 'High temperature protection value for discharge port',
    '放电口高温2_保护延时': 'Discharge port high temperature 2-protection delay',
    '放电口高温2_保护恢复值': 'Discharge port high temperature protection recovery value',
    '放电口高温2_保护恢复延时': 'Discharge port high temperature 2-protection recovery delay',
    '放电口高温3_保护值': 'Discharge port high temperature 3_ protection value',
    '放电口高温3_保护延时': 'Discharge port high temperature 3_ protection delay',
    '放电口高温3_保护恢复值': 'Discharge port high temperature 3_ protection recovery value',
    '放电口高温3_保护恢复延时': 'Discharge port high temperature 3_ protection recovery delay',
    '正极端子高温1_保护值': 'Positive terminal high-temperature protection value',
    '正极端子高温1_保护延时': 'Positive terminal high temperature protection delay',
    '正极端子高温1_保护恢复值': 'Positive terminal high temperature 1_protection recovery value',
    '正极端子高温1_保护恢复延时': 'Positive terminal high temperature 1_protection recovery delay',
    '正极端子高温2_保护值': 'Positive terminal high temperature protection value',
    '正极端子高温2_保护延时': 'Positive terminal high temperature 2-protection delay',
    '正极端子高温2_保护恢复值': 'Positive terminal high temperature protection recovery value',
    '正极端子高温2_保护恢复延时': 'Positive terminal high temperature 2-protection recovery delay',
    '正极端子高温3_保护值': 'Positive terminal high temperature 3_ protection value',
    '正极端子高温3_保护延时': 'Positive terminal high temperature 3_ protection delay',
    '正极端子高温3_保护恢复值': 'Positive terminal high temperature 3_ protection recovery value',
    '正极端子高温3_保护恢复延时': 'Positive terminal high temperature 3_ protection recovery delay',
    '负极端子高温1_保护值': 'Negative terminal high temperature protection value',
    '负极端子高温1_保护延时': 'Negative terminal high temperature protection delay',
    '负极端子高温1_保护恢复值': 'Negative terminal high temperature 1_protection recovery value',
    '负极端子高温1_保护恢复延时': 'Negative terminal high temperature 1_protection recovery delay',
    '负极端子高温2_保护值': 'Negative terminal high temperature protection value',
    '负极端子高温2_保护延时': 'Negative terminal high temperature 2-protection delay',
    '负极端子高温2_保护恢复值': 'Negative terminal high temperature protection recovery value',
    '负极端子高温2_保护恢复延时': 'Negative terminal high temperature 2-protection recovery delay',
    '负极端子高温3_保护值': 'Negative terminal high temperature 3_ protection value',
    '负极端子高温3_保护延时': 'Negative terminal high temperature 3_ protection delay',
    '负极端子高温3_保护恢复值': 'Negative terminal high temperature 3_ protection recovery value',
    '负极端子高温3_保护恢复延时': 'Negative terminal high temperature 3_ protection recovery delay',
    '1级保护状态': 'Level 1 protection status',
    '2级保护状态': 'Level 2 protection status',
    '3级保护状态': 'Level 3 protection status',
    '故障状态': 'fault conditions',
    '开关控制状态': 'Switch control status',
    '开关响应状态': 'Switch response status',
    '继电器真实状态': 'Real state of relay',
    '传感器状态': 'Sensor status',
    '特殊状态': 'Special state',
    '端子温度数量': 'Terminal temperature quantity',
    '端子温度': 'Terminal temperature',
    '最大单体电压在PACK中的地址': 'Address of maximum cell voltage in PACK',
    '最小单体电压在PACK中的地址': 'Address of minimum cell voltage in PACK',
    '电芯温度最大值': 'Maximum temperature of battery cell',
    '电芯温度最小值': 'Minimum temperature of battery cell',
    '最大电芯温度PACK地址': 'Maximum cell temperature PACK address',
    '最小电芯温度PACK地址': 'Minimum cell temperature PACK address',
    '最大电芯温度在PACK中的地址': 'Address of maximum cell temperature in PACK',
    '最小电芯温度在PACK中的地址': 'Address of minimum cell temperature in PACK',
    'PACK电压最大值': 'Maximum PACK voltage',
    'PACK电压最小值': 'Minimum value of PACK voltage',
    '最大PACK电压PACK地址': 'Maximum PACK voltage PACK address',
    '最小PACK电压PACK地址': 'Minimum PACK voltage PACK address',
    '快充继电器': 'Fast charging relay',
    '慢充继电器': 'Slow charging relay',
    '快充继电器使能': 'Enable fast charging relay',
    '慢充继电器使能': 'Enable slow charging relay',
    '预充': 'Pre charge',
    '霍尔传感器': 'hall sensor',
    '快充口高温': 'Fast charging port high temperature',
    '慢充口高温': 'Slow charging port high temperature',
    '放电口高温': 'High temperature at discharge port',
    '正极端子高温保护': 'Positive terminal high temperature protection',
    '负极端子高温保护': 'Negative terminal high temperature protection',
    'Ntc采样异常1_保护延时': 'Ntc sampling anomaly 1_protection delay',
    'Ntc采样异常1_保护恢复延时': 'Ntc sampling anomaly 1_protection recovery delay',
    'Ntc采样异常2_保护延时': 'Ntc sampling anomaly 2-protection delay',
    'Ntc采样异常2_保护恢复延时': 'Ntc sampling anomaly 2-protection recovery delay',
    'Ntc采样异常3_保护延时': 'Ntc sampling exception 3_ protection delay',
    'Ntc采样异常3_保护恢复延时': 'Ntc sampling exception 3_ protection recovery delay',
    '电芯采样异常1_保护延时': 'Abnormal cell sampling 1_protection delay',
    '电芯采样异常1_保护恢复延时': 'Abnormal cell sampling 1_protection recovery delay',
    '电芯采样异常2_保护延时': 'Abnormal cell sampling 2-protection delay',
    '电芯采样异常2_保护恢复延时': 'Abnormal cell sampling 2-Protection recovery delay',
    '电芯采样异常3_保护延时': 'Abnormal cell sampling 3_ protection delay',
    '电芯采样异常3_保护恢复延时': 'Abnormal cell sampling 3_ Protection recovery delay',
    '加热膜开启温度': 'Heating film opening temperature',
    '加热膜关闭温度': 'Heating film closing temperature',
    '时区设置': 'time zone',
    '个人中心': 'Personal Center',
    '重置密码': 'reset password',
    '退出登录': 'Log Out',
    '时区': 'time zone',
    '亚洲': 'Asia',
    '北美洲': 'North America',
    '欧洲': 'Europe',
    '南美洲': 'South America',
    '非洲': 'Africa',
    '中国': 'China',
    '日本': 'Japan',
    '韩国': 'Republic of Korea',
    '印度': 'India',
    '新加坡': 'Singapore',
    '马来西亚': 'Malaysia',
    '泰国': 'Thailand',
    '越南': 'Vietnam',
    '台湾地区': 'Taiwan region',
    '香港地区': 'Hong Kong region',
    '澳门地区': 'Macau Region',
    '菲律宾': 'the Philippines',
    '阿联酋（迪拜）': 'United Arab Emirates (Dubai)',
    '美国（东部）': 'United States (Eastern)',
    '加拿大（东部）': 'Canada (Eastern)',
    '加拿大（西部）': 'Canada (Western)',
    '墨西哥': 'Mexico',
    '英国': 'britain',
    '德国': 'Germany',
    '法国': 'France',
    '意大利': 'Italy',
    '西班牙': 'Spain',
    '俄罗斯（莫斯科）': 'Russia (Moscow)',
    '荷兰': 'Netherlands',
    '瑞士': 'Switzerland',
    '澳大利亚（东部）': 'Australia (Eastern)',
    '澳大利亚（中部）': 'Australia (Central)',
    '新西兰': 'New Zealand',
    '巴西（圣保罗）': 'Brazil (Sao Paulo)',
    '阿根廷': 'Argentina',
    '南非': 'South Africa',
    '埃及': 'Egypt',
    '肯尼亚': 'Kenya',
    '时区不能为空': 'Time zone cannot be empty',
    '重置密码': 'reset password ',
    '原密码': 'Original password',
    '新密码': 'Password',
    '重复新密码': 'Repeat New Password',
    '原密码不能为空': 'The original password cannot be empty',
    '新密码不能为空': 'The new password cannot be empty',
    '重复新密码': 'Repeat New Password',
    '重复新密码不能为空': 'Duplicate new password cannot be empty',
    '导出': '“export”',
    '搜索': 'search for',
    '请输入设备ID': 'Please enter the device ID',

    '代理商管理': 'Agent Management',
    '出库管理': 'Outbound management',
    '资料下载': 'Data Download',
    detailsNew: 'deviceList'
  }
}
